export default [
  {
    id: 1,
    general: {
      name: "Franny",
      // src: "https://lh3.googleusercontent.com/tmDxtrM7y8dGsdMAZ-B598Y-GXkA_Eh0zOPhUMSKsKV71easUhB9_jlCUMMcgBgN0NlCNX6GqJR1HSnRW1_Qe3qrVgBmuMSQbsLUNw=w206",
      src: "https://public.nftstatic.com/static/nft/zipped/316b937f6ce043ca885aef2908984df9_zipped.png",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: false,
      link: "https://huffingtonpost.com/imperdiet/sapien.js?consequat=vel&nulla=augue&nisl=vestibulum&nunc=ante&nisl=ipsum&duis=primis&bibendum=in&felis=faucibus&sed=orci&interdum=luctus&venenatis=et&turpis=ultrices&enim=posuere&blandit=cubilia&mi=curae&in=donec&porttitor=pharetra&pede=magna&justo=vestibulum&eu=aliquet&massa=ultrices&donec=erat&dapibus=tortor",
    },
    contract: {
      contractAddress: "0x03dcd5802a41c65b837fd0d997536ab9dbedc9d5",
      tokenID: 4672,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Winni",
        link: "http://multiply.com/justo/in/blandit/ultrices/enim/lorem/ipsum.json?risus=fermentum&praesent=donec&lectus=ut&vestibulum=mauris&quam=eget&sapien=massa&varius=tempor&ut=convallis&blandit=nulla&non=neque&interdum=libero&in=convallis&ante=eget&vestibulum=eleifend&ante=luctus",
        avatar:
          "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
      },
      creator: {
        name: "AzukiAzukiAzukiAzukiAzukiAzukiAzukiAzukiAzuki123AzukiAzukiAzukiAzukiAzukiAzukiAzukiAzukiAzuki123",
        link: "http://accuweather.com/nibh/in/hac/habitasse/platea/dictumst/aliquam.js?phasellus=mattis&in=nibh&felis=ligula&donec=nec&semper=sem&sapien=duis&a=aliquam&libero=convallis&nam=nunc&dui=proin&proin=at&leo=turpis&odio=a&porttitor=pede&id=posuere&consequat=nonummy&in=integer&consequat=non&ut=velit&nulla=donec&sed=diam&accumsan=neque&felis=vestibulum&ut=eget&at=vulputate&dolor=ut&quis=ultrices&odio=vel&consequat=augue&varius=vestibulum&integer=ante&ac=ipsum&leo=primis&pellentesque=in&ultrices=faucibus&mattis=orci&odio=luctus&donec=et&vitae=ultrices&nisi=posuere&nam=cubilia&ultrices=curae&libero=donec&non=pharetra&mattis=magna&pulvinar=vestibulum&nulla=aliquet&pede=ultrices&ullamcorper=erat&augue=tortor&a=sollicitudin&suscipit=mi&nulla=sit&elit=amet&ac=lobortis&nulla=sapien&sed=sapien&vel=non&enim=mi&sit=integer&amet=ac&nunc=neque&viverra=duis&dapibus=bibendum&nulla=morbi&suscipit=non&ligula=quam&in=nec&lacus=dui&curabitur=luctus&at=rutrum&ipsum=nulla&ac=tellus&tellus=in&semper=sagittis&interdum=dui&mauris=vel&ullamcorper=nisl&purus=duis&sit=ac&amet=nibh&nulla=fusce",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 6,
      },
    },
    socialMedia: {
      stats: { favorites: 84433, views: 124957 },
      links: {
        website:
          "http://irs.gov/libero/rutrum/ac/lobortis/vel.jpg?morbi=quam&a=nec&ipsum=dui&integer=luctus&a=rutrum&nibh=nulla&in=tellus&quis=in&justo=sagittis&maecenas=dui&rhoncus=vel&aliquam=nisl&lacus=duis&morbi=ac&quis=nibh&tortor=fusce&id=lacus&nulla=purus&ultrices=aliquet&aliquet=at&maecenas=feugiat&leo=non&odio=pretium&condimentum=quis&id=lectus&luctus=suspendisse&nec=potenti&molestie=in&sed=eleifend&justo=quam&pellentesque=a&viverra=odio&pede=in&ac=hac&diam=habitasse&cras=platea&pellentesque=dictumst&volutpat=maecenas&dui=ut&maecenas=massa&tristique=quis&est=augue&et=luctus&tempus=tincidunt&semper=nulla&est=mollis&quam=molestie&pharetra=lorem&magna=quisque&ac=ut&consequat=erat&metus=curabitur&sapien=gravida&ut=nisi&nunc=at&vestibulum=nibh&ante=in&ipsum=hac&primis=habitasse&in=platea&faucibus=dictumst",
        discord:
          "https://bandcamp.com/vel/augue/vestibulum.json?dolor=nulla&quis=tempus&odio=vivamus&consequat=in&varius=felis&integer=eu&ac=sapien&leo=cursus&pellentesque=vestibulum&ultrices=proin&mattis=eu&odio=mi&donec=nulla&vitae=ac&nisi=enim&nam=in&ultrices=tempor&libero=turpis&non=nec&mattis=euismod&pulvinar=scelerisque&nulla=quam&pede=turpis&ullamcorper=adipiscing&augue=lorem&a=vitae&suscipit=mattis&nulla=nibh&elit=ligula&ac=nec&nulla=sem&sed=duis",
        medium:
          "https://soundcloud.com/at/diam/nam/tristique/tortor/eu/pede.jpg?vulputate=id&nonummy=sapien&maecenas=in&tincidunt=sapien&lacus=iaculis&at=congue&velit=vivamus&vivamus=metus&vel=arcu&nulla=adipiscing&eget=molestie&eros=hendrerit&elementum=at&pellentesque=vulputate&quisque=vitae&porta=nisl&volutpat=aenean&erat=lectus&quisque=pellentesque&erat=eget&eros=nunc&viverra=donec&eget=quis&congue=orci&eget=eget&semper=orci&rutrum=vehicula&nulla=condimentum&nunc=curabitur&purus=in&phasellus=libero&in=ut&felis=massa&donec=volutpat&semper=convallis&sapien=morbi&a=odio&libero=odio&nam=elementum&dui=eu&proin=interdum&leo=eu&odio=tincidunt&porttitor=in&id=leo&consequat=maecenas&in=pulvinar&consequat=lobortis&ut=est",
        telegram:
          "https://eepurl.com/primis.png?ligula=aliquam&in=sit&lacus=amet&curabitur=diam&at=in&ipsum=magna&ac=bibendum&tellus=imperdiet&semper=nullam&interdum=orci&mauris=pede&ullamcorper=venenatis&purus=non&sit=sodales&amet=sed&nulla=tincidunt&quisque=eu&arcu=felis&libero=fusce&rutrum=posuere&ac=felis&lobortis=sed&vel=lacus&dapibus=morbi&at=sem",
        instagram:
          "http://desdev.cn/cursus/vestibulum.js?nulla=nibh&tempus=in&vivamus=hac&in=habitasse&felis=platea&eu=dictumst&sapien=aliquam&cursus=augue&vestibulum=quam&proin=sollicitudin&eu=vitae&mi=consectetuer&nulla=eget&ac=rutrum&enim=at&in=lorem&tempor=integer&turpis=tincidunt&nec=ante&euismod=vel&scelerisque=ipsum&quam=praesent&turpis=blandit&adipiscing=lacinia&lorem=erat&vitae=vestibulum&mattis=sed&nibh=magna&ligula=at&nec=nunc&sem=commodo&duis=placerat",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["art"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "12/23/2021",
        listPrice: 15,
        editionSupply: 4,
        edition: 1,
        editionType: "Con Exclusive",
        season: 1,
        rarity: "Secret",
        license: "DC",
        brand: "Captain America",
        collection: "Old School",
        series: "Captain America - Old School",
        annotations: ["Zombie", "Generation"],
        description:
          "tincidunt eu felis fusce posuere felis sed lacus morbi sem mauris laoreet ut rhoncus aliquet pulvinar sed nisl",
      },
    },
    auction: null,
    price: {
      amount: 244.29,
      currency: "MATIC",
      history: [
        { amount: 224.37, currency: "SOL", date: "01/02/2022 00:00:00" },
        { amount: 480.62, currency: "ETH", date: "03/01/2022 20:20:20" },
        { amount: 749.58, currency: "MATIC", date: "07/06/2021 05:33:33" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "05/18/2022 05:33:33",
          amount: 971123.13,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "01/28/2022 00:00:00",
          amount: 63.45,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "09/08/2021 17:12:12",
          amount: 614.96,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 566.37,
          currency: "BUSD",
          expiration: "07/08/2021 10:55:55",
          from: "Winni",
        },
        {
          active: false,
          amount: 10.0,
          currency: "BUSD",
          expiration: "03/23/2022 05:33:33",
          from: "Eda",
        },
        {
          active: false,
          amount: 41.2,
          currency: "BUSD",
          expiration: "08/02/2021 20:20:20",
          from: "Kristofer",
        },
      ],
    },
    listings: [
      {
        amount: 2.16,
        currency: "ETH",
        expiration: "08/21/2021 05:33:33",
        addDate: "02/08/2022 20:20:20",
        from: "Winni",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 9.3 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "01/11/2022 20:20:20",
        transaction: "0x67a039af02a6cf9810834a54f468763aa1a99b3e",
      },
      {
        type: "Sale",
        cost: { amount: 4.57, currency: "SOL", usdEquivalent: 4.03 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "12/27/2021 23:23:23",
        transaction: "0xcaf0f85be9ff5ba211b6d021a5cb9c04c6efbeba",
      },
      {
        type: "Transfer",
        cost: { amount: 5.13, currency: "ETH", usdEquivalent: 9.36 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "03/18/2022 17:12:12",
        transaction: "0xcc769d700b0fee2c4b9e02dc682273417148551a",
      },
    ],
    more: [{ id: 1 }, { id: 1 }],
  },
  {
    id: 2,
    general: {
      name: "Molli",
      src: "https://lh3.googleusercontent.com/esQDThqSsPd2PjTYZ7dkBdjzfuE3QgZAfh-IHq5bTHLYh2H4nbqTXBGQZPLC90B9EsolTgQNXrW81qvsn6jEhBxnI-wChE2tI69PCQ=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: false,
      link: "https://blog.com/in/hac/habitasse/platea/dictumst.xml?sapien=sapien&urna=non&pretium=mi&nisl=integer&ut=ac&volutpat=neque&sapien=duis&arcu=bibendum&sed=morbi&augue=non&aliquam=quam&erat=nec&volutpat=dui&in=luctus&congue=rutrum&etiam=nulla&justo=tellus&etiam=in&pretium=sagittis&iaculis=dui&justo=vel&in=nisl&hac=duis&habitasse=ac&platea=nibh&dictumst=fusce&etiam=lacus&faucibus=purus&cursus=aliquet&urna=at&ut=feugiat&tellus=non&nulla=pretium&ut=quis&erat=lectus&id=suspendisse&mauris=potenti&vulputate=in&elementum=eleifend&nullam=quam&varius=a&nulla=odio&facilisi=in&cras=hac&non=habitasse&velit=platea&nec=dictumst&nisi=maecenas&vulputate=ut&nonummy=massa&maecenas=quis&tincidunt=augue&lacus=luctus&at=tincidunt&velit=nulla&vivamus=mollis&vel=molestie&nulla=lorem&eget=quisque&eros=ut&elementum=erat&pellentesque=curabitur&quisque=gravida&porta=nisi&volutpat=at&erat=nibh&quisque=in&erat=hac&eros=habitasse&viverra=platea&eget=dictumst&congue=aliquam&eget=augue&semper=quam&rutrum=sollicitudin&nulla=vitae&nunc=consectetuer&purus=eget&phasellus=rutrum&in=at&felis=lorem&donec=integer&semper=tincidunt&sapien=ante&a=vel&libero=ipsum&nam=praesent&dui=blandit&proin=lacinia&leo=erat&odio=vestibulum",
    },
    contract: {
      contractAddress: "0x63a8103d59b2b0f484f74f293e5e2874ad90f2e8",
      tokenID: 5217,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Eda",
        link: "https://unicef.org/eros.jsp?viverra=vel&diam=nulla&vitae=eget",
        avatar:
          "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "https://yellowbook.com/posuere/cubilia/curae.jsp?a=aenean&ipsum=sit&integer=amet&a=justo&nibh=morbi&in=ut&quis=odio&justo=cras&maecenas=mi&rhoncus=pede&aliquam=malesuada&lacus=in&morbi=imperdiet&quis=et&tortor=commodo&id=vulputate&nulla=justo&ultrices=in&aliquet=blandit&maecenas=ultrices&leo=enim&odio=lorem&condimentum=ipsum&id=dolor&luctus=sit&nec=amet&molestie=consectetuer&sed=adipiscing&justo=elit&pellentesque=proin&viverra=interdum&pede=mauris&ac=non&diam=ligula&cras=pellentesque&pellentesque=ultrices&volutpat=phasellus&dui=id&maecenas=sapien&tristique=in&est=sapien&et=iaculis&tempus=congue&semper=vivamus&est=metus&quam=arcu&pharetra=adipiscing&magna=molestie&ac=hendrerit&consequat=at&metus=vulputate&sapien=vitae&ut=nisl&nunc=aenean&vestibulum=lectus&ante=pellentesque&ipsum=eget&primis=nunc&in=donec&faucibus=quis&orci=orci&luctus=eget&et=orci&ultrices=vehicula&posuere=condimentum&cubilia=curabitur&curae=in&mauris=libero&viverra=ut&diam=massa&vitae=volutpat&quam=convallis&suspendisse=morbi&potenti=odio&nullam=odio&porttitor=elementum&lacus=eu&at=interdum&turpis=eu&donec=tincidunt&posuere=in&metus=leo&vitae=maecenas&ipsum=pulvinar&aliquam=lobortis&non=est&mauris=phasellus&morbi=sit",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 11,
      },
    },
    socialMedia: {
      stats: { favorites: 157078, views: 898082 },
      links: {
        website:
          "https://ca.gov/eget/tempus/vel/pede/morbi/porttitor/lorem.json?diam=ultrices&in=aliquet&magna=maecenas&bibendum=leo&imperdiet=odio&nullam=condimentum&orci=id&pede=luctus&venenatis=nec&non=molestie&sodales=sed&sed=justo&tincidunt=pellentesque&eu=viverra&felis=pede&fusce=ac&posuere=diam&felis=cras&sed=pellentesque&lacus=volutpat&morbi=dui&sem=maecenas&mauris=tristique&laoreet=est&ut=et&rhoncus=tempus&aliquet=semper&pulvinar=est&sed=quam&nisl=pharetra&nunc=magna&rhoncus=ac&dui=consequat&vel=metus&sem=sapien&sed=ut&sagittis=nunc&nam=vestibulum&congue=ante&risus=ipsum&semper=primis&porta=in&volutpat=faucibus&quam=orci&pede=luctus&lobortis=et&ligula=ultrices&sit=posuere&amet=cubilia&eleifend=curae&pede=mauris&libero=viverra&quis=diam&orci=vitae",
        discord:
          "https://surveymonkey.com/venenatis/lacinia.js?quam=vestibulum&nec=sagittis&dui=sapien&luctus=cum&rutrum=sociis&nulla=natoque&tellus=penatibus&in=et&sagittis=magnis&dui=dis&vel=parturient&nisl=montes&duis=nascetur&ac=ridiculus&nibh=mus&fusce=etiam&lacus=vel&purus=augue&aliquet=vestibulum&at=rutrum&feugiat=rutrum&non=neque&pretium=aenean&quis=auctor&lectus=gravida&suspendisse=sem&potenti=praesent&in=id&eleifend=massa&quam=id&a=nisl&odio=venenatis&in=lacinia&hac=aenean",
        medium:
          "http://studiopress.com/morbi/ut/odio.html?sed=in&vel=sapien&enim=iaculis&sit=congue&amet=vivamus&nunc=metus&viverra=arcu&dapibus=adipiscing&nulla=molestie&suscipit=hendrerit&ligula=at&in=vulputate&lacus=vitae&curabitur=nisl&at=aenean&ipsum=lectus&ac=pellentesque&tellus=eget&semper=nunc&interdum=donec&mauris=quis&ullamcorper=orci&purus=eget&sit=orci&amet=vehicula&nulla=condimentum&quisque=curabitur&arcu=in&libero=libero&rutrum=ut",
        telegram:
          "https://apple.com/duis/bibendum/felis/sed/interdum/venenatis/turpis.aspx?leo=est&rhoncus=phasellus&sed=sit&vestibulum=amet&sit=erat&amet=nulla&cursus=tempus&id=vivamus&turpis=in&integer=felis&aliquet=eu&massa=sapien&id=cursus&lobortis=vestibulum&convallis=proin&tortor=eu&risus=mi&dapibus=nulla&augue=ac&vel=enim&accumsan=in&tellus=tempor&nisi=turpis&eu=nec&orci=euismod&mauris=scelerisque&lacinia=quam&sapien=turpis&quis=adipiscing&libero=lorem&nullam=vitae&sit=mattis&amet=nibh&turpis=ligula&elementum=nec&ligula=sem&vehicula=duis&consequat=aliquam&morbi=convallis&a=nunc&ipsum=proin&integer=at&a=turpis&nibh=a&in=pede&quis=posuere&justo=nonummy&maecenas=integer&rhoncus=non&aliquam=velit&lacus=donec&morbi=diam&quis=neque&tortor=vestibulum&id=eget&nulla=vulputate&ultrices=ut&aliquet=ultrices&maecenas=vel&leo=augue&odio=vestibulum&condimentum=ante&id=ipsum&luctus=primis&nec=in&molestie=faucibus&sed=orci&justo=luctus&pellentesque=et&viverra=ultrices&pede=posuere&ac=cubilia&diam=curae&cras=donec&pellentesque=pharetra&volutpat=magna&dui=vestibulum&maecenas=aliquet&tristique=ultrices&est=erat&et=tortor&tempus=sollicitudin&semper=mi&est=sit&quam=amet&pharetra=lobortis&magna=sapien&ac=sapien&consequat=non&metus=mi&sapien=integer&ut=ac&nunc=neque&vestibulum=duis&ante=bibendum&ipsum=morbi&primis=non",
        instagram:
          "http://fda.gov/etiam/vel/augue/vestibulum/rutrum.aspx?nulla=porttitor&ultrices=id&aliquet=consequat&maecenas=in&leo=consequat&odio=ut&condimentum=nulla&id=sed&luctus=accumsan&nec=felis&molestie=ut&sed=at&justo=dolor&pellentesque=quis&viverra=odio",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["art"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "1/14/2022",
        listPrice: 6,
        editionSupply: 9,
        edition: 1,
        editionType: "Unique",
        season: 2,
        rarity: "Secret",
        license: "Marvel",
        brand: "The Flash",
        collection: "Next Generation",
        series: "The Flash - Next Generation",
        annotations: [],
        description:
          "ac enim in tempor turpis nec euismod scelerisque quam turpis adipiscing lorem vitae mattis nibh ligula",
      },
    },
    auction: "12-Jul-2021 10:55:55",
    price: {
      amount: 308.64,
      currency: "SOL",
      history: [
        { amount: 417.61, currency: "ETH", date: "09/02/2021 05:33:33" },
        { amount: 450.34, currency: "SOL", date: "05/07/2021 20:20:20" },
        { amount: 453.47, currency: "MATIC", date: "11/04/2021 05:33:33" },
        { amount: 822.58, currency: "SOL", date: "11/15/2021 05:33:33" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "11/01/2023 10:55:55",
          amount: 664.39,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "08/18/2021 17:12:12",
          amount: 650.8,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 514.4,
          currency: "BUSD",
          expiration: "04/28/2021 05:33:33",
          from: "Raymund",
        },
        {
          active: false,
          amount: 870.68,
          currency: "BUSD",
          expiration: "11/28/2021 10:55:55",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 646.57,
          currency: "BUSD",
          expiration: "12/27/2021 17:12:12",
          from: "Winni",
        },
        {
          active: false,
          amount: 997.58,
          currency: "BUSD",
          expiration: "11/20/2021 17:12:12",
          from: "Eda",
        },
        {
          active: false,
          amount: 360.39,
          currency: "BUSD",
          expiration: "04/14/2021 17:12:12",
          from: "Kristofer",
        },
      ],
    },
    listings: [
      {
        amount: 5.04,
        currency: "MATIC",
        expiration: "11/19/2021 17:12:12",
        addDate: "09/27/2021 17:12:12",
        from: "Eda",
      },
      {
        amount: 5.03,
        currency: "SOL",
        expiration: "07/30/2021 00:00:00",
        addDate: "09/21/2021 00:00:00",
        from: "Kristofer",
      },
      {
        amount: 7.73,
        currency: "ETH",
        expiration: "03/27/2022 20:20:20",
        addDate: "08/31/2021 05:33:33",
        from: "Raymund",
      },
      {
        amount: 8.11,
        currency: "SOL",
        expiration: "04/07/2021 05:33:33",
        addDate: "03/11/2022 10:55:55",
        from: "Nickolas",
      },
      {
        amount: 3.42,
        currency: "MATIC",
        expiration: "06/07/2021 20:20:20",
        addDate: "10/23/2021 00:00:00",
        from: "Winni",
      },
    ],
    itemHistory: [],
    more: [],
  },
  {
    id: 3,
    general: {
      name: "HailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHailyHaily",
      src: "https://lh3.googleusercontent.com/nYH0MhgV94bzuhPsC4S0ZO83DtA1551pnvD3ezWOpLExxz7Je7BbVP2k9hXYvC1ypMBkQbdMMUgQ-RbeEXayybeuqv7-MPyHY4La1RU=w206",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: true,
      link: "http://time.com/nonummy/integer/non/velit/donec/diam/neque.png?eros=morbi&vestibulum=non&ac=quam&est=nec&lacinia=dui&nisi=luctus&venenatis=rutrum&tristique=nulla&fusce=tellus&congue=in&diam=sagittis&id=dui",
    },
    contract: {
      contractAddress: "0x95d9a14f87fd25b98b675d24d26a593b679f9ba1",
      tokenID: 7797,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Kristofer",
        link: "https://odnoklassniki.ru/sollicitudin/vitae/consectetuer/eget/rutrum/at/lorem.html?rhoncus=augue&aliquam=luctus&lacus=tincidunt&morbi=nulla&quis=mollis&tortor=molestie&id=lorem&nulla=quisque&ultrices=ut&aliquet=erat&maecenas=curabitur&leo=gravida&odio=nisi&condimentum=at&id=nibh&luctus=in&nec=hac&molestie=habitasse&sed=platea&justo=dictumst&pellentesque=aliquam&viverra=augue&pede=quam&ac=sollicitudin&diam=vitae&cras=consectetuer&pellentesque=eget",
        avatar:
          "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "https://nytimes.com/vestibulum.jsp?sodales=blandit&sed=ultrices&tincidunt=enim&eu=lorem&felis=ipsum&fusce=dolor&posuere=sit&felis=amet&sed=consectetuer&lacus=adipiscing&morbi=elit&sem=proin&mauris=interdum&laoreet=mauris&ut=non&rhoncus=ligula&aliquet=pellentesque&pulvinar=ultrices&sed=phasellus&nisl=id&nunc=sapien&rhoncus=in&dui=sapien&vel=iaculis&sem=congue&sed=vivamus&sagittis=metus&nam=arcu&congue=adipiscing&risus=molestie&semper=hendrerit&porta=at&volutpat=vulputate&quam=vitae&pede=nisl&lobortis=aenean&ligula=lectus&sit=pellentesque&amet=eget&eleifend=nunc&pede=donec&libero=quis&quis=orci&orci=eget&nullam=orci&molestie=vehicula&nibh=condimentum&in=curabitur&lectus=in&pellentesque=libero&at=ut&nulla=massa&suspendisse=volutpat&potenti=convallis&cras=morbi&in=odio&purus=odio&eu=elementum",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 85,
      },
    },
    socialMedia: {
      stats: { favorites: 681154, views: 782240 },
      links: {
        website:
          "https://youtube.com/proin/risus/praesent/lectus/vestibulum.jpg?lacinia=iaculis&sapien=justo&quis=in&libero=hac&nullam=habitasse&sit=platea&amet=dictumst&turpis=etiam&elementum=faucibus&ligula=cursus&vehicula=urna&consequat=ut&morbi=tellus&a=nulla&ipsum=ut&integer=erat&a=id&nibh=mauris&in=vulputate&quis=elementum&justo=nullam&maecenas=varius&rhoncus=nulla&aliquam=facilisi&lacus=cras&morbi=non&quis=velit&tortor=nec&id=nisi&nulla=vulputate&ultrices=nonummy&aliquet=maecenas&maecenas=tincidunt&leo=lacus&odio=at&condimentum=velit&id=vivamus&luctus=vel&nec=nulla&molestie=eget&sed=eros&justo=elementum&pellentesque=pellentesque&viverra=quisque&pede=porta&ac=volutpat&diam=erat&cras=quisque&pellentesque=erat&volutpat=eros&dui=viverra&maecenas=eget&tristique=congue&est=eget&et=semper&tempus=rutrum",
        discord:
          "https://php.net/quam/fringilla/rhoncus/mauris/enim/leo.html?placerat=vel&ante=augue&nulla=vestibulum&justo=ante&aliquam=ipsum&quis=primis&turpis=in&eget=faucibus&elit=orci&sodales=luctus&scelerisque=et&mauris=ultrices&sit=posuere&amet=cubilia&eros=curae&suspendisse=donec&accumsan=pharetra&tortor=magna&quis=vestibulum&turpis=aliquet&sed=ultrices&ante=erat&vivamus=tortor&tortor=sollicitudin&duis=mi&mattis=sit",
        medium:
          "https://elegantthemes.com/duis/faucibus/accumsan/odio/curabitur.js?nec=lacus&nisi=morbi&volutpat=quis&eleifend=tortor&donec=id&ut=nulla&dolor=ultrices&morbi=aliquet&vel=maecenas&lectus=leo&in=odio&quam=condimentum&fringilla=id&rhoncus=luctus&mauris=nec&enim=molestie&leo=sed&rhoncus=justo&sed=pellentesque&vestibulum=viverra&sit=pede&amet=ac&cursus=diam&id=cras&turpis=pellentesque&integer=volutpat&aliquet=dui&massa=maecenas&id=tristique&lobortis=est&convallis=et&tortor=tempus&risus=semper&dapibus=est&augue=quam&vel=pharetra&accumsan=magna&tellus=ac&nisi=consequat&eu=metus&orci=sapien&mauris=ut&lacinia=nunc&sapien=vestibulum",
        telegram:
          "https://webs.com/interdum/mauris/non.png?pulvinar=sem&sed=mauris&nisl=laoreet&nunc=ut&rhoncus=rhoncus&dui=aliquet&vel=pulvinar&sem=sed&sed=nisl&sagittis=nunc&nam=rhoncus&congue=dui&risus=vel&semper=sem&porta=sed&volutpat=sagittis&quam=nam&pede=congue&lobortis=risus&ligula=semper&sit=porta&amet=volutpat&eleifend=quam&pede=pede&libero=lobortis&quis=ligula&orci=sit&nullam=amet&molestie=eleifend&nibh=pede&in=libero&lectus=quis&pellentesque=orci&at=nullam&nulla=molestie&suspendisse=nibh&potenti=in&cras=lectus&in=pellentesque&purus=at&eu=nulla&magna=suspendisse&vulputate=potenti&luctus=cras&cum=in&sociis=purus&natoque=eu&penatibus=magna&et=vulputate&magnis=luctus&dis=cum&parturient=sociis&montes=natoque&nascetur=penatibus&ridiculus=et&mus=magnis&vivamus=dis&vestibulum=parturient&sagittis=montes&sapien=nascetur&cum=ridiculus&sociis=mus&natoque=vivamus&penatibus=vestibulum&et=sagittis&magnis=sapien&dis=cum&parturient=sociis&montes=natoque&nascetur=penatibus&ridiculus=et&mus=magnis&etiam=dis&vel=parturient&augue=montes&vestibulum=nascetur&rutrum=ridiculus&rutrum=mus&neque=etiam&aenean=vel&auctor=augue&gravida=vestibulum&sem=rutrum",
        instagram:
          "https://plala.or.jp/mi/sit/amet/lobortis/sapien/sapien.jpg?quis=felis&orci=sed&nullam=interdum&molestie=venenatis&nibh=turpis&in=enim&lectus=blandit&pellentesque=mi&at=in&nulla=porttitor&suspendisse=pede&potenti=justo&cras=eu&in=massa&purus=donec&eu=dapibus&magna=duis&vulputate=at&luctus=velit&cum=eu&sociis=est&natoque=congue",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["art"],
      properties: { accessory: ["Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "7/26/2021",
        listPrice: 29,
        editionSupply: 9,
        edition: 4,
        editionType: "Common",
        season: 3,
        rarity: "One of a kind",
        license: "Disney",
        brand: "The Flash",
        collection: "Purple",
        series: "The Flash - Purple",
        annotations: ["Generation", "Purple", "Zombie"],
        description:
          "in magna bibendum imperdiet nullam orci pede venenatis non sodales sed tincidunt eu felis fusce posuere felis sed",
      },
    },
    auction: null,
    price: {
      amount: 257.14,
      currency: "ETH",
      history: [
        { amount: 663.11, currency: "ETH", date: "08/25/2021 00:00:00" },
        { amount: 340.63, currency: "MATIC", date: "02/24/2022 23:23:23" },
        { amount: 355.33, currency: "MATIC", date: "09/18/2021 10:55:55" },
        { amount: 371.61, currency: "SOL", date: "03/22/2022 00:00:00" },
        { amount: 553.77, currency: "ETH", date: "04/08/2021 00:00:00" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "05/03/2021 20:20:20",
          amount: 394.17,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "03/19/2022 23:23:23",
          amount: 448.61,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "06/01/2021 17:12:12",
          amount: 932.5,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 898.78,
          currency: "BUSD",
          expiration: "04/03/2022 17:12:12",
          from: "Raymund",
        },
        {
          active: false,
          amount: 78.26,
          currency: "BUSD",
          expiration: "05/21/2021 05:33:33",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 798.01,
          currency: "BUSD",
          expiration: "09/02/2021 20:20:20",
          from: "Winni",
        },
        {
          active: false,
          amount: 353.27,
          currency: "BUSD",
          expiration: "12/21/2021 10:55:55",
          from: "Eda",
        },
        {
          active: false,
          amount: 3.63,
          currency: "BUSD",
          expiration: "11/28/2021 10:55:55",
          from: "Kristofer",
        },
      ],
    },
    listings: [
      {
        amount: 3.55,
        currency: "ETH",
        expiration: "12/31/2021 05:33:33",
        addDate: "06/13/2021 10:55:55",
        from: "Eda",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "ETH", usdEquivalent: 9.37 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "04/21/2021 00:00:00",
        transaction: "0x5015be54d2d38a60204ea4e17e8117d2ba9e422c",
      },
    ],
    more: [{ id: 2 }, { id: 2 }],
  },
  {
    id: 4,
    general: {
      name: "Joli",
      src: "https://lh3.googleusercontent.com/5-Nx0qj4MYyHG2-l9p_4U27ly5qddKsaV69Qs295VsXUvgKj0FYmtKq_TFv-ASFa-R9K-q8YnIs6ZSNE04EQvyDe5oIPwz8OUEDzhQ=w206",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: false,
      link: "http://va.gov/convallis/duis/consequat/dui/nec/nisi.aspx?sed=integer&ante=tincidunt&vivamus=ante&tortor=vel&duis=ipsum&mattis=praesent&egestas=blandit&metus=lacinia&aenean=erat&fermentum=vestibulum&donec=sed&ut=magna&mauris=at&eget=nunc&massa=commodo&tempor=placerat&convallis=praesent&nulla=blandit&neque=nam&libero=nulla&convallis=integer&eget=pede&eleifend=justo&luctus=lacinia&ultricies=eget&eu=tincidunt&nibh=eget&quisque=tempus&id=vel&justo=pede&sit=morbi&amet=porttitor&sapien=lorem&dignissim=id&vestibulum=ligula&vestibulum=suspendisse&ante=ornare&ipsum=consequat&primis=lectus&in=in&faucibus=est&orci=risus&luctus=auctor&et=sed&ultrices=tristique&posuere=in&cubilia=tempus&curae=sit&nulla=amet&dapibus=sem&dolor=fusce&vel=consequat&est=nulla&donec=nisl&odio=nunc&justo=nisl&sollicitudin=duis&ut=bibendum&suscipit=felis&a=sed&feugiat=interdum&et=venenatis&eros=turpis&vestibulum=enim&ac=blandit&est=mi&lacinia=in&nisi=porttitor&venenatis=pede&tristique=justo&fusce=eu&congue=massa&diam=donec&id=dapibus&ornare=duis&imperdiet=at&sapien=velit&urna=eu&pretium=est&nisl=congue&ut=elementum&volutpat=in&sapien=hac&arcu=habitasse",
    },
    contract: {
      contractAddress: "0x255c2b8d45a8dccdc2cae83831bde449bde82615",
      tokenID: 2091,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Raymund",
        link: "https://cpanel.net/magnis/dis/parturient.jpg?nulla=ultrices&ut=posuere&erat=cubilia&id=curae&mauris=duis&vulputate=faucibus&elementum=accumsan&nullam=odio&varius=curabitur&nulla=convallis&facilisi=duis&cras=consequat&non=dui&velit=nec&nec=nisi&nisi=volutpat&vulputate=eleifend&nonummy=donec&maecenas=ut&tincidunt=dolor&lacus=morbi&at=vel&velit=lectus&vivamus=in&vel=quam&nulla=fringilla&eget=rhoncus&eros=mauris&elementum=enim&pellentesque=leo&quisque=rhoncus&porta=sed&volutpat=vestibulum&erat=sit&quisque=amet&erat=cursus&eros=id&viverra=turpis&eget=integer&congue=aliquet&eget=massa&semper=id&rutrum=lobortis&nulla=convallis&nunc=tortor&purus=risus&phasellus=dapibus&in=augue&felis=vel&donec=accumsan&semper=tellus&sapien=nisi&a=eu&libero=orci&nam=mauris&dui=lacinia&proin=sapien&leo=quis&odio=libero&porttitor=nullam&id=sit",
        avatar:
          "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
      },
      creator: {
        name: "Azuki",
        link: "https://weibo.com/ut.jsp?non=sollicitudin&ligula=mi&pellentesque=sit&ultrices=amet&phasellus=lobortis&id=sapien&sapien=sapien&in=non&sapien=mi&iaculis=integer&congue=ac&vivamus=neque&metus=duis&arcu=bibendum&adipiscing=morbi&molestie=non&hendrerit=quam&at=nec&vulputate=dui&vitae=luctus&nisl=rutrum&aenean=nulla&lectus=tellus&pellentesque=in&eget=sagittis&nunc=dui&donec=vel&quis=nisl&orci=duis&eget=ac&orci=nibh&vehicula=fusce&condimentum=lacus&curabitur=purus&in=aliquet&libero=at&ut=feugiat&massa=non&volutpat=pretium&convallis=quis&morbi=lectus&odio=suspendisse&odio=potenti&elementum=in&eu=eleifend&interdum=quam&eu=a&tincidunt=odio&in=in&leo=hac&maecenas=habitasse&pulvinar=platea&lobortis=dictumst&est=maecenas&phasellus=ut&sit=massa&amet=quis&erat=augue&nulla=luctus&tempus=tincidunt&vivamus=nulla&in=mollis&felis=molestie&eu=lorem&sapien=quisque&cursus=ut&vestibulum=erat&proin=curabitur&eu=gravida&mi=nisi&nulla=at&ac=nibh",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 97,
      },
    },
    socialMedia: {
      stats: { favorites: 965115, views: 176867 },
      links: {
        website:
          "http://techcrunch.com/augue/quam/sollicitudin/vitae.xml?vivamus=mattis&metus=egestas&arcu=metus&adipiscing=aenean&molestie=fermentum&hendrerit=donec&at=ut&vulputate=mauris&vitae=eget&nisl=massa&aenean=tempor&lectus=convallis&pellentesque=nulla&eget=neque&nunc=libero&donec=convallis&quis=eget&orci=eleifend&eget=luctus&orci=ultricies&vehicula=eu&condimentum=nibh&curabitur=quisque&in=id&libero=justo&ut=sit&massa=amet&volutpat=sapien&convallis=dignissim&morbi=vestibulum&odio=vestibulum&odio=ante&elementum=ipsum&eu=primis&interdum=in&eu=faucibus&tincidunt=orci&in=luctus&leo=et&maecenas=ultrices&pulvinar=posuere&lobortis=cubilia&est=curae&phasellus=nulla&sit=dapibus&amet=dolor&erat=vel&nulla=est&tempus=donec&vivamus=odio&in=justo&felis=sollicitudin&eu=ut&sapien=suscipit&cursus=a&vestibulum=feugiat&proin=et&eu=eros&mi=vestibulum&nulla=ac&ac=est&enim=lacinia&in=nisi&tempor=venenatis&turpis=tristique&nec=fusce&euismod=congue&scelerisque=diam&quam=id&turpis=ornare&adipiscing=imperdiet&lorem=sapien&vitae=urna&mattis=pretium&nibh=nisl&ligula=ut&nec=volutpat&sem=sapien&duis=arcu&aliquam=sed&convallis=augue&nunc=aliquam&proin=erat&at=volutpat&turpis=in&a=congue&pede=etiam&posuere=justo&nonummy=etiam&integer=pretium&non=iaculis&velit=justo&donec=in",
        discord:
          "http://chron.com/in/lectus/pellentesque/at/nulla.aspx?habitasse=turpis&platea=sed&dictumst=ante&aliquam=vivamus&augue=tortor&quam=duis&sollicitudin=mattis&vitae=egestas&consectetuer=metus&eget=aenean&rutrum=fermentum&at=donec&lorem=ut&integer=mauris&tincidunt=eget&ante=massa&vel=tempor&ipsum=convallis&praesent=nulla&blandit=neque&lacinia=libero&erat=convallis&vestibulum=eget&sed=eleifend&magna=luctus",
        medium:
          "https://house.gov/sapien/non.html?nec=eget&nisi=vulputate&vulputate=ut&nonummy=ultrices&maecenas=vel&tincidunt=augue&lacus=vestibulum&at=ante&velit=ipsum&vivamus=primis&vel=in&nulla=faucibus&eget=orci&eros=luctus&elementum=et&pellentesque=ultrices&quisque=posuere&porta=cubilia&volutpat=curae&erat=donec&quisque=pharetra&erat=magna&eros=vestibulum&viverra=aliquet&eget=ultrices&congue=erat&eget=tortor&semper=sollicitudin&rutrum=mi&nulla=sit&nunc=amet&purus=lobortis&phasellus=sapien&in=sapien&felis=non&donec=mi&semper=integer&sapien=ac&a=neque&libero=duis&nam=bibendum&dui=morbi&proin=non&leo=quam&odio=nec&porttitor=dui&id=luctus&consequat=rutrum&in=nulla&consequat=tellus&ut=in&nulla=sagittis&sed=dui&accumsan=vel&felis=nisl&ut=duis&at=ac&dolor=nibh&quis=fusce&odio=lacus&consequat=purus&varius=aliquet&integer=at&ac=feugiat&leo=non&pellentesque=pretium&ultrices=quis&mattis=lectus&odio=suspendisse",
        telegram:
          "https://technorati.com/quam/nec.html?id=hac&consequat=habitasse&in=platea&consequat=dictumst&ut=maecenas&nulla=ut&sed=massa&accumsan=quis&felis=augue&ut=luctus&at=tincidunt&dolor=nulla&quis=mollis&odio=molestie&consequat=lorem&varius=quisque&integer=ut&ac=erat&leo=curabitur&pellentesque=gravida&ultrices=nisi&mattis=at&odio=nibh&donec=in&vitae=hac&nisi=habitasse&nam=platea&ultrices=dictumst&libero=aliquam&non=augue&mattis=quam&pulvinar=sollicitudin&nulla=vitae&pede=consectetuer&ullamcorper=eget&augue=rutrum&a=at&suscipit=lorem&nulla=integer&elit=tincidunt&ac=ante&nulla=vel&sed=ipsum&vel=praesent&enim=blandit&sit=lacinia&amet=erat&nunc=vestibulum&viverra=sed&dapibus=magna&nulla=at&suscipit=nunc&ligula=commodo&in=placerat&lacus=praesent",
        instagram:
          "https://github.com/purus/aliquet/at/feugiat/non/pretium.json?vestibulum=quisque&sed=ut&magna=erat&at=curabitur&nunc=gravida&commodo=nisi&placerat=at&praesent=nibh&blandit=in&nam=hac&nulla=habitasse&integer=platea&pede=dictumst&justo=aliquam&lacinia=augue&eget=quam&tincidunt=sollicitudin&eget=vitae&tempus=consectetuer&vel=eget&pede=rutrum&morbi=at&porttitor=lorem&lorem=integer&id=tincidunt&ligula=ante&suspendisse=vel&ornare=ipsum&consequat=praesent&lectus=blandit&in=lacinia&est=erat&risus=vestibulum&auctor=sed&sed=magna&tristique=at&in=nunc&tempus=commodo&sit=placerat&amet=praesent&sem=blandit&fusce=nam&consequat=nulla&nulla=integer&nisl=pede&nunc=justo&nisl=lacinia&duis=eget&bibendum=tincidunt&felis=eget&sed=tempus&interdum=vel&venenatis=pede&turpis=morbi&enim=porttitor&blandit=lorem&mi=id&in=ligula&porttitor=suspendisse&pede=ornare&justo=consequat&eu=lectus&massa=in&donec=est&dapibus=risus&duis=auctor&at=sed&velit=tristique&eu=in&est=tempus&congue=sit&elementum=amet&in=sem&hac=fusce&habitasse=consequat&platea=nulla&dictumst=nisl&morbi=nunc&vestibulum=nisl&velit=duis&id=bibendum&pretium=felis&iaculis=sed&diam=interdum&erat=venenatis&fermentum=turpis&justo=enim&nec=blandit&condimentum=mi&neque=in&sapien=porttitor&placerat=pede&ante=justo&nulla=eu&justo=massa&aliquam=donec&quis=dapibus&turpis=duis",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "10/7/2021",
        listPrice: 37,
        editionSupply: 5,
        edition: 5,
        editionType: "Common",
        season: 3,
        rarity: "Secret",
        license: "DC",
        brand: "Batman",
        collection: "Next Generation",
        series: "Batman - Next Generation",
        annotations: ["Generation", "Zombie", "Purple"],
        description:
          "luctus et ultrices posuere cubilia curae mauris viverra diam vitae quam suspendisse potenti nullam porttitor lacus at",
      },
    },
    auction: "14-Apr-2021 20:20:20",
    price: {
      amount: 235.86,
      currency: "ETH",
      history: [
        { amount: 344.36, currency: "MATIC", date: "12/11/2021 10:55:55" },
        { amount: 232.56, currency: "ETH", date: "11/19/2021 23:23:23" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "01/25/2022 20:20:20",
          amount: 536.17,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "09/29/2021 17:12:12",
          amount: 132.18,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 597.76,
          currency: "BUSD",
          expiration: "07/05/2021 23:23:23",
          from: "Raymund",
        },
      ],
    },
    listings: [
      {
        amount: 3.86,
        currency: "SOL",
        expiration: "01/04/2022 10:55:55",
        addDate: "05/18/2021 17:12:12",
        from: "Kristofer",
      },
      {
        amount: 9.54,
        currency: "MATIC",
        expiration: "04/15/2021 17:12:12",
        addDate: "01/15/2022 17:12:12",
        from: "Raymund",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 7.78 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "11/13/2021 23:23:23",
        transaction: "0x56e2fd2f21fac40c351f37ef96204ea57eba08a1",
      },
      {
        type: "Sale",
        cost: { amount: 6.15, currency: "SOL", usdEquivalent: 7.38 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "05/10/2021 23:23:23",
        transaction: "0x15389e4754e467473dba7579471861e367edd400",
      },
      {
        type: "Transfer",
        cost: { amount: 9.97, currency: "SOL", usdEquivalent: 9.25 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "11/19/2021 00:00:00",
        transaction: "0x641f4bd99ef7e0080374a2060abb8103cc0b45aa",
      },
      {
        type: "Bid",
        cost: { amount: 5.03, currency: "MATIC", usdEquivalent: 2.86 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "06/13/2021 23:23:23",
        transaction: "0x4038c3beba55efa8bf77e832f7a1995b1326ad9e",
      },
      {
        type: "Bid",
        cost: { amount: 2.81, currency: "ETH", usdEquivalent: 5.5 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "06/30/2021 20:20:20",
        transaction: "0x7ec23824b970254fc8c3a804f7552cc375d4efa1",
      },
    ],
    more: [{ id: 2 }],
  },
  {
    id: 5,
    general: {
      name: "Aileen",
      src: "https://lh3.googleusercontent.com/nYH0MhgV94bzuhPsC4S0ZO83DtA1551pnvD3ezWOpLExxz7Je7BbVP2k9hXYvC1ypMBkQbdMMUgQ-RbeEXayybeuqv7-MPyHY4La1RU=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: true,
      link: "https://google.de/mauris/ullamcorper.aspx?quis=vulputate&turpis=vitae&eget=nisl&elit=aenean&sodales=lectus&scelerisque=pellentesque&mauris=eget&sit=nunc&amet=donec&eros=quis&suspendisse=orci&accumsan=eget&tortor=orci&quis=vehicula&turpis=condimentum&sed=curabitur&ante=in&vivamus=libero&tortor=ut&duis=massa&mattis=volutpat&egestas=convallis&metus=morbi&aenean=odio&fermentum=odio&donec=elementum&ut=eu&mauris=interdum&eget=eu&massa=tincidunt&tempor=in&convallis=leo&nulla=maecenas&neque=pulvinar&libero=lobortis&convallis=est&eget=phasellus&eleifend=sit&luctus=amet&ultricies=erat&eu=nulla&nibh=tempus&quisque=vivamus&id=in&justo=felis&sit=eu&amet=sapien&sapien=cursus&dignissim=vestibulum&vestibulum=proin&vestibulum=eu&ante=mi&ipsum=nulla&primis=ac&in=enim&faucibus=in",
    },
    contract: {
      contractAddress: "0x869aaf33b8b842873fd45fb9ef8369eea933ed5c",
      tokenID: 8211,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Nickolas",
        link: "http://senate.gov/pellentesque/ultrices/phasellus.jsp?sapien=blandit&in=nam&sapien=nulla&iaculis=integer&congue=pede&vivamus=justo&metus=lacinia&arcu=eget&adipiscing=tincidunt&molestie=eget&hendrerit=tempus&at=vel&vulputate=pede&vitae=morbi&nisl=porttitor&aenean=lorem&lectus=id&pellentesque=ligula&eget=suspendisse&nunc=ornare&donec=consequat&quis=lectus&orci=in&eget=est&orci=risus&vehicula=auctor&condimentum=sed",
        avatar:
          "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
      },
      creator: {
        name: "Azuki",
        link: "https://digg.com/non/pretium/quis/lectus/suspendisse/potenti.jsp?nunc=justo&commodo=maecenas&placerat=rhoncus&praesent=aliquam&blandit=lacus&nam=morbi&nulla=quis&integer=tortor&pede=id&justo=nulla&lacinia=ultrices",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 20,
      },
    },
    socialMedia: {
      stats: { favorites: 78473, views: 6411 },
      links: {
        website:
          "https://theguardian.com/sed/lacus/morbi/sem.xml?phasellus=interdum&id=mauris&sapien=ullamcorper&in=purus&sapien=sit&iaculis=amet&congue=nulla&vivamus=quisque&metus=arcu&arcu=libero&adipiscing=rutrum&molestie=ac&hendrerit=lobortis&at=vel",
        discord:
          "http://dailymotion.com/ultrices/libero/non/mattis/pulvinar.jsp?enim=porta&lorem=volutpat&ipsum=erat&dolor=quisque&sit=erat&amet=eros&consectetuer=viverra",
        medium:
          "http://un.org/morbi/non.html?elementum=donec&in=pharetra&hac=magna&habitasse=vestibulum&platea=aliquet&dictumst=ultrices&morbi=erat&vestibulum=tortor&velit=sollicitudin&id=mi&pretium=sit&iaculis=amet&diam=lobortis&erat=sapien&fermentum=sapien&justo=non&nec=mi&condimentum=integer&neque=ac&sapien=neque&placerat=duis&ante=bibendum&nulla=morbi&justo=non&aliquam=quam&quis=nec&turpis=dui&eget=luctus&elit=rutrum&sodales=nulla&scelerisque=tellus&mauris=in&sit=sagittis&amet=dui&eros=vel&suspendisse=nisl&accumsan=duis&tortor=ac&quis=nibh&turpis=fusce&sed=lacus&ante=purus&vivamus=aliquet&tortor=at&duis=feugiat&mattis=non&egestas=pretium&metus=quis&aenean=lectus&fermentum=suspendisse&donec=potenti&ut=in&mauris=eleifend&eget=quam&massa=a&tempor=odio&convallis=in&nulla=hac&neque=habitasse&libero=platea&convallis=dictumst&eget=maecenas&eleifend=ut&luctus=massa&ultricies=quis&eu=augue&nibh=luctus&quisque=tincidunt&id=nulla&justo=mollis&sit=molestie&amet=lorem&sapien=quisque&dignissim=ut&vestibulum=erat&vestibulum=curabitur&ante=gravida&ipsum=nisi&primis=at&in=nibh&faucibus=in&orci=hac&luctus=habitasse&et=platea&ultrices=dictumst&posuere=aliquam&cubilia=augue&curae=quam&nulla=sollicitudin&dapibus=vitae&dolor=consectetuer&vel=eget&est=rutrum",
        telegram:
          "http://kickstarter.com/cras/non/velit/nec/nisi.jpg?libero=id&nullam=luctus&sit=nec&amet=molestie&turpis=sed&elementum=justo&ligula=pellentesque&vehicula=viverra&consequat=pede&morbi=ac&a=diam&ipsum=cras&integer=pellentesque&a=volutpat&nibh=dui&in=maecenas&quis=tristique&justo=est&maecenas=et&rhoncus=tempus&aliquam=semper&lacus=est&morbi=quam&quis=pharetra&tortor=magna&id=ac&nulla=consequat&ultrices=metus&aliquet=sapien&maecenas=ut&leo=nunc&odio=vestibulum&condimentum=ante&id=ipsum&luctus=primis&nec=in&molestie=faucibus&sed=orci&justo=luctus&pellentesque=et&viverra=ultrices&pede=posuere&ac=cubilia&diam=curae&cras=mauris&pellentesque=viverra&volutpat=diam&dui=vitae&maecenas=quam&tristique=suspendisse&est=potenti&et=nullam&tempus=porttitor&semper=lacus&est=at&quam=turpis",
        instagram:
          "https://artisteer.com/lacinia.html?libero=vestibulum&convallis=velit&eget=id&eleifend=pretium&luctus=iaculis&ultricies=diam&eu=erat&nibh=fermentum&quisque=justo&id=nec&justo=condimentum&sit=neque&amet=sapien&sapien=placerat&dignissim=ante&vestibulum=nulla&vestibulum=justo&ante=aliquam&ipsum=quis&primis=turpis&in=eget&faucibus=elit&orci=sodales&luctus=scelerisque&et=mauris&ultrices=sit&posuere=amet&cubilia=eros&curae=suspendisse&nulla=accumsan&dapibus=tortor&dolor=quis&vel=turpis&est=sed&donec=ante&odio=vivamus&justo=tortor&sollicitudin=duis&ut=mattis&suscipit=egestas",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["art"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Female" },
      stats: null,
      details: {
        dropDate: "11/20/2021",
        listPrice: 79,
        editionSupply: 3,
        edition: 5,
        editionType: "Rare",
        season: 3,
        rarity: "One of a kind",
        license: "Disney",
        brand: "Batman",
        collection: "Purple",
        series: "Batman - Purple",
        annotations: ["Purple"],
        description:
          "amet sem fusce consequat nulla nisl nunc nisl duis bibendum felis sed interdum venenatis turpis enim blandit",
      },
    },
    auction: "03-Oct-2021 23:23:23",
    price: {
      amount: 743.51,
      currency: "SOL",
      history: [
        { amount: 664.34, currency: "SOL", date: "10/27/2021 23:23:23" },
        { amount: 285.3, currency: "ETH", date: "10/22/2021 20:20:20" },
        { amount: 294.25, currency: "MATIC", date: "06/24/2021 17:12:12" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "03/19/2022 05:33:33",
          amount: 339.22,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "04/30/2021 17:12:12",
          amount: 949.31,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "03/20/2022 00:00:00",
          amount: 150.69,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "07/04/2021 20:20:20",
          amount: 437.83,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 905.09,
          currency: "BUSD",
          expiration: "09/22/2021 20:20:20",
          from: "Nickolas",
        },
      ],
    },
    listings: [
      {
        amount: 9.17,
        currency: "MATIC",
        expiration: "11/07/2021 00:00:00",
        addDate: "11/04/2021 05:33:33",
        from: "Nickolas",
      },
      {
        amount: 8.39,
        currency: "ETH",
        expiration: "09/27/2021 10:55:55",
        addDate: "03/30/2022 05:33:33",
        from: "Winni",
      },
    ],
    itemHistory: [],
    more: [{ id: 0 }, { id: 1 }],
  },
  {
    id: 6,
    general: {
      name: "Spense",
      src: "https://lh3.googleusercontent.com/3rllkFLC_4ZIjcKi9tKHfVMvhcaSw9SLaJ8GbOGg5Joouct5bpdeBNJLz3t9Tt1Q1YiDGsfA_mO8nlBlLsZxJ53ZG4yR_MpDU327Ji0=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: true,
      link: "https://state.tx.us/accumsan/felis/ut/at/dolor.xml?non=in&interdum=hac&in=habitasse&ante=platea&vestibulum=dictumst&ante=etiam&ipsum=faucibus&primis=cursus&in=urna&faucibus=ut&orci=tellus&luctus=nulla&et=ut&ultrices=erat&posuere=id&cubilia=mauris&curae=vulputate&duis=elementum&faucibus=nullam&accumsan=varius&odio=nulla&curabitur=facilisi&convallis=cras&duis=non&consequat=velit&dui=nec&nec=nisi&nisi=vulputate&volutpat=nonummy&eleifend=maecenas&donec=tincidunt&ut=lacus&dolor=at&morbi=velit&vel=vivamus&lectus=vel&in=nulla&quam=eget&fringilla=eros&rhoncus=elementum&mauris=pellentesque&enim=quisque&leo=porta&rhoncus=volutpat&sed=erat&vestibulum=quisque&sit=erat&amet=eros&cursus=viverra&id=eget&turpis=congue&integer=eget&aliquet=semper&massa=rutrum&id=nulla&lobortis=nunc&convallis=purus&tortor=phasellus&risus=in&dapibus=felis&augue=donec&vel=semper&accumsan=sapien&tellus=a&nisi=libero&eu=nam&orci=dui&mauris=proin&lacinia=leo&sapien=odio&quis=porttitor&libero=id&nullam=consequat&sit=in&amet=consequat&turpis=ut&elementum=nulla&ligula=sed&vehicula=accumsan&consequat=felis&morbi=ut&a=at&ipsum=dolor&integer=quis&a=odio&nibh=consequat&in=varius&quis=integer&justo=ac&maecenas=leo&rhoncus=pellentesque",
    },
    contract: {
      contractAddress: "0xd595aaae7b03e7342b13980ff1a3ee7590dae8a2",
      tokenID: 8758,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Winni",
        link: "http://usnews.com/amet.jsp?elit=in&proin=lacus&interdum=curabitur&mauris=at&non=ipsum&ligula=ac&pellentesque=tellus&ultrices=semper&phasellus=interdum&id=mauris&sapien=ullamcorper&in=purus&sapien=sit",
        avatar:
          "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "http://yale.edu/ultrices/posuere.json?lectus=euismod&in=scelerisque&quam=quam&fringilla=turpis&rhoncus=adipiscing&mauris=lorem&enim=vitae&leo=mattis&rhoncus=nibh&sed=ligula&vestibulum=nec&sit=sem&amet=duis&cursus=aliquam&id=convallis&turpis=nunc&integer=proin&aliquet=at&massa=turpis&id=a&lobortis=pede&convallis=posuere&tortor=nonummy&risus=integer&dapibus=non&augue=velit&vel=donec&accumsan=diam&tellus=neque&nisi=vestibulum&eu=eget&orci=vulputate&mauris=ut&lacinia=ultrices&sapien=vel&quis=augue&libero=vestibulum&nullam=ante&sit=ipsum&amet=primis&turpis=in&elementum=faucibus&ligula=orci&vehicula=luctus&consequat=et&morbi=ultrices&a=posuere&ipsum=cubilia&integer=curae&a=donec&nibh=pharetra&in=magna&quis=vestibulum&justo=aliquet&maecenas=ultrices&rhoncus=erat&aliquam=tortor&lacus=sollicitudin&morbi=mi&quis=sit&tortor=amet&id=lobortis&nulla=sapien&ultrices=sapien&aliquet=non&maecenas=mi&leo=integer&odio=ac&condimentum=neque&id=duis&luctus=bibendum&nec=morbi&molestie=non&sed=quam&justo=nec&pellentesque=dui&viverra=luctus&pede=rutrum&ac=nulla&diam=tellus&cras=in&pellentesque=sagittis&volutpat=dui&dui=vel&maecenas=nisl&tristique=duis&est=ac&et=nibh&tempus=fusce&semper=lacus&est=purus&quam=aliquet&pharetra=at&magna=feugiat&ac=non&consequat=pretium&metus=quis&sapien=lectus&ut=suspendisse",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 16,
      },
    },
    socialMedia: {
      stats: { favorites: 214621, views: 942433 },
      links: {
        website:
          "https://dedecms.com/duis/mattis.xml?quam=nascetur&sollicitudin=ridiculus&vitae=mus&consectetuer=vivamus&eget=vestibulum&rutrum=sagittis&at=sapien&lorem=cum&integer=sociis&tincidunt=natoque&ante=penatibus&vel=et&ipsum=magnis&praesent=dis&blandit=parturient&lacinia=montes&erat=nascetur&vestibulum=ridiculus&sed=mus&magna=etiam&at=vel&nunc=augue&commodo=vestibulum&placerat=rutrum&praesent=rutrum&blandit=neque&nam=aenean&nulla=auctor&integer=gravida&pede=sem&justo=praesent&lacinia=id&eget=massa&tincidunt=id&eget=nisl&tempus=venenatis&vel=lacinia&pede=aenean&morbi=sit&porttitor=amet&lorem=justo&id=morbi&ligula=ut&suspendisse=odio&ornare=cras&consequat=mi&lectus=pede&in=malesuada&est=in&risus=imperdiet&auctor=et&sed=commodo&tristique=vulputate&in=justo&tempus=in&sit=blandit&amet=ultrices&sem=enim&fusce=lorem&consequat=ipsum&nulla=dolor&nisl=sit&nunc=amet&nisl=consectetuer&duis=adipiscing&bibendum=elit&felis=proin&sed=interdum&interdum=mauris&venenatis=non&turpis=ligula&enim=pellentesque&blandit=ultrices&mi=phasellus&in=id&porttitor=sapien&pede=in&justo=sapien&eu=iaculis&massa=congue&donec=vivamus&dapibus=metus&duis=arcu&at=adipiscing&velit=molestie&eu=hendrerit&est=at&congue=vulputate&elementum=vitae&in=nisl&hac=aenean&habitasse=lectus&platea=pellentesque",
        discord:
          "https://theguardian.com/neque/aenean/auctor.jsp?dictumst=porttitor&etiam=lorem&faucibus=id&cursus=ligula&urna=suspendisse&ut=ornare&tellus=consequat&nulla=lectus&ut=in&erat=est&id=risus&mauris=auctor&vulputate=sed&elementum=tristique&nullam=in&varius=tempus&nulla=sit&facilisi=amet&cras=sem&non=fusce&velit=consequat&nec=nulla&nisi=nisl&vulputate=nunc&nonummy=nisl&maecenas=duis&tincidunt=bibendum&lacus=felis&at=sed&velit=interdum&vivamus=venenatis&vel=turpis&nulla=enim&eget=blandit&eros=mi&elementum=in&pellentesque=porttitor&quisque=pede",
        medium:
          "http://tripod.com/vestibulum/proin/eu/mi/nulla/ac.png?ligula=volutpat&suspendisse=in&ornare=congue&consequat=etiam&lectus=justo&in=etiam&est=pretium&risus=iaculis&auctor=justo&sed=in&tristique=hac&in=habitasse&tempus=platea&sit=dictumst&amet=etiam&sem=faucibus&fusce=cursus&consequat=urna&nulla=ut&nisl=tellus&nunc=nulla&nisl=ut&duis=erat&bibendum=id&felis=mauris&sed=vulputate&interdum=elementum&venenatis=nullam&turpis=varius&enim=nulla&blandit=facilisi&mi=cras&in=non&porttitor=velit&pede=nec&justo=nisi&eu=vulputate&massa=nonummy&donec=maecenas&dapibus=tincidunt&duis=lacus&at=at&velit=velit&eu=vivamus&est=vel&congue=nulla&elementum=eget&in=eros&hac=elementum&habitasse=pellentesque&platea=quisque&dictumst=porta&morbi=volutpat&vestibulum=erat&velit=quisque&id=erat",
        telegram:
          "http://cam.ac.uk/dolor/morbi/vel.jpg?sapien=pede&urna=malesuada&pretium=in&nisl=imperdiet&ut=et&volutpat=commodo&sapien=vulputate&arcu=justo&sed=in&augue=blandit&aliquam=ultrices&erat=enim&volutpat=lorem&in=ipsum&congue=dolor&etiam=sit&justo=amet&etiam=consectetuer&pretium=adipiscing&iaculis=elit&justo=proin&in=interdum&hac=mauris&habitasse=non&platea=ligula&dictumst=pellentesque&etiam=ultrices&faucibus=phasellus&cursus=id&urna=sapien&ut=in&tellus=sapien&nulla=iaculis&ut=congue&erat=vivamus&id=metus&mauris=arcu&vulputate=adipiscing",
        instagram:
          "http://harvard.edu/hac/habitasse/platea/dictumst.js?morbi=in&vel=magna&lectus=bibendum&in=imperdiet&quam=nullam&fringilla=orci&rhoncus=pede&mauris=venenatis&enim=non&leo=sodales&rhoncus=sed&sed=tincidunt&vestibulum=eu&sit=felis&amet=fusce&cursus=posuere&id=felis&turpis=sed&integer=lacus&aliquet=morbi&massa=sem&id=mauris&lobortis=laoreet&convallis=ut&tortor=rhoncus&risus=aliquet&dapibus=pulvinar&augue=sed&vel=nisl&accumsan=nunc&tellus=rhoncus&nisi=dui&eu=vel&orci=sem&mauris=sed&lacinia=sagittis&sapien=nam&quis=congue&libero=risus&nullam=semper&sit=porta&amet=volutpat&turpis=quam&elementum=pede&ligula=lobortis&vehicula=ligula&consequat=sit&morbi=amet&a=eleifend&ipsum=pede&integer=libero&a=quis&nibh=orci&in=nullam&quis=molestie&justo=nibh&maecenas=in&rhoncus=lectus&aliquam=pellentesque&lacus=at&morbi=nulla&quis=suspendisse&tortor=potenti&id=cras&nulla=in&ultrices=purus&aliquet=eu&maecenas=magna&leo=vulputate&odio=luctus&condimentum=cum&id=sociis&luctus=natoque&nec=penatibus&molestie=et",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: false,
      category: ["art"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "1/19/2022",
        listPrice: 84,
        editionSupply: 4,
        edition: 1,
        editionType: "Con Exclusive",
        season: 3,
        rarity: "Common",
        license: "Disney",
        brand: "Captain America",
        collection: "Purple",
        series: "Captain America - Purple",
        annotations: [],
        description:
          "condimentum neque sapien placerat ante nulla justo aliquam quis turpis eget elit sodales scelerisque mauris",
      },
    },
    auction: null,
    price: {
      amount: 149.28,
      currency: "MATIC",
      history: [
        { amount: 257.64, currency: "SOL", date: "02/13/2022 00:00:00" },
        { amount: 740.77, currency: "MATIC", date: "05/13/2021 00:00:00" },
        { amount: 38.08, currency: "SOL", date: "04/02/2022 17:12:12" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "12/19/2021 05:33:33",
          amount: 299.81,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "10/27/2021 20:20:20",
          amount: 452.28,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 436.43,
          currency: "BUSD",
          expiration: "08/06/2021 23:23:23",
          from: "Winni",
        },
        {
          active: false,
          amount: 491.47,
          currency: "BUSD",
          expiration: "08/18/2021 23:23:23",
          from: "Eda",
        },
        {
          active: false,
          amount: 936.39,
          currency: "BUSD",
          expiration: "09/08/2021 10:55:55",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 826.72,
          currency: "BUSD",
          expiration: "04/16/2021 17:12:12",
          from: "Raymund",
        },
        {
          active: false,
          amount: 267.04,
          currency: "BUSD",
          expiration: "07/26/2021 23:23:23",
          from: "Nickolas",
        },
      ],
    },
    listings: [
      {
        amount: 8.7,
        currency: "SOL",
        expiration: "09/05/2021 00:00:00",
        addDate: "06/16/2021 17:12:12",
        from: "Eda",
      },
      {
        amount: 4.88,
        currency: "SOL",
        expiration: "06/10/2021 00:00:00",
        addDate: "11/15/2021 00:00:00",
        from: "Kristofer",
      },
      {
        amount: 6.17,
        currency: "MATIC",
        expiration: "04/13/2021 05:33:33",
        addDate: "07/03/2021 05:33:33",
        from: "Raymund",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 3.15 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "12/15/2021 20:20:20",
        transaction: "0xa405627614a67c541bf1e1ee573ab55cc48ba95e",
      },
      {
        type: "Sale",
        cost: { amount: 5.54, currency: "ETH", usdEquivalent: 9.54 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "06/03/2021 17:12:12",
        transaction: "0x876ebb5de8aea9bf85812bf8af40715ac1d85ac6",
      },
      {
        type: "Transfer",
        cost: { amount: 6.71, currency: "MATIC", usdEquivalent: 3.74 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "02/02/2022 17:12:12",
        transaction: "0x230c0864d6957d351eabc193ad2af9d22a475dc9",
      },
    ],
    more: [{ id: 2 }, { id: 0 }, { id: 2 }, { id: 1 }],
  },
  {
    id: 7,
    general: {
      name: "Blinnie",
      src: "https://lh3.googleusercontent.com/esQDThqSsPd2PjTYZ7dkBdjzfuE3QgZAfh-IHq5bTHLYh2H4nbqTXBGQZPLC90B9EsolTgQNXrW81qvsn6jEhBxnI-wChE2tI69PCQ=w206",
    },
    project: {
      name: "Azuki",
      isVerified: false,
      link: "https://vk.com/volutpat/eleifend/donec/ut/dolor/morbi/vel.png?ultrices=ullamcorper",
    },
    contract: {
      contractAddress: "0x437b10c9016a8876874185dd7affc057e33a7874",
      tokenID: 5891,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Eda",
        link: "https://istockphoto.com/lacus/morbi/quis/tortor.jpg?consectetuer=neque&eget=libero&rutrum=convallis&at=eget&lorem=eleifend&integer=luctus&tincidunt=ultricies&ante=eu&vel=nibh&ipsum=quisque&praesent=id&blandit=justo&lacinia=sit&erat=amet&vestibulum=sapien&sed=dignissim&magna=vestibulum&at=vestibulum&nunc=ante&commodo=ipsum&placerat=primis&praesent=in&blandit=faucibus&nam=orci&nulla=luctus&integer=et",
        avatar:
          "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "http://comcast.net/ligula/sit/amet.js?ut=lorem&mauris=integer&eget=tincidunt&massa=ante&tempor=vel&convallis=ipsum&nulla=praesent&neque=blandit&libero=lacinia&convallis=erat&eget=vestibulum&eleifend=sed&luctus=magna&ultricies=at&eu=nunc&nibh=commodo&quisque=placerat&id=praesent&justo=blandit&sit=nam&amet=nulla&sapien=integer&dignissim=pede&vestibulum=justo&vestibulum=lacinia&ante=eget&ipsum=tincidunt&primis=eget&in=tempus&faucibus=vel&orci=pede&luctus=morbi&et=porttitor&ultrices=lorem&posuere=id&cubilia=ligula&curae=suspendisse&nulla=ornare&dapibus=consequat&dolor=lectus&vel=in&est=est&donec=risus&odio=auctor&justo=sed&sollicitudin=tristique&ut=in&suscipit=tempus&a=sit&feugiat=amet&et=sem&eros=fusce&vestibulum=consequat&ac=nulla&est=nisl&lacinia=nunc&nisi=nisl&venenatis=duis&tristique=bibendum&fusce=felis&congue=sed&diam=interdum&id=venenatis",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 17,
      },
    },
    socialMedia: {
      stats: { favorites: 976891, views: 589754 },
      links: {
        website:
          "http://storify.com/gravida/sem/praesent/id.xml?ut=nec&odio=dui&cras=luctus&mi=rutrum&pede=nulla&malesuada=tellus&in=in&imperdiet=sagittis&et=dui&commodo=vel&vulputate=nisl&justo=duis&in=ac&blandit=nibh&ultrices=fusce&enim=lacus&lorem=purus&ipsum=aliquet&dolor=at&sit=feugiat&amet=non&consectetuer=pretium&adipiscing=quis&elit=lectus&proin=suspendisse",
        discord:
          "https://joomla.org/mattis/nibh/ligula/nec/sem/duis.aspx?elementum=rutrum&nullam=at&varius=lorem&nulla=integer&facilisi=tincidunt&cras=ante&non=vel&velit=ipsum&nec=praesent&nisi=blandit&vulputate=lacinia&nonummy=erat&maecenas=vestibulum&tincidunt=sed&lacus=magna&at=at&velit=nunc&vivamus=commodo&vel=placerat&nulla=praesent&eget=blandit&eros=nam&elementum=nulla&pellentesque=integer&quisque=pede&porta=justo&volutpat=lacinia&erat=eget&quisque=tincidunt&erat=eget&eros=tempus&viverra=vel&eget=pede&congue=morbi&eget=porttitor&semper=lorem&rutrum=id&nulla=ligula&nunc=suspendisse&purus=ornare&phasellus=consequat&in=lectus&felis=in&donec=est&semper=risus&sapien=auctor&a=sed&libero=tristique&nam=in&dui=tempus&proin=sit&leo=amet&odio=sem&porttitor=fusce&id=consequat&consequat=nulla&in=nisl&consequat=nunc&ut=nisl&nulla=duis&sed=bibendum&accumsan=felis&felis=sed&ut=interdum&at=venenatis&dolor=turpis&quis=enim&odio=blandit&consequat=mi&varius=in&integer=porttitor&ac=pede&leo=justo&pellentesque=eu&ultrices=massa&mattis=donec&odio=dapibus&donec=duis&vitae=at&nisi=velit&nam=eu&ultrices=est&libero=congue&non=elementum&mattis=in&pulvinar=hac&nulla=habitasse&pede=platea&ullamcorper=dictumst&augue=morbi&a=vestibulum&suscipit=velit&nulla=id&elit=pretium&ac=iaculis&nulla=diam",
        medium:
          "https://wordpress.com/lacus/at/turpis.jpg?faucibus=in&cursus=sagittis&urna=dui&ut=vel&tellus=nisl&nulla=duis&ut=ac&erat=nibh&id=fusce&mauris=lacus&vulputate=purus&elementum=aliquet",
        telegram:
          "http://bloglovin.com/dui/nec/nisi.jsp?bibendum=ac&felis=neque&sed=duis&interdum=bibendum&venenatis=morbi&turpis=non&enim=quam&blandit=nec&mi=dui&in=luctus&porttitor=rutrum&pede=nulla&justo=tellus&eu=in&massa=sagittis&donec=dui&dapibus=vel&duis=nisl&at=duis&velit=ac&eu=nibh&est=fusce&congue=lacus&elementum=purus&in=aliquet&hac=at&habitasse=feugiat&platea=non&dictumst=pretium&morbi=quis&vestibulum=lectus&velit=suspendisse&id=potenti&pretium=in&iaculis=eleifend&diam=quam&erat=a&fermentum=odio&justo=in&nec=hac&condimentum=habitasse&neque=platea&sapien=dictumst&placerat=maecenas&ante=ut&nulla=massa&justo=quis&aliquam=augue&quis=luctus&turpis=tincidunt&eget=nulla&elit=mollis&sodales=molestie&scelerisque=lorem&mauris=quisque&sit=ut&amet=erat&eros=curabitur&suspendisse=gravida&accumsan=nisi&tortor=at&quis=nibh",
        instagram:
          "http://admin.ch/eros/suspendisse/accumsan/tortor.jpg?sem=lacinia&praesent=sapien&id=quis&massa=libero&id=nullam&nisl=sit&venenatis=amet&lacinia=turpis&aenean=elementum&sit=ligula&amet=vehicula&justo=consequat&morbi=morbi&ut=a&odio=ipsum&cras=integer&mi=a&pede=nibh&malesuada=in&in=quis&imperdiet=justo&et=maecenas&commodo=rhoncus&vulputate=aliquam&justo=lacus&in=morbi&blandit=quis&ultrices=tortor&enim=id&lorem=nulla&ipsum=ultrices&dolor=aliquet&sit=maecenas&amet=leo&consectetuer=odio&adipiscing=condimentum&elit=id&proin=luctus&interdum=nec&mauris=molestie&non=sed&ligula=justo&pellentesque=pellentesque&ultrices=viverra&phasellus=pede&id=ac&sapien=diam&in=cras&sapien=pellentesque&iaculis=volutpat&congue=dui&vivamus=maecenas&metus=tristique&arcu=est&adipiscing=et&molestie=tempus&hendrerit=semper&at=est&vulputate=quam&vitae=pharetra&nisl=magna&aenean=ac&lectus=consequat&pellentesque=metus&eget=sapien&nunc=ut&donec=nunc&quis=vestibulum&orci=ante&eget=ipsum&orci=primis&vehicula=in&condimentum=faucibus&curabitur=orci&in=luctus&libero=et&ut=ultrices&massa=posuere&volutpat=cubilia&convallis=curae&morbi=mauris&odio=viverra&odio=diam&elementum=vitae&eu=quam&interdum=suspendisse&eu=potenti&tincidunt=nullam&in=porttitor&leo=lacus&maecenas=at&pulvinar=turpis&lobortis=donec&est=posuere&phasellus=metus&sit=vitae&amet=ipsum&erat=aliquam&nulla=non&tempus=mauris",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "3/11/2022",
        listPrice: 86,
        editionSupply: 2,
        edition: 2,
        editionType: "Unique",
        season: 1,
        rarity: "One of a kind",
        license: "Marvel",
        brand: "The Flash",
        collection: "Next Generation",
        series: "The Flash - Next Generation",
        annotations: ["Purple"],
        description:
          "augue luctus tincidunt nulla mollis molestie lorem quisque ut erat curabitur gravida nisi at nibh in hac habitasse platea",
      },
    },
    auction: "23-Jun-2021 00:00:00",
    price: {
      amount: 164.56,
      currency: "MATIC",
      history: [
        { amount: 818.53, currency: "ETH", date: "04/28/2021 10:55:55" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "11/14/2021 10:55:55",
          amount: 557.4,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 442.82,
          currency: "BUSD",
          expiration: "01/27/2022 23:23:23",
          from: "Winni",
        },
        {
          active: false,
          amount: 171.85,
          currency: "BUSD",
          expiration: "11/20/2021 05:33:33",
          from: "Eda",
        },
        {
          active: false,
          amount: 957.24,
          currency: "BUSD",
          expiration: "11/17/2021 17:12:12",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 26.44,
          currency: "BUSD",
          expiration: "05/05/2021 00:00:00",
          from: "Raymund",
        },
      ],
    },
    listings: [],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 5.5 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "12/18/2021 23:23:23",
        transaction: "0x6a6ffce70f5764935f992fd50f032dec9414d677",
      },
      {
        type: "Sale",
        cost: { amount: 7.81, currency: "ETH", usdEquivalent: 2.91 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "01/24/2022 23:23:23",
        transaction: "0xa331f0fad163584918d0f4911e5a649884024cd9",
      },
      {
        type: "Transfer",
        cost: { amount: 6.69, currency: "SOL", usdEquivalent: 5.11 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "03/01/2022 17:12:12",
        transaction: "0x16459da14fe8fe8937960bad6e95df83bf116bfe",
      },
    ],
    more: [{ id: 1 }, { id: 0 }, { id: 2 }, { id: 2 }],
  },
  {
    id: 8,
    general: {
      name: "Chiquita",
      src: "https://lh3.googleusercontent.com/vxPRqRqF5XXXiKcY2WmySxPph8n8DIT4-9lUcGPOOf5FDxzODslqcSy5kr5gt8gEI6c20fDmWTMi9CH86GlPo5wuTMbiuFmCPV2q=w206",
    },
    project: {
      name: "Azuki",
      isVerified: false,
      link: "https://altervista.org/pede.json?aliquet=curae&massa=donec&id=pharetra&lobortis=magna&convallis=vestibulum&tortor=aliquet&risus=ultrices&dapibus=erat&augue=tortor&vel=sollicitudin&accumsan=mi&tellus=sit&nisi=amet&eu=lobortis&orci=sapien&mauris=sapien&lacinia=non&sapien=mi&quis=integer&libero=ac&nullam=neque&sit=duis&amet=bibendum&turpis=morbi&elementum=non&ligula=quam&vehicula=nec&consequat=dui&morbi=luctus&a=rutrum&ipsum=nulla&integer=tellus&a=in&nibh=sagittis&in=dui&quis=vel&justo=nisl&maecenas=duis&rhoncus=ac&aliquam=nibh&lacus=fusce&morbi=lacus&quis=purus&tortor=aliquet",
    },
    contract: {
      contractAddress: "0x25e28abf56f0880469951d3d3a646c28fdd81d80",
      tokenID: 6671,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Kristofer",
        link: "https://jigsy.com/penatibus/et/magnis.png?ultrices=nulla&erat=tellus&tortor=in&sollicitudin=sagittis&mi=dui&sit=vel&amet=nisl&lobortis=duis&sapien=ac&sapien=nibh&non=fusce&mi=lacus&integer=purus",
        avatar:
          "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "http://yahoo.co.jp/eu.png?blandit=ac",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 18,
      },
    },
    socialMedia: {
      stats: { favorites: 153668, views: 353665 },
      links: {
        website:
          "http://upenn.edu/proin/at/turpis/a.jpg?non=vestibulum&velit=velit&donec=id&diam=pretium&neque=iaculis&vestibulum=diam&eget=erat&vulputate=fermentum&ut=justo&ultrices=nec&vel=condimentum&augue=neque&vestibulum=sapien&ante=placerat&ipsum=ante&primis=nulla&in=justo&faucibus=aliquam&orci=quis&luctus=turpis&et=eget&ultrices=elit&posuere=sodales&cubilia=scelerisque&curae=mauris&donec=sit&pharetra=amet&magna=eros&vestibulum=suspendisse&aliquet=accumsan&ultrices=tortor&erat=quis&tortor=turpis&sollicitudin=sed&mi=ante&sit=vivamus&amet=tortor&lobortis=duis&sapien=mattis&sapien=egestas&non=metus&mi=aenean&integer=fermentum&ac=donec&neque=ut&duis=mauris&bibendum=eget&morbi=massa&non=tempor&quam=convallis&nec=nulla&dui=neque&luctus=libero&rutrum=convallis&nulla=eget&tellus=eleifend&in=luctus&sagittis=ultricies&dui=eu&vel=nibh&nisl=quisque&duis=id&ac=justo&nibh=sit&fusce=amet",
        discord:
          "https://imgur.com/convallis.aspx?vulputate=ultrices&nonummy=mattis&maecenas=odio&tincidunt=donec&lacus=vitae&at=nisi&velit=nam&vivamus=ultrices&vel=libero&nulla=non&eget=mattis&eros=pulvinar&elementum=nulla&pellentesque=pede&quisque=ullamcorper&porta=augue&volutpat=a&erat=suscipit&quisque=nulla&erat=elit&eros=ac&viverra=nulla&eget=sed&congue=vel&eget=enim&semper=sit&rutrum=amet&nulla=nunc&nunc=viverra&purus=dapibus&phasellus=nulla&in=suscipit&felis=ligula&donec=in&semper=lacus&sapien=curabitur&a=at&libero=ipsum&nam=ac&dui=tellus&proin=semper&leo=interdum&odio=mauris&porttitor=ullamcorper&id=purus&consequat=sit&in=amet",
        medium:
          "https://state.gov/lectus/suspendisse/potenti/in/eleifend/quam.js?eu=sociis&felis=natoque&fusce=penatibus&posuere=et&felis=magnis&sed=dis&lacus=parturient&morbi=montes&sem=nascetur&mauris=ridiculus&laoreet=mus&ut=etiam&rhoncus=vel&aliquet=augue&pulvinar=vestibulum&sed=rutrum&nisl=rutrum&nunc=neque&rhoncus=aenean&dui=auctor&vel=gravida&sem=sem&sed=praesent&sagittis=id&nam=massa&congue=id&risus=nisl&semper=venenatis&porta=lacinia&volutpat=aenean&quam=sit&pede=amet&lobortis=justo&ligula=morbi",
        telegram:
          "https://google.nl/eros/suspendisse/accumsan/tortor/quis.xml?urna=imperdiet&ut=et&tellus=commodo&nulla=vulputate&ut=justo&erat=in&id=blandit&mauris=ultrices&vulputate=enim&elementum=lorem&nullam=ipsum&varius=dolor&nulla=sit&facilisi=amet&cras=consectetuer&non=adipiscing&velit=elit&nec=proin&nisi=interdum&vulputate=mauris&nonummy=non&maecenas=ligula&tincidunt=pellentesque&lacus=ultrices&at=phasellus&velit=id&vivamus=sapien&vel=in&nulla=sapien&eget=iaculis&eros=congue",
        instagram:
          "http://oakley.com/turpis/sed/ante/vivamus/tortor.json?libero=ligula&rutrum=sit&ac=amet&lobortis=eleifend&vel=pede&dapibus=libero&at=quis&diam=orci",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "3/7/2022",
        listPrice: 37,
        editionSupply: 7,
        edition: 3,
        editionType: "Rare",
        season: 1,
        rarity: "Common",
        license: "Disney",
        brand: "The Flash",
        collection: "Zombie",
        series: "The Flash - Zombie",
        annotations: [],
        description:
          "feugiat et eros vestibulum ac est lacinia nisi venenatis tristique fusce congue diam id",
      },
    },
    auction: null,
    price: {
      amount: 610.19,
      currency: "SOL",
      history: [
        { amount: 186.73, currency: "MATIC", date: "07/20/2021 20:20:20" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "07/23/2021 00:00:00",
          amount: 182.93,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 881.02,
          currency: "BUSD",
          expiration: "02/23/2022 10:55:55",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 636.95,
          currency: "BUSD",
          expiration: "07/22/2021 10:55:55",
          from: "Winni",
        },
        {
          active: false,
          amount: 868.92,
          currency: "BUSD",
          expiration: "10/04/2021 17:12:12",
          from: "Eda",
        },
      ],
    },
    listings: [
      {
        amount: 8.32,
        currency: "ETH",
        expiration: "08/15/2021 00:00:00",
        addDate: "01/26/2022 05:33:33",
        from: "Nickolas",
      },
      {
        amount: 9.42,
        currency: "ETH",
        expiration: "06/28/2021 05:33:33",
        addDate: "01/24/2022 00:00:00",
        from: "Winni",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 7.5 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "05/31/2021 00:00:00",
        transaction: "0xef8bd812e97fa8b7b22f3f6e1895fc34562468b4",
      },
      {
        type: "Sale",
        cost: { amount: 1.79, currency: "MATIC", usdEquivalent: 3.44 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "12/08/2021 23:23:23",
        transaction: "0x0461bb424c07e1009d7fdcdb962fbe3c1fe494ba",
      },
      {
        type: "Transfer",
        cost: { amount: 3.53, currency: "ETH", usdEquivalent: 7.23 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "12/24/2021 10:55:55",
        transaction: "0xb1b5cb9e399987c570720d07a40821574293ec63",
      },
      {
        type: "Bid",
        cost: { amount: 9.06, currency: "ETH", usdEquivalent: 4.0 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "12/28/2021 00:00:00",
        transaction: "0x47415b00e6e24c80164242ff6a4fc6318b36203c",
      },
      {
        type: "Bid",
        cost: { amount: 5.27, currency: "MATIC", usdEquivalent: 8.5 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "09/09/2021 00:00:00",
        transaction: "0x3232d1bd48aed47477f82ccfc7f54f6bc6ee8516",
      },
    ],
    more: [{ id: 0 }, { id: 1 }, { id: 1 }, { id: 2 }],
  },
  {
    id: 9,
    general: {
      name: "Cindra",
      src: "https://lh3.googleusercontent.com/Uagikn-Lhn2W44V54_5UcsnMqrBESw6TkHV3PF_HiDXZZdryannrULVLEsrSeqLZxlSJZ3aA2E7hq3O62Ta4237jEQ=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: true,
      link: "https://prweb.com/quam/turpis.xml?a=nullam&ipsum=porttitor&integer=lacus&a=at&nibh=turpis&in=donec&quis=posuere&justo=metus&maecenas=vitae&rhoncus=ipsum&aliquam=aliquam&lacus=non&morbi=mauris&quis=morbi&tortor=non&id=lectus&nulla=aliquam&ultrices=sit&aliquet=amet&maecenas=diam&leo=in&odio=magna&condimentum=bibendum&id=imperdiet&luctus=nullam&nec=orci&molestie=pede&sed=venenatis&justo=non&pellentesque=sodales&viverra=sed&pede=tincidunt&ac=eu&diam=felis&cras=fusce&pellentesque=posuere&volutpat=felis&dui=sed&maecenas=lacus&tristique=morbi&est=sem&et=mauris&tempus=laoreet&semper=ut&est=rhoncus&quam=aliquet",
    },
    contract: {
      contractAddress: "0xcbf509b311a3737e65249cc26d911648fd462b19",
      tokenID: 6138,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Raymund",
        link: "http://fotki.com/maecenas/pulvinar/lobortis.png?sagittis=in&sapien=hac&cum=habitasse&sociis=platea&natoque=dictumst&penatibus=aliquam&et=augue&magnis=quam&dis=sollicitudin&parturient=vitae&montes=consectetuer&nascetur=eget&ridiculus=rutrum&mus=at&etiam=lorem&vel=integer&augue=tincidunt&vestibulum=ante&rutrum=vel&rutrum=ipsum&neque=praesent&aenean=blandit",
        avatar:
          "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "http://yolasite.com/vivamus/in.jpg?bibendum=quam&imperdiet=sapien&nullam=varius&orci=ut&pede=blandit&venenatis=non&non=interdum&sodales=in&sed=ante&tincidunt=vestibulum&eu=ante&felis=ipsum&fusce=primis&posuere=in&felis=faucibus&sed=orci&lacus=luctus&morbi=et&sem=ultrices&mauris=posuere&laoreet=cubilia&ut=curae&rhoncus=duis&aliquet=faucibus&pulvinar=accumsan&sed=odio&nisl=curabitur&nunc=convallis&rhoncus=duis&dui=consequat&vel=dui&sem=nec&sed=nisi&sagittis=volutpat&nam=eleifend&congue=donec&risus=ut&semper=dolor&porta=morbi&volutpat=vel&quam=lectus&pede=in&lobortis=quam&ligula=fringilla&sit=rhoncus&amet=mauris&eleifend=enim&pede=leo&libero=rhoncus&quis=sed&orci=vestibulum&nullam=sit&molestie=amet&nibh=cursus&in=id&lectus=turpis&pellentesque=integer&at=aliquet&nulla=massa&suspendisse=id&potenti=lobortis&cras=convallis&in=tortor&purus=risus&eu=dapibus&magna=augue&vulputate=vel&luctus=accumsan&cum=tellus&sociis=nisi&natoque=eu&penatibus=orci&et=mauris",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 60,
      },
    },
    socialMedia: {
      stats: { favorites: 222548, views: 66475 },
      links: {
        website:
          "http://php.net/vitae/quam/suspendisse/potenti/nullam.json?ante=nulla&ipsum=facilisi&primis=cras&in=non&faucibus=velit&orci=nec&luctus=nisi&et=vulputate&ultrices=nonummy&posuere=maecenas&cubilia=tincidunt&curae=lacus&mauris=at&viverra=velit&diam=vivamus&vitae=vel&quam=nulla&suspendisse=eget&potenti=eros&nullam=elementum&porttitor=pellentesque&lacus=quisque&at=porta&turpis=volutpat&donec=erat&posuere=quisque&metus=erat&vitae=eros&ipsum=viverra&aliquam=eget&non=congue&mauris=eget&morbi=semper&non=rutrum&lectus=nulla&aliquam=nunc&sit=purus&amet=phasellus&diam=in&in=felis&magna=donec&bibendum=semper&imperdiet=sapien&nullam=a&orci=libero&pede=nam&venenatis=dui&non=proin&sodales=leo&sed=odio&tincidunt=porttitor&eu=id&felis=consequat&fusce=in&posuere=consequat&felis=ut&sed=nulla&lacus=sed&morbi=accumsan&sem=felis&mauris=ut&laoreet=at&ut=dolor&rhoncus=quis",
        discord:
          "https://uol.com.br/lectus/suspendisse/potenti/in/eleifend/quam.xml?praesent=nulla&lectus=elit&vestibulum=ac&quam=nulla&sapien=sed&varius=vel&ut=enim&blandit=sit&non=amet&interdum=nunc&in=viverra&ante=dapibus&vestibulum=nulla",
        medium:
          "http://qq.com/consequat/in/consequat/ut/nulla/sed.js?id=primis&nisl=in&venenatis=faucibus&lacinia=orci&aenean=luctus&sit=et&amet=ultrices&justo=posuere&morbi=cubilia&ut=curae&odio=duis&cras=faucibus&mi=accumsan&pede=odio&malesuada=curabitur&in=convallis&imperdiet=duis&et=consequat&commodo=dui&vulputate=nec&justo=nisi&in=volutpat&blandit=eleifend&ultrices=donec&enim=ut&lorem=dolor&ipsum=morbi&dolor=vel&sit=lectus&amet=in&consectetuer=quam&adipiscing=fringilla&elit=rhoncus&proin=mauris&interdum=enim&mauris=leo&non=rhoncus&ligula=sed&pellentesque=vestibulum&ultrices=sit&phasellus=amet&id=cursus&sapien=id&in=turpis&sapien=integer&iaculis=aliquet&congue=massa&vivamus=id&metus=lobortis&arcu=convallis&adipiscing=tortor&molestie=risus&hendrerit=dapibus&at=augue&vulputate=vel&vitae=accumsan&nisl=tellus&aenean=nisi&lectus=eu&pellentesque=orci&eget=mauris&nunc=lacinia&donec=sapien&quis=quis&orci=libero&eget=nullam&orci=sit&vehicula=amet&condimentum=turpis&curabitur=elementum&in=ligula&libero=vehicula&ut=consequat&massa=morbi&volutpat=a&convallis=ipsum&morbi=integer",
        telegram:
          "https://linkedin.com/platea/dictumst/etiam/faucibus/cursus/urna/ut.aspx?eget=pede&tincidunt=ullamcorper&eget=augue&tempus=a&vel=suscipit&pede=nulla&morbi=elit&porttitor=ac&lorem=nulla",
        instagram:
          "http://msn.com/sapien/sapien/non/mi/integer.js?nisl=ligula&nunc=vehicula&nisl=consequat&duis=morbi&bibendum=a&felis=ipsum&sed=integer&interdum=a&venenatis=nibh&turpis=in&enim=quis&blandit=justo&mi=maecenas&in=rhoncus&porttitor=aliquam&pede=lacus&justo=morbi&eu=quis&massa=tortor&donec=id&dapibus=nulla&duis=ultrices&at=aliquet&velit=maecenas&eu=leo&est=odio&congue=condimentum&elementum=id&in=luctus&hac=nec&habitasse=molestie&platea=sed&dictumst=justo&morbi=pellentesque&vestibulum=viverra&velit=pede&id=ac&pretium=diam&iaculis=cras&diam=pellentesque&erat=volutpat&fermentum=dui&justo=maecenas&nec=tristique&condimentum=est&neque=et&sapien=tempus&placerat=semper&ante=est&nulla=quam&justo=pharetra&aliquam=magna&quis=ac&turpis=consequat&eget=metus&elit=sapien&sodales=ut&scelerisque=nunc&mauris=vestibulum&sit=ante&amet=ipsum&eros=primis&suspendisse=in&accumsan=faucibus",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: true,
      category: ["art"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "11/8/2021",
        listPrice: 43,
        editionSupply: 5,
        edition: 4,
        editionType: "Common",
        season: 2,
        rarity: "One of a kind",
        license: "Disney",
        brand: "Robin",
        collection: "Next Generation",
        series: "Robin - Next Generation",
        annotations: ["Generation", "Purple", "Zombie"],
        description:
          "egestas metus aenean fermentum donec ut mauris eget massa tempor convallis",
      },
    },
    auction: "05-Oct-2021 17:12:12",
    price: {
      amount: 894.27,
      currency: "ETH",
      history: [
        { amount: 408.62, currency: "SOL", date: "05/27/2021 00:00:00" },
        { amount: 676.69, currency: "ETH", date: "12/06/2021 00:00:00" },
        { amount: 853.23, currency: "MATIC", date: "12/10/2021 10:55:55" },
        { amount: 863.79, currency: "SOL", date: "12/08/2021 00:00:00" },
        { amount: 177.23, currency: "ETH", date: "06/21/2021 23:23:23" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "12/26/2021 23:23:23",
          amount: 643.26,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 755.15,
          currency: "BUSD",
          expiration: "02/20/2022 10:55:55",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 331.98,
          currency: "BUSD",
          expiration: "05/18/2021 20:20:20",
          from: "Raymund",
        },
      ],
    },
    listings: [
      {
        amount: 9.54,
        currency: "MATIC",
        expiration: "05/12/2021 00:00:00",
        addDate: "06/02/2021 05:33:33",
        from: "Eda",
      },
      {
        amount: 1.12,
        currency: "SOL",
        expiration: "06/21/2021 17:12:12",
        addDate: "11/11/2021 20:20:20",
        from: "Kristofer",
      },
      {
        amount: 7.95,
        currency: "SOL",
        expiration: "07/21/2021 23:23:23",
        addDate: "12/19/2021 00:00:00",
        from: "Raymund",
      },
      {
        amount: 3.79,
        currency: "MATIC",
        expiration: "08/08/2021 17:12:12",
        addDate: "07/27/2021 20:20:20",
        from: "Nickolas",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 1.85 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "11/17/2021 23:23:23",
        transaction: "0x3171dc00607c82612a42be127a5c6bb8053e22ac",
      },
      {
        type: "Sale",
        cost: { amount: 4.19, currency: "MATIC", usdEquivalent: 5.42 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "04/21/2021 20:20:20",
        transaction: "0xa957c6674efe1517d51cad9cef7cab8a24ca795c",
      },
      {
        type: "Transfer",
        cost: { amount: 3.12, currency: "ETH", usdEquivalent: 2.78 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "02/08/2022 23:23:23",
        transaction: "0x9b62ba532bbb2a8129fcfd0b239bbaf9c9f0b2df",
      },
      {
        type: "Bid",
        cost: { amount: 6.78, currency: "SOL", usdEquivalent: 2.76 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "04/02/2022 23:23:23",
        transaction: "0x263754a91a5dd85de94e1dd18e38efdb042b473f",
      },
    ],
    more: [{ id: 0 }, { id: 1 }],
  },
  {
    id: 10,
    general: {
      name: "Gaspar",
      src: "https://lh3.googleusercontent.com/Uagikn-Lhn2W44V54_5UcsnMqrBESw6TkHV3PF_HiDXZZdryannrULVLEsrSeqLZxlSJZ3aA2E7hq3O62Ta4237jEQ=w206",
    },
    project: {
      name: "Azuki",
      isVerified: false,
      link: "https://oaic.gov.au/aenean/lectus/pellentesque/eget/nunc/donec/quis.png?ipsum=eget&praesent=tincidunt&blandit=eget&lacinia=tempus&erat=vel&vestibulum=pede&sed=morbi&magna=porttitor&at=lorem&nunc=id&commodo=ligula&placerat=suspendisse&praesent=ornare&blandit=consequat&nam=lectus&nulla=in&integer=est&pede=risus&justo=auctor&lacinia=sed&eget=tristique&tincidunt=in&eget=tempus&tempus=sit&vel=amet&pede=sem&morbi=fusce&porttitor=consequat&lorem=nulla&id=nisl&ligula=nunc&suspendisse=nisl&ornare=duis&consequat=bibendum&lectus=felis&in=sed&est=interdum&risus=venenatis&auctor=turpis&sed=enim&tristique=blandit&in=mi&tempus=in&sit=porttitor&amet=pede&sem=justo&fusce=eu&consequat=massa&nulla=donec&nisl=dapibus&nunc=duis&nisl=at&duis=velit&bibendum=eu&felis=est&sed=congue&interdum=elementum&venenatis=in&turpis=hac&enim=habitasse&blandit=platea&mi=dictumst&in=morbi&porttitor=vestibulum&pede=velit&justo=id&eu=pretium&massa=iaculis&donec=diam&dapibus=erat&duis=fermentum&at=justo&velit=nec&eu=condimentum&est=neque&congue=sapien&elementum=placerat&in=ante",
    },
    contract: {
      contractAddress: "0xb19e8dfb52fd9de03a7a299f369edd4170f37171",
      tokenID: 7470,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Nickolas",
        link: "http://ihg.com/libero.json?in=nulla&quam=nunc&fringilla=purus&rhoncus=phasellus&mauris=in&enim=felis&leo=donec&rhoncus=semper&sed=sapien&vestibulum=a&sit=libero&amet=nam&cursus=dui&id=proin&turpis=leo&integer=odio&aliquet=porttitor&massa=id&id=consequat&lobortis=in&convallis=consequat&tortor=ut&risus=nulla&dapibus=sed&augue=accumsan&vel=felis&accumsan=ut&tellus=at&nisi=dolor&eu=quis&orci=odio&mauris=consequat&lacinia=varius",
        avatar:
          "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "https://free.fr/parturient/montes/nascetur/ridiculus/mus/vivamus.aspx?euismod=vestibulum&scelerisque=ante&quam=ipsum&turpis=primis&adipiscing=in&lorem=faucibus&vitae=orci&mattis=luctus&nibh=et&ligula=ultrices&nec=posuere&sem=cubilia&duis=curae&aliquam=mauris&convallis=viverra&nunc=diam&proin=vitae&at=quam&turpis=suspendisse&a=potenti&pede=nullam&posuere=porttitor&nonummy=lacus&integer=at&non=turpis&velit=donec&donec=posuere&diam=metus&neque=vitae&vestibulum=ipsum&eget=aliquam&vulputate=non&ut=mauris&ultrices=morbi&vel=non&augue=lectus&vestibulum=aliquam&ante=sit&ipsum=amet&primis=diam&in=in&faucibus=magna&orci=bibendum&luctus=imperdiet&et=nullam&ultrices=orci&posuere=pede&cubilia=venenatis&curae=non&donec=sodales&pharetra=sed&magna=tincidunt&vestibulum=eu&aliquet=felis&ultrices=fusce&erat=posuere&tortor=felis&sollicitudin=sed&mi=lacus&sit=morbi&amet=sem",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 47,
      },
    },
    socialMedia: {
      stats: { favorites: 679819, views: 453188 },
      links: {
        website:
          "https://istockphoto.com/at.aspx?ipsum=porttitor&primis=id&in=consequat&faucibus=in&orci=consequat&luctus=ut&et=nulla&ultrices=sed&posuere=accumsan&cubilia=felis&curae=ut&donec=at&pharetra=dolor&magna=quis&vestibulum=odio&aliquet=consequat&ultrices=varius&erat=integer&tortor=ac&sollicitudin=leo&mi=pellentesque&sit=ultrices&amet=mattis&lobortis=odio&sapien=donec&sapien=vitae&non=nisi&mi=nam&integer=ultrices&ac=libero&neque=non&duis=mattis&bibendum=pulvinar&morbi=nulla&non=pede&quam=ullamcorper&nec=augue&dui=a&luctus=suscipit&rutrum=nulla&nulla=elit&tellus=ac&in=nulla&sagittis=sed&dui=vel&vel=enim&nisl=sit&duis=amet&ac=nunc&nibh=viverra&fusce=dapibus&lacus=nulla&purus=suscipit&aliquet=ligula&at=in&feugiat=lacus&non=curabitur&pretium=at&quis=ipsum&lectus=ac&suspendisse=tellus&potenti=semper&in=interdum&eleifend=mauris&quam=ullamcorper&a=purus&odio=sit&in=amet&hac=nulla&habitasse=quisque&platea=arcu&dictumst=libero&maecenas=rutrum&ut=ac&massa=lobortis&quis=vel&augue=dapibus&luctus=at&tincidunt=diam&nulla=nam&mollis=tristique&molestie=tortor&lorem=eu",
        discord:
          "http://pinterest.com/nec/condimentum/neque.xml?massa=risus&donec=praesent&dapibus=lectus&duis=vestibulum&at=quam&velit=sapien&eu=varius&est=ut&congue=blandit&elementum=non&in=interdum&hac=in&habitasse=ante&platea=vestibulum&dictumst=ante&morbi=ipsum&vestibulum=primis&velit=in&id=faucibus&pretium=orci&iaculis=luctus&diam=et&erat=ultrices&fermentum=posuere&justo=cubilia&nec=curae&condimentum=duis&neque=faucibus&sapien=accumsan&placerat=odio&ante=curabitur&nulla=convallis&justo=duis&aliquam=consequat&quis=dui&turpis=nec&eget=nisi&elit=volutpat&sodales=eleifend&scelerisque=donec&mauris=ut&sit=dolor&amet=morbi&eros=vel&suspendisse=lectus&accumsan=in&tortor=quam&quis=fringilla&turpis=rhoncus&sed=mauris&ante=enim&vivamus=leo&tortor=rhoncus&duis=sed&mattis=vestibulum&egestas=sit&metus=amet&aenean=cursus&fermentum=id&donec=turpis&ut=integer&mauris=aliquet&eget=massa&massa=id&tempor=lobortis&convallis=convallis&nulla=tortor&neque=risus&libero=dapibus&convallis=augue&eget=vel&eleifend=accumsan&luctus=tellus&ultricies=nisi&eu=eu&nibh=orci&quisque=mauris&id=lacinia&justo=sapien&sit=quis&amet=libero&sapien=nullam&dignissim=sit&vestibulum=amet&vestibulum=turpis&ante=elementum&ipsum=ligula&primis=vehicula&in=consequat&faucibus=morbi&orci=a",
        medium:
          "http://elpais.com/odio/curabitur/convallis/duis.js?in=nascetur&sagittis=ridiculus&dui=mus&vel=etiam&nisl=vel&duis=augue&ac=vestibulum&nibh=rutrum&fusce=rutrum&lacus=neque&purus=aenean&aliquet=auctor&at=gravida&feugiat=sem&non=praesent&pretium=id&quis=massa&lectus=id&suspendisse=nisl&potenti=venenatis&in=lacinia&eleifend=aenean&quam=sit&a=amet&odio=justo&in=morbi&hac=ut&habitasse=odio&platea=cras&dictumst=mi&maecenas=pede&ut=malesuada&massa=in&quis=imperdiet&augue=et&luctus=commodo&tincidunt=vulputate&nulla=justo&mollis=in&molestie=blandit&lorem=ultrices&quisque=enim&ut=lorem&erat=ipsum&curabitur=dolor&gravida=sit&nisi=amet&at=consectetuer&nibh=adipiscing&in=elit&hac=proin&habitasse=interdum&platea=mauris&dictumst=non&aliquam=ligula&augue=pellentesque&quam=ultrices&sollicitudin=phasellus&vitae=id&consectetuer=sapien&eget=in&rutrum=sapien&at=iaculis&lorem=congue",
        telegram:
          "https://blogspot.com/rutrum.js?mi=potenti&nulla=nullam&ac=porttitor&enim=lacus&in=at&tempor=turpis&turpis=donec&nec=posuere&euismod=metus&scelerisque=vitae&quam=ipsum&turpis=aliquam",
        instagram:
          "http://wiley.com/mus/etiam/vel.aspx?sem=ut&fusce=at&consequat=dolor&nulla=quis&nisl=odio&nunc=consequat&nisl=varius&duis=integer&bibendum=ac&felis=leo&sed=pellentesque&interdum=ultrices&venenatis=mattis&turpis=odio&enim=donec&blandit=vitae&mi=nisi&in=nam&porttitor=ultrices&pede=libero&justo=non&eu=mattis&massa=pulvinar&donec=nulla&dapibus=pede&duis=ullamcorper&at=augue&velit=a&eu=suscipit&est=nulla&congue=elit&elementum=ac&in=nulla&hac=sed&habitasse=vel&platea=enim&dictumst=sit&morbi=amet&vestibulum=nunc&velit=viverra&id=dapibus&pretium=nulla&iaculis=suscipit&diam=ligula&erat=in&fermentum=lacus&justo=curabitur&nec=at&condimentum=ipsum&neque=ac",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["art"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "7/29/2021",
        listPrice: 95,
        editionSupply: 8,
        edition: 3,
        editionType: "Unique",
        season: 3,
        rarity: "Common",
        license: "Disney",
        brand: "Batman",
        collection: "Old School",
        series: "Batman - Old School",
        annotations: ["Purple", "Zombie", "Generation"],
        description:
          "interdum in ante vestibulum ante ipsum primis in faucibus orci",
      },
    },
    auction: "23-Dec-2021 23:23:23",
    price: {
      amount: 224.21,
      currency: "SOL",
      history: [
        { amount: 472.8, currency: "ETH", date: "08/21/2021 10:55:55" },
        { amount: 962.58, currency: "MATIC", date: "07/16/2021 20:20:20" },
        { amount: 667.49, currency: "SOL", date: "03/24/2022 10:55:55" },
        { amount: 363.89, currency: "MATIC", date: "12/19/2021 10:55:55" },
        { amount: 711.28, currency: "ETH", date: "03/18/2022 00:00:00" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "05/20/2021 10:55:55",
          amount: 364.28,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "06/02/2021 17:12:12",
          amount: 303.38,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "06/17/2021 00:00:00",
          amount: 27.75,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "06/01/2021 23:23:23",
          amount: 409.41,
          currency: "BUSD",
        },
        {
          id: 5,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "11/24/2021 23:23:23",
          amount: 162.78,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 671.99,
          currency: "BUSD",
          expiration: "03/26/2022 17:12:12",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 598.51,
          currency: "BUSD",
          expiration: "05/13/2021 05:33:33",
          from: "Winni",
        },
      ],
    },
    listings: [
      {
        amount: 1.54,
        currency: "ETH",
        expiration: "06/16/2021 10:55:55",
        addDate: "01/12/2022 23:23:23",
        from: "Winni",
      },
      {
        amount: 8.02,
        currency: "SOL",
        expiration: "11/08/2021 00:00:00",
        addDate: "01/02/2022 10:55:55",
        from: "Eda",
      },
      {
        amount: 4.58,
        currency: "MATIC",
        expiration: "08/31/2021 10:55:55",
        addDate: "03/17/2022 17:12:12",
        from: "Kristofer",
      },
      {
        amount: 3.29,
        currency: "ETH",
        expiration: "01/23/2022 10:55:55",
        addDate: "12/31/2021 00:00:00",
        from: "Raymund",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 8.86 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "07/31/2021 00:00:00",
        transaction: "0xa140b98478efa9a829d753aea42dafcfcbb6d61c",
      },
      {
        type: "Sale",
        cost: { amount: 4.89, currency: "SOL", usdEquivalent: 5.27 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "11/21/2021 10:55:55",
        transaction: "0xbe2aff34d1bbe77afc07043314a8325c16ae3268",
      },
      {
        type: "Transfer",
        cost: { amount: 6.12, currency: "ETH", usdEquivalent: 4.56 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "12/27/2021 23:23:23",
        transaction: "0xc3ef6137a5ae940b28dd763e78e6c110c586ab66",
      },
      {
        type: "Bid",
        cost: { amount: 3.45, currency: "SOL", usdEquivalent: 2.26 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "10/18/2021 00:00:00",
        transaction: "0x7945061f3ffbba1e4ab4d8f365c3d6f2dad631c0",
      },
      {
        type: "Bid",
        cost: { amount: 6.44, currency: "ETH", usdEquivalent: 4.9 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "08/10/2021 00:00:00",
        transaction: "0x835d2813122b43526316c5b62f6894808ec9c1d9",
      },
    ],
    more: [{ id: 2 }, { id: 1 }, { id: 1 }, { id: 1 }],
  },
  {
    id: 11,
    general: {
      name: "Janaye",
      src: "https://lh3.googleusercontent.com/M9Tyqa3vOo5ApTCmIq0ot64XcjPb1NlImqhJnQmAmhWghbhF-oJrG-HVM7p4J9lQaHkIA_CAximNRn3H81dOP43S=w206",
    },
    project: {
      name: "Azuki",
      isVerified: false,
      link: "https://intel.com/maecenas/tristique/est/et.js?risus=lacinia&semper=eget&porta=tincidunt&volutpat=eget&quam=tempus&pede=vel&lobortis=pede&ligula=morbi&sit=porttitor&amet=lorem&eleifend=id&pede=ligula&libero=suspendisse&quis=ornare&orci=consequat&nullam=lectus&molestie=in&nibh=est&in=risus&lectus=auctor&pellentesque=sed&at=tristique&nulla=in&suspendisse=tempus&potenti=sit&cras=amet&in=sem&purus=fusce&eu=consequat&magna=nulla&vulputate=nisl&luctus=nunc&cum=nisl&sociis=duis&natoque=bibendum&penatibus=felis&et=sed&magnis=interdum&dis=venenatis&parturient=turpis&montes=enim&nascetur=blandit&ridiculus=mi&mus=in&vivamus=porttitor&vestibulum=pede&sagittis=justo&sapien=eu&cum=massa&sociis=donec&natoque=dapibus&penatibus=duis&et=at&magnis=velit&dis=eu&parturient=est&montes=congue&nascetur=elementum&ridiculus=in&mus=hac&etiam=habitasse&vel=platea&augue=dictumst&vestibulum=morbi&rutrum=vestibulum&rutrum=velit&neque=id&aenean=pretium&auctor=iaculis",
    },
    contract: {
      contractAddress: "0x080d9de010806b907c43398726b96dbcf8eec9d9",
      tokenID: 1808,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Winni",
        link: "http://answers.com/sagittis/nam/congue.json?ipsum=ut&primis=volutpat&in=sapien&faucibus=arcu&orci=sed&luctus=augue&et=aliquam&ultrices=erat&posuere=volutpat&cubilia=in&curae=congue&mauris=etiam&viverra=justo&diam=etiam&vitae=pretium&quam=iaculis&suspendisse=justo&potenti=in&nullam=hac&porttitor=habitasse&lacus=platea&at=dictumst&turpis=etiam&donec=faucibus&posuere=cursus&metus=urna&vitae=ut&ipsum=tellus&aliquam=nulla&non=ut&mauris=erat&morbi=id&non=mauris&lectus=vulputate&aliquam=elementum&sit=nullam&amet=varius&diam=nulla&in=facilisi&magna=cras&bibendum=non&imperdiet=velit&nullam=nec&orci=nisi&pede=vulputate&venenatis=nonummy&non=maecenas",
        avatar:
          "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
      },
      creator: {
        name: "Azuki",
        link: "https://mlb.com/amet.html?non=vitae&velit=consectetuer&nec=eget&nisi=rutrum&vulputate=at&nonummy=lorem&maecenas=integer&tincidunt=tincidunt&lacus=ante&at=vel&velit=ipsum&vivamus=praesent&vel=blandit&nulla=lacinia&eget=erat&eros=vestibulum&elementum=sed&pellentesque=magna&quisque=at&porta=nunc&volutpat=commodo&erat=placerat&quisque=praesent&erat=blandit&eros=nam&viverra=nulla&eget=integer&congue=pede&eget=justo&semper=lacinia&rutrum=eget&nulla=tincidunt&nunc=eget&purus=tempus&phasellus=vel&in=pede&felis=morbi&donec=porttitor&semper=lorem&sapien=id&a=ligula&libero=suspendisse&nam=ornare&dui=consequat&proin=lectus&leo=in&odio=est&porttitor=risus&id=auctor",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 19,
      },
    },
    socialMedia: {
      stats: { favorites: 453711, views: 274444 },
      links: {
        website:
          "https://comsenz.com/cursus/id/turpis.xml?imperdiet=tempor&et=turpis&commodo=nec&vulputate=euismod&justo=scelerisque&in=quam&blandit=turpis&ultrices=adipiscing&enim=lorem&lorem=vitae&ipsum=mattis&dolor=nibh&sit=ligula&amet=nec&consectetuer=sem&adipiscing=duis&elit=aliquam&proin=convallis&interdum=nunc&mauris=proin&non=at&ligula=turpis&pellentesque=a&ultrices=pede&phasellus=posuere&id=nonummy&sapien=integer&in=non&sapien=velit&iaculis=donec&congue=diam&vivamus=neque&metus=vestibulum&arcu=eget&adipiscing=vulputate&molestie=ut&hendrerit=ultrices&at=vel&vulputate=augue&vitae=vestibulum&nisl=ante&aenean=ipsum&lectus=primis&pellentesque=in&eget=faucibus&nunc=orci&donec=luctus&quis=et&orci=ultrices&eget=posuere&orci=cubilia&vehicula=curae&condimentum=donec&curabitur=pharetra&in=magna&libero=vestibulum&ut=aliquet&massa=ultrices&volutpat=erat&convallis=tortor&morbi=sollicitudin&odio=mi&odio=sit&elementum=amet&eu=lobortis&interdum=sapien&eu=sapien&tincidunt=non&in=mi&leo=integer&maecenas=ac&pulvinar=neque&lobortis=duis&est=bibendum&phasellus=morbi&sit=non&amet=quam&erat=nec&nulla=dui&tempus=luctus&vivamus=rutrum&in=nulla&felis=tellus&eu=in&sapien=sagittis&cursus=dui",
        discord:
          "https://elpais.com/justo/lacinia/eget/tincidunt.html?magnis=varius&dis=integer&parturient=ac&montes=leo&nascetur=pellentesque&ridiculus=ultrices&mus=mattis&vivamus=odio&vestibulum=donec&sagittis=vitae&sapien=nisi&cum=nam&sociis=ultrices&natoque=libero&penatibus=non&et=mattis&magnis=pulvinar&dis=nulla&parturient=pede&montes=ullamcorper&nascetur=augue&ridiculus=a&mus=suscipit&etiam=nulla&vel=elit&augue=ac&vestibulum=nulla&rutrum=sed&rutrum=vel&neque=enim&aenean=sit&auctor=amet&gravida=nunc&sem=viverra&praesent=dapibus&id=nulla&massa=suscipit&id=ligula&nisl=in&venenatis=lacus&lacinia=curabitur&aenean=at&sit=ipsum&amet=ac&justo=tellus&morbi=semper&ut=interdum&odio=mauris&cras=ullamcorper&mi=purus&pede=sit&malesuada=amet&in=nulla",
        medium:
          "http://usatoday.com/sed/vestibulum/sit/amet/cursus.js?erat=nulla&quisque=nisl&erat=nunc&eros=nisl&viverra=duis&eget=bibendum&congue=felis&eget=sed&semper=interdum&rutrum=venenatis&nulla=turpis&nunc=enim&purus=blandit&phasellus=mi&in=in&felis=porttitor&donec=pede&semper=justo&sapien=eu",
        telegram:
          "https://example.com/potenti/in.xml?sed=ut&vestibulum=volutpat&sit=sapien&amet=arcu&cursus=sed&id=augue&turpis=aliquam&integer=erat&aliquet=volutpat&massa=in&id=congue&lobortis=etiam&convallis=justo&tortor=etiam&risus=pretium&dapibus=iaculis&augue=justo&vel=in&accumsan=hac&tellus=habitasse&nisi=platea&eu=dictumst&orci=etiam&mauris=faucibus&lacinia=cursus&sapien=urna&quis=ut&libero=tellus&nullam=nulla&sit=ut&amet=erat&turpis=id&elementum=mauris&ligula=vulputate&vehicula=elementum&consequat=nullam&morbi=varius&a=nulla&ipsum=facilisi&integer=cras&a=non&nibh=velit&in=nec&quis=nisi&justo=vulputate&maecenas=nonummy&rhoncus=maecenas&aliquam=tincidunt&lacus=lacus&morbi=at&quis=velit&tortor=vivamus&id=vel&nulla=nulla&ultrices=eget&aliquet=eros&maecenas=elementum&leo=pellentesque&odio=quisque&condimentum=porta&id=volutpat&luctus=erat&nec=quisque&molestie=erat&sed=eros&justo=viverra&pellentesque=eget&viverra=congue&pede=eget&ac=semper&diam=rutrum&cras=nulla&pellentesque=nunc&volutpat=purus",
        instagram:
          "https://timesonline.co.uk/eget/tempus/vel/pede.aspx?convallis=amet&eget=consectetuer&eleifend=adipiscing&luctus=elit&ultricies=proin&eu=interdum&nibh=mauris&quisque=non&id=ligula&justo=pellentesque&sit=ultrices&amet=phasellus&sapien=id&dignissim=sapien&vestibulum=in&vestibulum=sapien&ante=iaculis&ipsum=congue&primis=vivamus&in=metus&faucibus=arcu&orci=adipiscing&luctus=molestie&et=hendrerit&ultrices=at&posuere=vulputate&cubilia=vitae&curae=nisl&nulla=aenean&dapibus=lectus&dolor=pellentesque&vel=eget&est=nunc&donec=donec&odio=quis&justo=orci&sollicitudin=eget&ut=orci&suscipit=vehicula&a=condimentum&feugiat=curabitur&et=in&eros=libero&vestibulum=ut&ac=massa&est=volutpat&lacinia=convallis&nisi=morbi&venenatis=odio&tristique=odio&fusce=elementum&congue=eu&diam=interdum&id=eu&ornare=tincidunt&imperdiet=in&sapien=leo&urna=maecenas&pretium=pulvinar&nisl=lobortis&ut=est&volutpat=phasellus&sapien=sit",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "9/12/2021",
        listPrice: 59,
        editionSupply: 4,
        edition: 1,
        editionType: "Con Exclusive",
        season: 2,
        rarity: "Secret",
        license: "Disney",
        brand: "Batman",
        collection: "Old School",
        series: "Batman - Old School",
        annotations: ["Generation", "Zombie"],
        description:
          "ut at dolor quis odio consequat varius integer ac leo pellentesque ultrices mattis odio donec vitae nisi nam ultrices",
      },
    },
    auction: "04-Feb-2022 00:00:00",
    price: {
      amount: 150.94,
      currency: "ETH",
      history: [
        { amount: 521.69, currency: "SOL", date: "05/11/2021 00:00:00" },
        { amount: 537.17, currency: "SOL", date: "03/30/2022 20:20:20" },
        { amount: 917.78, currency: "MATIC", date: "04/07/2021 00:00:00" },
        { amount: 794.43, currency: "ETH", date: "04/26/2021 05:33:33" },
        { amount: 963.09, currency: "MATIC", date: "03/09/2022 20:20:20" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "09/16/2021 23:23:23",
          amount: 65.08,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "06/14/2021 05:33:33",
          amount: 782.04,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "11/30/2021 00:00:00",
          amount: 339.46,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "11/30/2021 17:12:12",
          amount: 118.66,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 456.23,
          currency: "BUSD",
          expiration: "07/31/2021 10:55:55",
          from: "Eda",
        },
      ],
    },
    listings: [
      {
        amount: 9.63,
        currency: "SOL",
        expiration: "05/27/2021 20:20:20",
        addDate: "12/25/2021 17:12:12",
        from: "Nickolas",
      },
      {
        amount: 9.5,
        currency: "MATIC",
        expiration: "01/07/2022 05:33:33",
        addDate: "05/06/2021 23:23:23",
        from: "Winni",
      },
      {
        amount: 2.34,
        currency: "ETH",
        expiration: "10/23/2021 05:33:33",
        addDate: "02/25/2022 23:23:23",
        from: "Eda",
      },
      {
        amount: 2.34,
        currency: "SOL",
        expiration: "10/02/2021 05:33:33",
        addDate: "06/29/2021 05:33:33",
        from: "Kristofer",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 6.85 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "12/23/2021 17:12:12",
        transaction: "0x7ac0bc77020f88b9c62d37303f5b67179ec3b073",
      },
      {
        type: "Sale",
        cost: { amount: 1.9, currency: "SOL", usdEquivalent: 3.28 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "10/17/2021 00:00:00",
        transaction: "0x371587ec5020257575a93f00cb96b75096e434df",
      },
      {
        type: "Transfer",
        cost: { amount: 1.35, currency: "MATIC", usdEquivalent: 4.47 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "01/03/2022 05:33:33",
        transaction: "0xce2c11bb880d00c0e38af2785203f5863a44edc9",
      },
      {
        type: "Bid",
        cost: { amount: 1.9, currency: "ETH", usdEquivalent: 8.12 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "02/20/2022 20:20:20",
        transaction: "0xff9ac0d1d755faea9a01ae656eee9fc8f0e4ab26",
      },
      {
        type: "Bid",
        cost: { amount: 5.67, currency: "ETH", usdEquivalent: 5.44 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "11/22/2021 10:55:55",
        transaction: "0xb5cbde827b940b9d367bb3fb4d15387820d7c6d4",
      },
    ],
    more: [{ id: 0 }, { id: 0 }, { id: 0 }, { id: 2 }, { id: 0 }],
  },
  {
    id: 12,
    general: {
      name: "Fredericka",
      src: "https://lh3.googleusercontent.com/V7yIEHLmpvZUpKdzsdUkzWtRXOY67NcCiKEOekD5qtBtHRxUaSOpjnH0k23byzUW7OBhVvuYyrTV07wpFO6j70XRerHFJRI6WPa-=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: false,
      link: "http://upenn.edu/amet/eros/suspendisse.xml?fusce=vel&consequat=nulla&nulla=eget&nisl=eros&nunc=elementum&nisl=pellentesque&duis=quisque&bibendum=porta&felis=volutpat&sed=erat&interdum=quisque&venenatis=erat&turpis=eros&enim=viverra&blandit=eget&mi=congue&in=eget&porttitor=semper&pede=rutrum&justo=nulla&eu=nunc&massa=purus&donec=phasellus&dapibus=in&duis=felis&at=donec&velit=semper&eu=sapien&est=a&congue=libero&elementum=nam&in=dui&hac=proin&habitasse=leo&platea=odio&dictumst=porttitor&morbi=id&vestibulum=consequat&velit=in&id=consequat&pretium=ut&iaculis=nulla&diam=sed&erat=accumsan&fermentum=felis&justo=ut&nec=at&condimentum=dolor&neque=quis&sapien=odio&placerat=consequat&ante=varius&nulla=integer&justo=ac&aliquam=leo&quis=pellentesque&turpis=ultrices&eget=mattis&elit=odio&sodales=donec&scelerisque=vitae&mauris=nisi&sit=nam&amet=ultrices&eros=libero&suspendisse=non&accumsan=mattis&tortor=pulvinar&quis=nulla&turpis=pede&sed=ullamcorper&ante=augue&vivamus=a&tortor=suscipit&duis=nulla&mattis=elit&egestas=ac",
    },
    contract: {
      contractAddress: "0xe92bc9a7d614ed885887a546469f471ccd360c81",
      tokenID: 5712,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Eda",
        link: "http://tripadvisor.com/urna/pretium/nisl/ut.html?ipsum=felis&primis=eu&in=sapien&faucibus=cursus&orci=vestibulum&luctus=proin&et=eu&ultrices=mi&posuere=nulla&cubilia=ac&curae=enim&nulla=in&dapibus=tempor&dolor=turpis&vel=nec&est=euismod&donec=scelerisque&odio=quam&justo=turpis&sollicitudin=adipiscing&ut=lorem&suscipit=vitae&a=mattis&feugiat=nibh&et=ligula&eros=nec&vestibulum=sem&ac=duis&est=aliquam&lacinia=convallis&nisi=nunc&venenatis=proin&tristique=at&fusce=turpis&congue=a&diam=pede",
        avatar:
          "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "http://jiathis.com/ante.js?vel=justo&augue=eu&vestibulum=massa&ante=donec&ipsum=dapibus&primis=duis&in=at&faucibus=velit&orci=eu&luctus=est&et=congue&ultrices=elementum&posuere=in&cubilia=hac&curae=habitasse&donec=platea&pharetra=dictumst&magna=morbi&vestibulum=vestibulum&aliquet=velit&ultrices=id&erat=pretium&tortor=iaculis&sollicitudin=diam&mi=erat&sit=fermentum&amet=justo&lobortis=nec&sapien=condimentum&sapien=neque&non=sapien&mi=placerat&integer=ante&ac=nulla&neque=justo&duis=aliquam&bibendum=quis&morbi=turpis&non=eget&quam=elit&nec=sodales&dui=scelerisque&luctus=mauris&rutrum=sit&nulla=amet&tellus=eros&in=suspendisse&sagittis=accumsan&dui=tortor&vel=quis&nisl=turpis&duis=sed&ac=ante&nibh=vivamus&fusce=tortor&lacus=duis&purus=mattis&aliquet=egestas&at=metus&feugiat=aenean&non=fermentum&pretium=donec&quis=ut&lectus=mauris&suspendisse=eget&potenti=massa&in=tempor&eleifend=convallis&quam=nulla",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 14,
      },
    },
    socialMedia: {
      stats: { favorites: 758825, views: 990330 },
      links: {
        website:
          "http://sun.com/vivamus/vel/nulla/eget/eros.png?et=nisi&magnis=venenatis&dis=tristique&parturient=fusce&montes=congue&nascetur=diam&ridiculus=id&mus=ornare&etiam=imperdiet&vel=sapien&augue=urna&vestibulum=pretium&rutrum=nisl&rutrum=ut&neque=volutpat&aenean=sapien&auctor=arcu&gravida=sed&sem=augue&praesent=aliquam&id=erat&massa=volutpat&id=in&nisl=congue&venenatis=etiam&lacinia=justo&aenean=etiam&sit=pretium&amet=iaculis&justo=justo&morbi=in&ut=hac&odio=habitasse&cras=platea&mi=dictumst&pede=etiam&malesuada=faucibus&in=cursus&imperdiet=urna&et=ut&commodo=tellus&vulputate=nulla&justo=ut&in=erat&blandit=id&ultrices=mauris&enim=vulputate&lorem=elementum&ipsum=nullam&dolor=varius&sit=nulla&amet=facilisi&consectetuer=cras&adipiscing=non&elit=velit&proin=nec&interdum=nisi&mauris=vulputate&non=nonummy&ligula=maecenas&pellentesque=tincidunt&ultrices=lacus&phasellus=at&id=velit&sapien=vivamus&in=vel&sapien=nulla&iaculis=eget&congue=eros&vivamus=elementum&metus=pellentesque&arcu=quisque&adipiscing=porta&molestie=volutpat&hendrerit=erat&at=quisque&vulputate=erat&vitae=eros&nisl=viverra",
        discord:
          "https://hc360.com/odio/condimentum/id.png?maecenas=vulputate&pulvinar=vitae&lobortis=nisl&est=aenean&phasellus=lectus&sit=pellentesque&amet=eget&erat=nunc&nulla=donec&tempus=quis&vivamus=orci&in=eget&felis=orci&eu=vehicula&sapien=condimentum&cursus=curabitur&vestibulum=in&proin=libero&eu=ut&mi=massa&nulla=volutpat&ac=convallis&enim=morbi&in=odio&tempor=odio&turpis=elementum&nec=eu&euismod=interdum&scelerisque=eu&quam=tincidunt&turpis=in&adipiscing=leo&lorem=maecenas&vitae=pulvinar&mattis=lobortis&nibh=est&ligula=phasellus&nec=sit&sem=amet&duis=erat&aliquam=nulla&convallis=tempus&nunc=vivamus&proin=in&at=felis&turpis=eu&a=sapien&pede=cursus&posuere=vestibulum&nonummy=proin&integer=eu&non=mi&velit=nulla&donec=ac&diam=enim&neque=in&vestibulum=tempor&eget=turpis&vulputate=nec&ut=euismod&ultrices=scelerisque&vel=quam&augue=turpis&vestibulum=adipiscing&ante=lorem&ipsum=vitae&primis=mattis",
        medium:
          "https://chicagotribune.com/sapien/quis/libero/nullam/sit.jsp?nibh=nec&fusce=euismod&lacus=scelerisque&purus=quam&aliquet=turpis&at=adipiscing&feugiat=lorem&non=vitae&pretium=mattis&quis=nibh&lectus=ligula&suspendisse=nec&potenti=sem&in=duis&eleifend=aliquam&quam=convallis&a=nunc&odio=proin&in=at&hac=turpis&habitasse=a&platea=pede&dictumst=posuere&maecenas=nonummy&ut=integer&massa=non&quis=velit&augue=donec&luctus=diam&tincidunt=neque&nulla=vestibulum&mollis=eget&molestie=vulputate&lorem=ut&quisque=ultrices&ut=vel&erat=augue&curabitur=vestibulum",
        telegram:
          "http://jigsy.com/rutrum/nulla/tellus/in/sagittis.jsp?maecenas=sapien&tincidunt=in&lacus=sapien&at=iaculis&velit=congue&vivamus=vivamus&vel=metus&nulla=arcu&eget=adipiscing&eros=molestie&elementum=hendrerit&pellentesque=at&quisque=vulputate&porta=vitae&volutpat=nisl&erat=aenean&quisque=lectus&erat=pellentesque&eros=eget&viverra=nunc&eget=donec&congue=quis&eget=orci&semper=eget&rutrum=orci&nulla=vehicula&nunc=condimentum&purus=curabitur&phasellus=in&in=libero&felis=ut&donec=massa&semper=volutpat",
        instagram:
          "http://amazon.co.jp/vel/lectus/in/quam/fringilla/rhoncus.js?posuere=consequat&cubilia=nulla&curae=nisl&nulla=nunc&dapibus=nisl&dolor=duis&vel=bibendum&est=felis&donec=sed&odio=interdum&justo=venenatis&sollicitudin=turpis&ut=enim&suscipit=blandit&a=mi&feugiat=in&et=porttitor&eros=pede&vestibulum=justo&ac=eu&est=massa&lacinia=donec&nisi=dapibus&venenatis=duis&tristique=at&fusce=velit&congue=eu&diam=est&id=congue&ornare=elementum&imperdiet=in&sapien=hac&urna=habitasse&pretium=platea&nisl=dictumst&ut=morbi&volutpat=vestibulum&sapien=velit&arcu=id&sed=pretium&augue=iaculis&aliquam=diam&erat=erat&volutpat=fermentum&in=justo&congue=nec&etiam=condimentum&justo=neque&etiam=sapien&pretium=placerat&iaculis=ante&justo=nulla&in=justo&hac=aliquam&habitasse=quis&platea=turpis&dictumst=eget&etiam=elit&faucibus=sodales&cursus=scelerisque&urna=mauris&ut=sit&tellus=amet&nulla=eros&ut=suspendisse&erat=accumsan&id=tortor&mauris=quis&vulputate=turpis&elementum=sed&nullam=ante&varius=vivamus&nulla=tortor&facilisi=duis&cras=mattis&non=egestas&velit=metus&nec=aenean&nisi=fermentum&vulputate=donec&nonummy=ut&maecenas=mauris&tincidunt=eget&lacus=massa&at=tempor&velit=convallis&vivamus=nulla&vel=neque&nulla=libero&eget=convallis&eros=eget",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "1/27/2022",
        listPrice: 56,
        editionSupply: 4,
        edition: 3,
        editionType: "Common",
        season: 1,
        rarity: "Common",
        license: "Marvel",
        brand: "Batman",
        collection: "Zombie",
        series: "Batman - Zombie",
        annotations: ["Zombie"],
        description:
          "sapien cum sociis natoque penatibus et magnis dis parturient montes nascetur ridiculus mus etiam vel",
      },
    },
    auction: null,
    price: {
      amount: 92.01,
      currency: "MATIC",
      history: [
        { amount: 151.54, currency: "SOL", date: "07/13/2021 20:20:20" },
        { amount: 992.62, currency: "ETH", date: "11/24/2021 05:33:33" },
        { amount: 280.46, currency: "SOL", date: "07/28/2021 00:00:00" },
        { amount: 263.34, currency: "MATIC", date: "05/22/2021 10:55:55" },
        { amount: 80.02, currency: "ETH", date: "03/27/2022 20:20:20" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "09/13/2021 10:55:55",
          amount: 188.46,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 626.3,
          currency: "BUSD",
          expiration: "02/12/2022 17:12:12",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 800.58,
          currency: "BUSD",
          expiration: "12/10/2021 20:20:20",
          from: "Raymund",
        },
        {
          active: false,
          amount: 230.23,
          currency: "BUSD",
          expiration: "08/15/2021 05:33:33",
          from: "Nickolas",
        },
      ],
    },
    listings: [
      {
        amount: 9.84,
        currency: "MATIC",
        expiration: "06/06/2021 00:00:00",
        addDate: "08/08/2021 23:23:23",
        from: "Raymund",
      },
      {
        amount: 9.79,
        currency: "ETH",
        expiration: "04/24/2021 20:20:20",
        addDate: "11/13/2021 05:33:33",
        from: "Nickolas",
      },
      {
        amount: 5.87,
        currency: "SOL",
        expiration: "11/14/2021 05:33:33",
        addDate: "01/14/2022 05:33:33",
        from: "Winni",
      },
      {
        amount: 9.48,
        currency: "ETH",
        expiration: "12/24/2021 23:23:23",
        addDate: "09/30/2021 10:55:55",
        from: "Eda",
      },
      {
        amount: 8.78,
        currency: "MATIC",
        expiration: "07/24/2021 05:33:33",
        addDate: "09/13/2021 10:55:55",
        from: "Kristofer",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 3.71 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "07/26/2021 23:23:23",
        transaction: "0x418035ba13a04f5c50b2741b285fe13f102cce3a",
      },
      {
        type: "Sale",
        cost: { amount: 2.25, currency: "MATIC", usdEquivalent: 8.74 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "01/02/2022 23:23:23",
        transaction: "0x83ad67f2e75c87042dd9f12b7e266e45f580a45f",
      },
      {
        type: "Transfer",
        cost: { amount: 9.77, currency: "MATIC", usdEquivalent: 7.22 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "03/05/2022 23:23:23",
        transaction: "0x8276e0852cb813efe1ff752cb637f34cb07f9299",
      },
    ],
    more: [],
  },
  {
    id: 13,
    general: {
      name: "Yoko",
      src: "https://lh3.googleusercontent.com/esQDThqSsPd2PjTYZ7dkBdjzfuE3QgZAfh-IHq5bTHLYh2H4nbqTXBGQZPLC90B9EsolTgQNXrW81qvsn6jEhBxnI-wChE2tI69PCQ=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: true,
      link: "https://berkeley.edu/adipiscing/elit/proin.js?sociis=mauris&natoque=lacinia&penatibus=sapien&et=quis&magnis=libero&dis=nullam&parturient=sit&montes=amet&nascetur=turpis&ridiculus=elementum&mus=ligula&vivamus=vehicula&vestibulum=consequat&sagittis=morbi&sapien=a&cum=ipsum&sociis=integer",
    },
    contract: {
      contractAddress: "0x58c8a2c80893864eb8cf5ae83b88d5e8094b0164",
      tokenID: 5121,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Kristofer",
        link: "https://yandex.ru/amet/consectetuer/adipiscing/elit/proin.html?natoque=molestie&penatibus=sed&et=justo&magnis=pellentesque&dis=viverra&parturient=pede&montes=ac&nascetur=diam&ridiculus=cras&mus=pellentesque&vivamus=volutpat&vestibulum=dui&sagittis=maecenas&sapien=tristique&cum=est&sociis=et&natoque=tempus&penatibus=semper&et=est&magnis=quam&dis=pharetra&parturient=magna&montes=ac&nascetur=consequat&ridiculus=metus&mus=sapien&etiam=ut&vel=nunc&augue=vestibulum&vestibulum=ante",
        avatar:
          "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "https://dailymotion.com/aliquam/augue/quam/sollicitudin/vitae.aspx?luctus=volutpat&cum=erat&sociis=quisque&natoque=erat&penatibus=eros&et=viverra&magnis=eget&dis=congue&parturient=eget&montes=semper&nascetur=rutrum&ridiculus=nulla&mus=nunc&vivamus=purus&vestibulum=phasellus&sagittis=in&sapien=felis&cum=donec&sociis=semper&natoque=sapien&penatibus=a&et=libero&magnis=nam&dis=dui&parturient=proin&montes=leo&nascetur=odio&ridiculus=porttitor&mus=id&etiam=consequat&vel=in&augue=consequat&vestibulum=ut&rutrum=nulla&rutrum=sed&neque=accumsan&aenean=felis&auctor=ut&gravida=at&sem=dolor&praesent=quis&id=odio&massa=consequat&id=varius&nisl=integer&venenatis=ac&lacinia=leo&aenean=pellentesque&sit=ultrices&amet=mattis&justo=odio&morbi=donec&ut=vitae&odio=nisi&cras=nam&mi=ultrices&pede=libero&malesuada=non&in=mattis&imperdiet=pulvinar&et=nulla&commodo=pede&vulputate=ullamcorper&justo=augue&in=a&blandit=suscipit&ultrices=nulla&enim=elit&lorem=ac&ipsum=nulla&dolor=sed&sit=vel&amet=enim&consectetuer=sit&adipiscing=amet&elit=nunc&proin=viverra&interdum=dapibus&mauris=nulla&non=suscipit&ligula=ligula&pellentesque=in&ultrices=lacus&phasellus=curabitur&id=at&sapien=ipsum&in=ac",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 40,
      },
    },
    socialMedia: {
      stats: { favorites: 743639, views: 50663 },
      links: {
        website:
          "https://paypal.com/luctus/nec/molestie.aspx?a=quis&odio=orci&in=nullam&hac=molestie&habitasse=nibh&platea=in&dictumst=lectus&maecenas=pellentesque",
        discord:
          "https://yellowbook.com/amet/diam/in.html?congue=eu&etiam=sapien&justo=cursus&etiam=vestibulum&pretium=proin&iaculis=eu&justo=mi&in=nulla&hac=ac&habitasse=enim&platea=in&dictumst=tempor&etiam=turpis&faucibus=nec&cursus=euismod&urna=scelerisque&ut=quam&tellus=turpis&nulla=adipiscing&ut=lorem&erat=vitae&id=mattis&mauris=nibh&vulputate=ligula&elementum=nec&nullam=sem&varius=duis&nulla=aliquam&facilisi=convallis&cras=nunc&non=proin&velit=at&nec=turpis&nisi=a&vulputate=pede&nonummy=posuere&maecenas=nonummy&tincidunt=integer&lacus=non&at=velit&velit=donec&vivamus=diam&vel=neque&nulla=vestibulum&eget=eget&eros=vulputate&elementum=ut&pellentesque=ultrices&quisque=vel&porta=augue&volutpat=vestibulum&erat=ante&quisque=ipsum&erat=primis&eros=in&viverra=faucibus&eget=orci&congue=luctus&eget=et&semper=ultrices&rutrum=posuere&nulla=cubilia&nunc=curae&purus=donec&phasellus=pharetra&in=magna&felis=vestibulum&donec=aliquet&semper=ultrices&sapien=erat&a=tortor&libero=sollicitudin&nam=mi&dui=sit&proin=amet&leo=lobortis&odio=sapien&porttitor=sapien&id=non",
        medium:
          "https://engadget.com/in.aspx?vulputate=libero&nonummy=quis&maecenas=orci&tincidunt=nullam&lacus=molestie&at=nibh&velit=in&vivamus=lectus&vel=pellentesque&nulla=at&eget=nulla&eros=suspendisse&elementum=potenti&pellentesque=cras&quisque=in&porta=purus&volutpat=eu&erat=magna&quisque=vulputate&erat=luctus&eros=cum&viverra=sociis&eget=natoque&congue=penatibus&eget=et&semper=magnis&rutrum=dis&nulla=parturient&nunc=montes&purus=nascetur&phasellus=ridiculus&in=mus&felis=vivamus&donec=vestibulum&semper=sagittis&sapien=sapien&a=cum&libero=sociis&nam=natoque&dui=penatibus&proin=et&leo=magnis&odio=dis&porttitor=parturient&id=montes&consequat=nascetur&in=ridiculus&consequat=mus&ut=etiam&nulla=vel&sed=augue&accumsan=vestibulum&felis=rutrum&ut=rutrum&at=neque&dolor=aenean&quis=auctor&odio=gravida&consequat=sem&varius=praesent&integer=id&ac=massa&leo=id&pellentesque=nisl&ultrices=venenatis&mattis=lacinia&odio=aenean&donec=sit&vitae=amet&nisi=justo&nam=morbi&ultrices=ut&libero=odio&non=cras&mattis=mi&pulvinar=pede&nulla=malesuada&pede=in&ullamcorper=imperdiet&augue=et&a=commodo&suscipit=vulputate&nulla=justo&elit=in&ac=blandit&nulla=ultrices&sed=enim&vel=lorem&enim=ipsum",
        telegram:
          "http://tinyurl.com/tortor/sollicitudin/mi/sit/amet/lobortis.jsp?metus=nulla&aenean=suscipit",
        instagram:
          "https://gravatar.com/ultrices.json?interdum=interdum&mauris=in&ullamcorper=ante&purus=vestibulum&sit=ante&amet=ipsum&nulla=primis&quisque=in&arcu=faucibus&libero=orci&rutrum=luctus&ac=et&lobortis=ultrices&vel=posuere&dapibus=cubilia&at=curae&diam=duis&nam=faucibus&tristique=accumsan&tortor=odio",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "1/18/2022",
        listPrice: 5,
        editionSupply: 1,
        edition: 1,
        editionType: "Unique",
        season: 1,
        rarity: "Secret",
        license: "Marvel",
        brand: "Robin",
        collection: "Zombie",
        series: "Robin - Zombie",
        annotations: ["Purple", "Generation", "Zombie"],
        description:
          "nibh ligula nec sem duis aliquam convallis nunc proin at turpis a pede posuere nonummy",
      },
    },
    auction: "22-Apr-2021 23:23:23",
    price: {
      amount: 815.74,
      currency: "MATIC",
      history: [
        { amount: 744.52, currency: "ETH", date: "03/22/2022 23:23:23" },
        { amount: 705.64, currency: "SOL", date: "08/14/2021 05:33:33" },
        { amount: 27.35, currency: "MATIC", date: "01/22/2022 20:20:20" },
        { amount: 534.18, currency: "MATIC", date: "05/23/2021 23:23:23" },
        { amount: 12.79, currency: "ETH", date: "12/28/2021 05:33:33" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "02/07/2022 10:55:55",
          amount: 742.47,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "05/28/2021 00:00:00",
          amount: 785.5,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "12/05/2021 00:00:00",
          amount: 74.84,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "01/09/2022 05:33:33",
          amount: 36.31,
          currency: "BUSD",
        },
      ],
      history: [],
    },
    listings: [
      {
        amount: 9.7,
        currency: "MATIC",
        expiration: "07/21/2021 23:23:23",
        addDate: "03/25/2022 00:00:00",
        from: "Raymund",
      },
    ],
    itemHistory: [],
    more: [{ id: 0 }, { id: 0 }, { id: 2 }, { id: 2 }, { id: 2 }],
  },
  {
    id: 14,
    general: {
      name: "Bruno",
      src: "https://lh3.googleusercontent.com/28jYQ9Toyfs8QPOUd_k86RhLSiventoMuhQjmqiE-TXVFlpoX_g_ncau0kO8GZb3-arCo712XcgsPZYyzYPop-V5=w206",
    },
    project: {
      name: "Azuki",
      isVerified: true,
      link: "http://godaddy.com/sapien/ut/nunc.js?tortor=proin&risus=eu&dapibus=mi&augue=nulla&vel=ac&accumsan=enim&tellus=in&nisi=tempor&eu=turpis&orci=nec&mauris=euismod&lacinia=scelerisque&sapien=quam&quis=turpis&libero=adipiscing&nullam=lorem&sit=vitae&amet=mattis&turpis=nibh&elementum=ligula&ligula=nec&vehicula=sem&consequat=duis&morbi=aliquam&a=convallis&ipsum=nunc&integer=proin&a=at&nibh=turpis&in=a&quis=pede&justo=posuere&maecenas=nonummy&rhoncus=integer&aliquam=non&lacus=velit&morbi=donec&quis=diam&tortor=neque&id=vestibulum&nulla=eget&ultrices=vulputate&aliquet=ut&maecenas=ultrices&leo=vel&odio=augue&condimentum=vestibulum&id=ante&luctus=ipsum&nec=primis&molestie=in&sed=faucibus&justo=orci&pellentesque=luctus&viverra=et&pede=ultrices&ac=posuere&diam=cubilia&cras=curae&pellentesque=donec&volutpat=pharetra&dui=magna&maecenas=vestibulum&tristique=aliquet&est=ultrices&et=erat&tempus=tortor&semper=sollicitudin&est=mi&quam=sit&pharetra=amet&magna=lobortis&ac=sapien&consequat=sapien&metus=non&sapien=mi&ut=integer&nunc=ac",
    },
    contract: {
      contractAddress: "0xff06ae9ff08cf1c77ad1bbbd508ae6d2b998242e",
      tokenID: 9958,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Raymund",
        link: "http://drupal.org/quam/fringilla/rhoncus/mauris/enim/leo.jsp?vel=nec&lectus=sem&in=duis&quam=aliquam&fringilla=convallis&rhoncus=nunc&mauris=proin&enim=at&leo=turpis&rhoncus=a&sed=pede&vestibulum=posuere&sit=nonummy&amet=integer&cursus=non&id=velit&turpis=donec&integer=diam&aliquet=neque&massa=vestibulum&id=eget&lobortis=vulputate&convallis=ut&tortor=ultrices&risus=vel&dapibus=augue&augue=vestibulum&vel=ante&accumsan=ipsum&tellus=primis&nisi=in&eu=faucibus&orci=orci&mauris=luctus&lacinia=et&sapien=ultrices&quis=posuere&libero=cubilia&nullam=curae&sit=donec&amet=pharetra&turpis=magna&elementum=vestibulum&ligula=aliquet&vehicula=ultrices&consequat=erat&morbi=tortor&a=sollicitudin&ipsum=mi&integer=sit&a=amet&nibh=lobortis&in=sapien&quis=sapien&justo=non&maecenas=mi&rhoncus=integer&aliquam=ac&lacus=neque&morbi=duis",
        avatar:
          "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
      },
      creator: {
        name: "Azuki",
        link: "https://posterous.com/ut/nunc/vestibulum/ante/ipsum/primis/in.html?ultricies=maecenas&eu=tristique&nibh=est&quisque=et&id=tempus&justo=semper&sit=est&amet=quam&sapien=pharetra&dignissim=magna&vestibulum=ac&vestibulum=consequat&ante=metus",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 94,
      },
    },
    socialMedia: {
      stats: { favorites: 140802, views: 755214 },
      links: {
        website:
          "https://hp.com/elementum.xml?scelerisque=aliquam&quam=augue&turpis=quam&adipiscing=sollicitudin&lorem=vitae&vitae=consectetuer&mattis=eget&nibh=rutrum&ligula=at&nec=lorem&sem=integer&duis=tincidunt&aliquam=ante&convallis=vel&nunc=ipsum&proin=praesent&at=blandit&turpis=lacinia&a=erat&pede=vestibulum&posuere=sed&nonummy=magna&integer=at&non=nunc",
        discord:
          "http://exblog.jp/dolor/sit/amet/consectetuer/adipiscing/elit.html?volutpat=sapien&dui=non&maecenas=mi&tristique=integer&est=ac&et=neque&tempus=duis&semper=bibendum&est=morbi&quam=non&pharetra=quam&magna=nec&ac=dui&consequat=luctus&metus=rutrum&sapien=nulla&ut=tellus&nunc=in&vestibulum=sagittis&ante=dui&ipsum=vel&primis=nisl&in=duis&faucibus=ac&orci=nibh&luctus=fusce&et=lacus&ultrices=purus&posuere=aliquet&cubilia=at&curae=feugiat&mauris=non&viverra=pretium&diam=quis&vitae=lectus&quam=suspendisse&suspendisse=potenti&potenti=in&nullam=eleifend&porttitor=quam&lacus=a&at=odio&turpis=in&donec=hac&posuere=habitasse&metus=platea&vitae=dictumst&ipsum=maecenas&aliquam=ut&non=massa&mauris=quis&morbi=augue&non=luctus&lectus=tincidunt&aliquam=nulla",
        medium:
          "https://who.int/commodo.aspx?eget=fusce&tincidunt=posuere&eget=felis&tempus=sed&vel=lacus&pede=morbi&morbi=sem&porttitor=mauris&lorem=laoreet&id=ut&ligula=rhoncus&suspendisse=aliquet&ornare=pulvinar&consequat=sed&lectus=nisl&in=nunc&est=rhoncus&risus=dui&auctor=vel&sed=sem&tristique=sed&in=sagittis&tempus=nam&sit=congue&amet=risus&sem=semper&fusce=porta&consequat=volutpat&nulla=quam&nisl=pede&nunc=lobortis&nisl=ligula&duis=sit&bibendum=amet&felis=eleifend&sed=pede&interdum=libero&venenatis=quis&turpis=orci&enim=nullam&blandit=molestie&mi=nibh&in=in&porttitor=lectus&pede=pellentesque&justo=at&eu=nulla&massa=suspendisse&donec=potenti&dapibus=cras&duis=in&at=purus&velit=eu&eu=magna&est=vulputate&congue=luctus&elementum=cum&in=sociis&hac=natoque&habitasse=penatibus&platea=et&dictumst=magnis&morbi=dis&vestibulum=parturient&velit=montes&id=nascetur&pretium=ridiculus&iaculis=mus&diam=vivamus&erat=vestibulum&fermentum=sagittis&justo=sapien&nec=cum&condimentum=sociis&neque=natoque&sapien=penatibus&placerat=et&ante=magnis&nulla=dis&justo=parturient&aliquam=montes&quis=nascetur&turpis=ridiculus&eget=mus&elit=etiam&sodales=vel&scelerisque=augue&mauris=vestibulum&sit=rutrum&amet=rutrum&eros=neque&suspendisse=aenean",
        telegram:
          "https://geocities.com/vestibulum/quam/sapien/varius/ut.xml?non=blandit&ligula=nam&pellentesque=nulla&ultrices=integer&phasellus=pede&id=justo&sapien=lacinia&in=eget&sapien=tincidunt&iaculis=eget&congue=tempus&vivamus=vel&metus=pede&arcu=morbi&adipiscing=porttitor&molestie=lorem&hendrerit=id&at=ligula&vulputate=suspendisse&vitae=ornare&nisl=consequat&aenean=lectus&lectus=in&pellentesque=est&eget=risus&nunc=auctor&donec=sed&quis=tristique&orci=in&eget=tempus&orci=sit&vehicula=amet&condimentum=sem&curabitur=fusce&in=consequat&libero=nulla&ut=nisl&massa=nunc&volutpat=nisl&convallis=duis&morbi=bibendum",
        instagram:
          "http://over-blog.com/pellentesque/volutpat/dui/maecenas.png?amet=tincidunt&sapien=ante&dignissim=vel",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Female" },
      stats: null,
      details: {
        dropDate: "9/22/2021",
        listPrice: 50,
        editionSupply: 8,
        edition: 5,
        editionType: "Common",
        season: 3,
        rarity: "One of a kind",
        license: "DC",
        brand: "Batman",
        collection: "Next Generation",
        series: "Batman - Next Generation",
        annotations: [],
        description:
          "in hac habitasse platea dictumst aliquam augue quam sollicitudin vitae consectetuer",
      },
    },
    auction: "15-Oct-2021 05:33:33",
    price: {
      amount: 273.7,
      currency: "ETH",
      history: [
        { amount: 913.94, currency: "SOL", date: "03/24/2022 17:12:12" },
        { amount: 107.95, currency: "SOL", date: "03/31/2022 20:20:20" },
        { amount: 921.89, currency: "MATIC", date: "08/21/2021 10:55:55" },
        { amount: 820.73, currency: "ETH", date: "01/24/2022 23:23:23" },
        { amount: 452.51, currency: "SOL", date: "11/05/2021 00:00:00" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "04/23/2021 20:20:20",
          amount: 470.36,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "12/30/2021 20:20:20",
          amount: 280.55,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "09/23/2021 17:12:12",
          amount: 243.26,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 280.05,
          currency: "BUSD",
          expiration: "11/16/2021 17:12:12",
          from: "Winni",
        },
        {
          active: false,
          amount: 218.84,
          currency: "BUSD",
          expiration: "12/22/2021 10:55:55",
          from: "Eda",
        },
      ],
    },
    listings: [],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 7.07 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "07/16/2021 00:00:00",
        transaction: "0x465f35934f6c6b40cf889868788626f9a1a2dd5b",
      },
      {
        type: "Sale",
        cost: { amount: 9.07, currency: "ETH", usdEquivalent: 7.22 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "01/09/2022 23:23:23",
        transaction: "0x0afa700fd262d2ac7e58939f928b490bf19319ef",
      },
    ],
    more: [{ id: 1 }, { id: 1 }],
  },
  {
    id: 15,
    general: {
      name: "Ginnifer",
      src: "https://lh3.googleusercontent.com/vxPRqRqF5XXXiKcY2WmySxPph8n8DIT4-9lUcGPOOf5FDxzODslqcSy5kr5gt8gEI6c20fDmWTMi9CH86GlPo5wuTMbiuFmCPV2q=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: true,
      link: "http://goo.gl/nulla/ut/erat.json?blandit=rutrum&ultrices=at&enim=lorem&lorem=integer&ipsum=tincidunt&dolor=ante&sit=vel&amet=ipsum&consectetuer=praesent&adipiscing=blandit&elit=lacinia&proin=erat&interdum=vestibulum&mauris=sed&non=magna&ligula=at&pellentesque=nunc&ultrices=commodo&phasellus=placerat&id=praesent&sapien=blandit&in=nam&sapien=nulla&iaculis=integer&congue=pede&vivamus=justo&metus=lacinia&arcu=eget&adipiscing=tincidunt&molestie=eget&hendrerit=tempus&at=vel&vulputate=pede&vitae=morbi&nisl=porttitor&aenean=lorem&lectus=id&pellentesque=ligula&eget=suspendisse&nunc=ornare&donec=consequat&quis=lectus&orci=in&eget=est&orci=risus&vehicula=auctor&condimentum=sed&curabitur=tristique&in=in&libero=tempus&ut=sit&massa=amet&volutpat=sem&convallis=fusce&morbi=consequat&odio=nulla&odio=nisl&elementum=nunc&eu=nisl&interdum=duis&eu=bibendum&tincidunt=felis&in=sed&leo=interdum&maecenas=venenatis&pulvinar=turpis&lobortis=enim&est=blandit&phasellus=mi&sit=in&amet=porttitor&erat=pede&nulla=justo&tempus=eu&vivamus=massa&in=donec&felis=dapibus&eu=duis&sapien=at&cursus=velit&vestibulum=eu&proin=est",
    },
    contract: {
      contractAddress: "0xa4fec2190ee8a1d05da7aa559d697b96bd25485b",
      tokenID: 7481,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Nickolas",
        link: "http://odnoklassniki.ru/turpis.aspx?sit=augue&amet=quam&eleifend=sollicitudin&pede=vitae&libero=consectetuer&quis=eget&orci=rutrum&nullam=at&molestie=lorem&nibh=integer&in=tincidunt&lectus=ante&pellentesque=vel&at=ipsum&nulla=praesent&suspendisse=blandit&potenti=lacinia&cras=erat&in=vestibulum&purus=sed&eu=magna&magna=at&vulputate=nunc&luctus=commodo&cum=placerat&sociis=praesent&natoque=blandit&penatibus=nam&et=nulla&magnis=integer&dis=pede&parturient=justo&montes=lacinia&nascetur=eget&ridiculus=tincidunt&mus=eget&vivamus=tempus&vestibulum=vel&sagittis=pede&sapien=morbi&cum=porttitor&sociis=lorem&natoque=id&penatibus=ligula&et=suspendisse&magnis=ornare&dis=consequat&parturient=lectus&montes=in&nascetur=est&ridiculus=risus&mus=auctor&etiam=sed&vel=tristique&augue=in&vestibulum=tempus&rutrum=sit&rutrum=amet&neque=sem&aenean=fusce&auctor=consequat&gravida=nulla&sem=nisl&praesent=nunc&id=nisl&massa=duis&id=bibendum&nisl=felis&venenatis=sed&lacinia=interdum&aenean=venenatis&sit=turpis&amet=enim&justo=blandit&morbi=mi&ut=in&odio=porttitor&cras=pede",
        avatar:
          "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "https://auda.org.au/aliquet/maecenas/leo/odio.jsp?vestibulum=nunc&rutrum=vestibulum&rutrum=ante&neque=ipsum&aenean=primis&auctor=in&gravida=faucibus&sem=orci&praesent=luctus&id=et&massa=ultrices&id=posuere&nisl=cubilia&venenatis=curae&lacinia=mauris&aenean=viverra&sit=diam&amet=vitae&justo=quam&morbi=suspendisse&ut=potenti&odio=nullam&cras=porttitor&mi=lacus&pede=at&malesuada=turpis&in=donec&imperdiet=posuere&et=metus&commodo=vitae&vulputate=ipsum&justo=aliquam&in=non&blandit=mauris&ultrices=morbi&enim=non&lorem=lectus&ipsum=aliquam&dolor=sit&sit=amet&amet=diam&consectetuer=in&adipiscing=magna&elit=bibendum&proin=imperdiet&interdum=nullam&mauris=orci&non=pede&ligula=venenatis&pellentesque=non&ultrices=sodales&phasellus=sed&id=tincidunt&sapien=eu&in=felis&sapien=fusce&iaculis=posuere&congue=felis&vivamus=sed&metus=lacus&arcu=morbi&adipiscing=sem&molestie=mauris&hendrerit=laoreet&at=ut&vulputate=rhoncus&vitae=aliquet&nisl=pulvinar&aenean=sed&lectus=nisl&pellentesque=nunc&eget=rhoncus&nunc=dui&donec=vel&quis=sem&orci=sed&eget=sagittis&orci=nam&vehicula=congue&condimentum=risus&curabitur=semper&in=porta&libero=volutpat&ut=quam&massa=pede&volutpat=lobortis",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 92,
      },
    },
    socialMedia: {
      stats: { favorites: 491435, views: 126524 },
      links: {
        website:
          "http://apache.org/amet/justo.aspx?ligula=morbi&vehicula=a&consequat=ipsum&morbi=integer&a=a",
        discord:
          "http://spiegel.de/porttitor/id/consequat/in/consequat/ut/nulla.json?purus=eu&phasellus=sapien&in=cursus&felis=vestibulum&donec=proin&semper=eu&sapien=mi&a=nulla&libero=ac&nam=enim&dui=in&proin=tempor&leo=turpis&odio=nec&porttitor=euismod&id=scelerisque&consequat=quam&in=turpis&consequat=adipiscing&ut=lorem&nulla=vitae&sed=mattis&accumsan=nibh&felis=ligula&ut=nec&at=sem&dolor=duis&quis=aliquam&odio=convallis&consequat=nunc&varius=proin&integer=at&ac=turpis&leo=a&pellentesque=pede&ultrices=posuere&mattis=nonummy&odio=integer&donec=non&vitae=velit&nisi=donec&nam=diam&ultrices=neque&libero=vestibulum&non=eget&mattis=vulputate&pulvinar=ut&nulla=ultrices&pede=vel&ullamcorper=augue&augue=vestibulum&a=ante&suscipit=ipsum&nulla=primis&elit=in&ac=faucibus&nulla=orci&sed=luctus&vel=et&enim=ultrices&sit=posuere&amet=cubilia&nunc=curae&viverra=donec&dapibus=pharetra&nulla=magna&suscipit=vestibulum&ligula=aliquet&in=ultrices&lacus=erat&curabitur=tortor&at=sollicitudin&ipsum=mi&ac=sit&tellus=amet&semper=lobortis&interdum=sapien&mauris=sapien&ullamcorper=non&purus=mi&sit=integer&amet=ac&nulla=neque&quisque=duis&arcu=bibendum&libero=morbi&rutrum=non&ac=quam&lobortis=nec&vel=dui&dapibus=luctus&at=rutrum&diam=nulla",
        medium:
          "http://statcounter.com/ante.png?tellus=nec&nisi=molestie&eu=sed&orci=justo&mauris=pellentesque&lacinia=viverra&sapien=pede&quis=ac&libero=diam&nullam=cras&sit=pellentesque&amet=volutpat&turpis=dui&elementum=maecenas&ligula=tristique&vehicula=est&consequat=et&morbi=tempus&a=semper&ipsum=est&integer=quam&a=pharetra&nibh=magna&in=ac&quis=consequat&justo=metus&maecenas=sapien&rhoncus=ut&aliquam=nunc&lacus=vestibulum&morbi=ante&quis=ipsum&tortor=primis&id=in&nulla=faucibus&ultrices=orci&aliquet=luctus&maecenas=et&leo=ultrices&odio=posuere&condimentum=cubilia&id=curae&luctus=mauris&nec=viverra&molestie=diam&sed=vitae&justo=quam&pellentesque=suspendisse&viverra=potenti&pede=nullam&ac=porttitor&diam=lacus&cras=at&pellentesque=turpis&volutpat=donec&dui=posuere&maecenas=metus&tristique=vitae&est=ipsum&et=aliquam&tempus=non&semper=mauris&est=morbi&quam=non&pharetra=lectus&magna=aliquam&ac=sit&consequat=amet&metus=diam&sapien=in&ut=magna&nunc=bibendum&vestibulum=imperdiet&ante=nullam&ipsum=orci&primis=pede&in=venenatis&faucibus=non&orci=sodales&luctus=sed&et=tincidunt&ultrices=eu&posuere=felis&cubilia=fusce",
        telegram:
          "https://netvibes.com/feugiat/et/eros/vestibulum/ac/est/lacinia.jsp?diam=eget&cras=massa&pellentesque=tempor&volutpat=convallis",
        instagram:
          "https://w3.org/lacus/morbi/sem/mauris/laoreet.json?nibh=at&fusce=vulputate&lacus=vitae&purus=nisl&aliquet=aenean&at=lectus&feugiat=pellentesque&non=eget&pretium=nunc&quis=donec&lectus=quis",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "12/2/2021",
        listPrice: 10,
        editionSupply: 5,
        edition: 3,
        editionType: "Unique",
        season: 2,
        rarity: "Secret",
        license: "Disney",
        brand: "Robin",
        collection: "Zombie",
        series: "Robin - Zombie",
        annotations: ["Generation", "Zombie"],
        description:
          "sit amet cursus id turpis integer aliquet massa id lobortis convallis tortor risus dapibus augue vel accumsan tellus nisi",
      },
    },
    auction: "21-Aug-2021 23:23:23",
    price: {
      amount: 408.42,
      currency: "SOL",
      history: [
        { amount: 630.59, currency: "MATIC", date: "05/02/2021 00:00:00" },
        { amount: 893.16, currency: "ETH", date: "03/14/2022 00:00:00" },
        { amount: 192.44, currency: "SOL", date: "04/05/2022 00:00:00" },
        { amount: 355.25, currency: "MATIC", date: "12/16/2021 20:20:20" },
        { amount: 386.17, currency: "ETH", date: "03/22/2022 23:23:23" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "08/07/2021 10:55:55",
          amount: 561329.14,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "09/17/2021 10:55:55",
          amount: 42.79,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 524.6,
          currency: "BUSD",
          expiration: "09/19/2021 00:00:00",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 705.78,
          currency: "BUSD",
          expiration: "05/27/2021 10:55:55",
          from: "Raymund",
        },
        {
          active: false,
          amount: 525.18,
          currency: "BUSD",
          expiration: "03/08/2022 05:33:33",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 360.46,
          currency: "BUSD",
          expiration: "04/06/2022 17:12:12",
          from: "Winni",
        },
        {
          active: false,
          amount: 917.68,
          currency: "BUSD",
          expiration: "09/13/2021 10:55:55",
          from: "Eda",
        },
      ],
    },
    listings: [],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 9.84 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "04/23/2021 05:33:33",
        transaction: "0x9050f3a838285cea4091f19cdc4bebfdbe5e3a7d",
      },
    ],
    more: [{ id: 1 }, { id: 1 }, { id: 0 }, { id: 2 }],
  },
  {
    id: 16,
    general: {
      name: "Deana",
      src: "https://lh3.googleusercontent.com/3rllkFLC_4ZIjcKi9tKHfVMvhcaSw9SLaJ8GbOGg5Joouct5bpdeBNJLz3t9Tt1Q1YiDGsfA_mO8nlBlLsZxJ53ZG4yR_MpDU327Ji0=w206",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: false,
      link: "https://jugem.jp/duis/bibendum.jpg?nulla=velit&nisl=eu&nunc=est&nisl=congue&duis=elementum&bibendum=in&felis=hac&sed=habitasse&interdum=platea&venenatis=dictumst&turpis=morbi&enim=vestibulum&blandit=velit&mi=id&in=pretium&porttitor=iaculis&pede=diam&justo=erat&eu=fermentum&massa=justo&donec=nec&dapibus=condimentum&duis=neque&at=sapien&velit=placerat&eu=ante&est=nulla&congue=justo&elementum=aliquam&in=quis&hac=turpis&habitasse=eget",
    },
    contract: {
      contractAddress: "0xe4a0c250c93361c4504af97a23aa28cb1010df17",
      tokenID: 543,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Winni",
        link: "http://upenn.edu/nulla/nisl/nunc/nisl/duis.jsp?odio=nunc&odio=commodo&elementum=placerat&eu=praesent&interdum=blandit&eu=nam&tincidunt=nulla&in=integer&leo=pede&maecenas=justo&pulvinar=lacinia&lobortis=eget&est=tincidunt&phasellus=eget&sit=tempus&amet=vel&erat=pede&nulla=morbi&tempus=porttitor&vivamus=lorem&in=id&felis=ligula&eu=suspendisse",
        avatar:
          "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "http://squarespace.com/purus/phasellus/in.json?augue=porttitor&luctus=id&tincidunt=consequat&nulla=in&mollis=consequat&molestie=ut&lorem=nulla&quisque=sed&ut=accumsan&erat=felis&curabitur=ut&gravida=at&nisi=dolor&at=quis&nibh=odio&in=consequat&hac=varius&habitasse=integer&platea=ac&dictumst=leo&aliquam=pellentesque&augue=ultrices&quam=mattis&sollicitudin=odio&vitae=donec&consectetuer=vitae&eget=nisi&rutrum=nam&at=ultrices&lorem=libero&integer=non&tincidunt=mattis&ante=pulvinar&vel=nulla&ipsum=pede&praesent=ullamcorper&blandit=augue&lacinia=a&erat=suscipit&vestibulum=nulla&sed=elit&magna=ac&at=nulla&nunc=sed&commodo=vel&placerat=enim&praesent=sit&blandit=amet&nam=nunc&nulla=viverra&integer=dapibus&pede=nulla&justo=suscipit&lacinia=ligula&eget=in&tincidunt=lacus&eget=curabitur&tempus=at",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 77,
      },
    },
    socialMedia: {
      stats: { favorites: 731671, views: 899700 },
      links: {
        website:
          "http://ucsd.edu/platea/dictumst/morbi.js?tortor=id&quis=pretium&turpis=iaculis&sed=diam&ante=erat&vivamus=fermentum&tortor=justo&duis=nec&mattis=condimentum&egestas=neque&metus=sapien&aenean=placerat&fermentum=ante&donec=nulla&ut=justo&mauris=aliquam&eget=quis&massa=turpis&tempor=eget&convallis=elit&nulla=sodales&neque=scelerisque&libero=mauris&convallis=sit&eget=amet&eleifend=eros&luctus=suspendisse&ultricies=accumsan&eu=tortor&nibh=quis&quisque=turpis&id=sed&justo=ante&sit=vivamus&amet=tortor&sapien=duis&dignissim=mattis&vestibulum=egestas&vestibulum=metus&ante=aenean&ipsum=fermentum&primis=donec&in=ut&faucibus=mauris&orci=eget&luctus=massa&et=tempor&ultrices=convallis&posuere=nulla&cubilia=neque&curae=libero&nulla=convallis&dapibus=eget&dolor=eleifend&vel=luctus&est=ultricies&donec=eu&odio=nibh&justo=quisque&sollicitudin=id&ut=justo&suscipit=sit&a=amet&feugiat=sapien&et=dignissim&eros=vestibulum&vestibulum=vestibulum&ac=ante",
        discord:
          "https://businessinsider.com/pede.png?quis=rhoncus&libero=aliquam&nullam=lacus&sit=morbi&amet=quis&turpis=tortor&elementum=id&ligula=nulla&vehicula=ultrices&consequat=aliquet&morbi=maecenas&a=leo&ipsum=odio&integer=condimentum&a=id&nibh=luctus&in=nec&quis=molestie&justo=sed&maecenas=justo&rhoncus=pellentesque&aliquam=viverra&lacus=pede&morbi=ac&quis=diam&tortor=cras&id=pellentesque&nulla=volutpat&ultrices=dui&aliquet=maecenas&maecenas=tristique&leo=est&odio=et&condimentum=tempus&id=semper&luctus=est&nec=quam&molestie=pharetra&sed=magna&justo=ac&pellentesque=consequat&viverra=metus&pede=sapien&ac=ut&diam=nunc&cras=vestibulum",
        medium:
          "http://example.com/lacinia/eget.png?congue=condimentum&risus=id&semper=luctus&porta=nec&volutpat=molestie&quam=sed&pede=justo&lobortis=pellentesque&ligula=viverra&sit=pede&amet=ac&eleifend=diam&pede=cras&libero=pellentesque&quis=volutpat&orci=dui&nullam=maecenas&molestie=tristique&nibh=est&in=et&lectus=tempus&pellentesque=semper&at=est&nulla=quam&suspendisse=pharetra&potenti=magna&cras=ac&in=consequat&purus=metus&eu=sapien&magna=ut&vulputate=nunc&luctus=vestibulum&cum=ante&sociis=ipsum&natoque=primis&penatibus=in&et=faucibus&magnis=orci&dis=luctus&parturient=et&montes=ultrices&nascetur=posuere&ridiculus=cubilia&mus=curae&vivamus=mauris&vestibulum=viverra&sagittis=diam&sapien=vitae&cum=quam&sociis=suspendisse&natoque=potenti&penatibus=nullam&et=porttitor&magnis=lacus&dis=at&parturient=turpis&montes=donec&nascetur=posuere&ridiculus=metus&mus=vitae&etiam=ipsum&vel=aliquam&augue=non&vestibulum=mauris&rutrum=morbi&rutrum=non&neque=lectus&aenean=aliquam&auctor=sit&gravida=amet&sem=diam&praesent=in&id=magna&massa=bibendum&id=imperdiet&nisl=nullam&venenatis=orci&lacinia=pede&aenean=venenatis&sit=non&amet=sodales&justo=sed&morbi=tincidunt&ut=eu&odio=felis&cras=fusce&mi=posuere&pede=felis",
        telegram:
          "https://blog.com/tortor/duis/mattis/egestas/metus/aenean.js?habitasse=nulla&platea=sed&dictumst=accumsan&morbi=felis&vestibulum=ut&velit=at&id=dolor&pretium=quis&iaculis=odio&diam=consequat&erat=varius&fermentum=integer&justo=ac&nec=leo",
        instagram:
          "https://qq.com/malesuada/in/imperdiet/et.jpg?etiam=luctus&justo=et&etiam=ultrices&pretium=posuere&iaculis=cubilia&justo=curae&in=duis&hac=faucibus&habitasse=accumsan&platea=odio&dictumst=curabitur&etiam=convallis&faucibus=duis&cursus=consequat&urna=dui&ut=nec&tellus=nisi&nulla=volutpat&ut=eleifend&erat=donec&id=ut&mauris=dolor&vulputate=morbi",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Female" },
      stats: null,
      details: {
        dropDate: "8/24/2021",
        listPrice: 86,
        editionSupply: 8,
        edition: 2,
        editionType: "Rare",
        season: 1,
        rarity: "Common",
        license: "DC",
        brand: "Robin",
        collection: "Old School",
        series: "Robin - Old School",
        annotations: [],
        description:
          "ultrices phasellus id sapien in sapien iaculis congue vivamus metus arcu adipiscing molestie hendrerit at vulputate vitae nisl aenean lectus",
      },
    },
    auction: "01-Mar-2022 05:33:33",
    price: { amount: 655.35, currency: "SOL", history: [] },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [],
      history: [
        {
          active: false,
          amount: 148.48,
          currency: "BUSD",
          expiration: "03/25/2022 05:33:33",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 337.85,
          currency: "BUSD",
          expiration: "08/15/2021 23:23:23",
          from: "Raymund",
        },
        {
          active: false,
          amount: 805.74,
          currency: "BUSD",
          expiration: "03/25/2022 20:20:20",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 638.75,
          currency: "BUSD",
          expiration: "03/17/2022 00:00:00",
          from: "Winni",
        },
        {
          active: false,
          amount: 98.98,
          currency: "BUSD",
          expiration: "08/26/2021 17:12:12",
          from: "Eda",
        },
      ],
    },
    listings: [
      {
        amount: 9.66,
        currency: "ETH",
        expiration: "09/18/2021 00:00:00",
        addDate: "11/25/2021 05:33:33",
        from: "Nickolas",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "MATIC", usdEquivalent: 8.94 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "02/02/2022 00:00:00",
        transaction: "0x9b097622c8e99279d34a195d8055c9db1c72804a",
      },
    ],
    more: [{ id: 0 }, { id: 0 }, { id: 2 }],
  },
  {
    id: 17,
    general: {
      name: "Worth",
      src: "https://lh3.googleusercontent.com/kR7YztId1NIN9dmJO41Bb0ZlwvwBsBfl9-JhptqriL1laOqaZ6b_lCOi2WukIqxE0f7DMJ_sSvhYkaElNGvY2tA=w206",
    },
    project: {
      name: "Azuki",
      isVerified: true,
      link: "http://rediff.com/primis/in/faucibus/orci/luctus/et/ultrices.jpg?eu=sit&massa=amet&donec=justo&dapibus=morbi&duis=ut&at=odio&velit=cras&eu=mi&est=pede&congue=malesuada&elementum=in&in=imperdiet&hac=et&habitasse=commodo&platea=vulputate&dictumst=justo&morbi=in&vestibulum=blandit&velit=ultrices&id=enim&pretium=lorem&iaculis=ipsum&diam=dolor&erat=sit&fermentum=amet&justo=consectetuer&nec=adipiscing&condimentum=elit&neque=proin&sapien=interdum&placerat=mauris&ante=non&nulla=ligula&justo=pellentesque&aliquam=ultrices&quis=phasellus&turpis=id&eget=sapien&elit=in&sodales=sapien&scelerisque=iaculis&mauris=congue&sit=vivamus&amet=metus&eros=arcu&suspendisse=adipiscing&accumsan=molestie&tortor=hendrerit&quis=at&turpis=vulputate&sed=vitae&ante=nisl&vivamus=aenean&tortor=lectus&duis=pellentesque&mattis=eget&egestas=nunc&metus=donec&aenean=quis",
    },
    contract: {
      contractAddress: "0xea06b3e8df149fc8e891770fbbb8a57d9b950f1c",
      tokenID: 3935,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Eda",
        link: "https://naver.com/ipsum/dolor/sit/amet.xml?morbi=gravida&non=sem&quam=praesent&nec=id&dui=massa&luctus=id&rutrum=nisl&nulla=venenatis&tellus=lacinia&in=aenean&sagittis=sit&dui=amet&vel=justo&nisl=morbi&duis=ut&ac=odio&nibh=cras&fusce=mi&lacus=pede&purus=malesuada&aliquet=in&at=imperdiet&feugiat=et&non=commodo&pretium=vulputate&quis=justo&lectus=in&suspendisse=blandit&potenti=ultrices&in=enim&eleifend=lorem&quam=ipsum&a=dolor",
        avatar:
          "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "http://mozilla.org/a/pede/posuere/nonummy/integer/non.js?ultrices=venenatis&enim=turpis&lorem=enim&ipsum=blandit&dolor=mi&sit=in&amet=porttitor&consectetuer=pede&adipiscing=justo&elit=eu&proin=massa&interdum=donec&mauris=dapibus&non=duis&ligula=at&pellentesque=velit&ultrices=eu&phasellus=est&id=congue&sapien=elementum&in=in&sapien=hac&iaculis=habitasse&congue=platea&vivamus=dictumst&metus=morbi&arcu=vestibulum&adipiscing=velit&molestie=id&hendrerit=pretium&at=iaculis&vulputate=diam&vitae=erat&nisl=fermentum&aenean=justo&lectus=nec&pellentesque=condimentum&eget=neque&nunc=sapien&donec=placerat&quis=ante&orci=nulla&eget=justo&orci=aliquam&vehicula=quis&condimentum=turpis&curabitur=eget&in=elit&libero=sodales&ut=scelerisque&massa=mauris&volutpat=sit&convallis=amet&morbi=eros&odio=suspendisse&odio=accumsan&elementum=tortor&eu=quis&interdum=turpis&eu=sed&tincidunt=ante",
        avatar:
          "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s64",
        royalties: 83,
      },
    },
    socialMedia: {
      stats: { favorites: 448592, views: 935844 },
      links: {
        website:
          "http://godaddy.com/nam.aspx?fusce=vitae&posuere=ipsum&felis=aliquam&sed=non&lacus=mauris&morbi=morbi&sem=non&mauris=lectus&laoreet=aliquam&ut=sit&rhoncus=amet&aliquet=diam&pulvinar=in&sed=magna&nisl=bibendum&nunc=imperdiet&rhoncus=nullam&dui=orci&vel=pede&sem=venenatis&sed=non&sagittis=sodales&nam=sed&congue=tincidunt&risus=eu&semper=felis&porta=fusce&volutpat=posuere&quam=felis&pede=sed&lobortis=lacus&ligula=morbi&sit=sem&amet=mauris&eleifend=laoreet&pede=ut&libero=rhoncus&quis=aliquet&orci=pulvinar&nullam=sed&molestie=nisl&nibh=nunc&in=rhoncus&lectus=dui&pellentesque=vel&at=sem&nulla=sed&suspendisse=sagittis&potenti=nam&cras=congue&in=risus&purus=semper&eu=porta&magna=volutpat&vulputate=quam&luctus=pede&cum=lobortis&sociis=ligula&natoque=sit&penatibus=amet&et=eleifend&magnis=pede&dis=libero&parturient=quis&montes=orci&nascetur=nullam&ridiculus=molestie&mus=nibh&vivamus=in&vestibulum=lectus&sagittis=pellentesque&sapien=at&cum=nulla&sociis=suspendisse&natoque=potenti&penatibus=cras&et=in&magnis=purus&dis=eu&parturient=magna&montes=vulputate&nascetur=luctus&ridiculus=cum&mus=sociis&etiam=natoque&vel=penatibus&augue=et&vestibulum=magnis&rutrum=dis",
        discord:
          "http://dagondesign.com/ante/nulla/justo/aliquam/quis/turpis/eget.html?morbi=convallis&porttitor=duis&lorem=consequat&id=dui&ligula=nec&suspendisse=nisi&ornare=volutpat&consequat=eleifend&lectus=donec&in=ut",
        medium:
          "http://abc.net.au/cum/sociis/natoque/penatibus/et/magnis/dis.png?amet=magna&eros=vestibulum&suspendisse=aliquet&accumsan=ultrices&tortor=erat&quis=tortor&turpis=sollicitudin&sed=mi&ante=sit&vivamus=amet&tortor=lobortis&duis=sapien&mattis=sapien&egestas=non&metus=mi&aenean=integer&fermentum=ac&donec=neque&ut=duis&mauris=bibendum&eget=morbi&massa=non&tempor=quam&convallis=nec&nulla=dui&neque=luctus&libero=rutrum&convallis=nulla&eget=tellus&eleifend=in&luctus=sagittis&ultricies=dui&eu=vel&nibh=nisl&quisque=duis&id=ac&justo=nibh&sit=fusce&amet=lacus&sapien=purus&dignissim=aliquet&vestibulum=at&vestibulum=feugiat&ante=non&ipsum=pretium&primis=quis&in=lectus&faucibus=suspendisse&orci=potenti&luctus=in&et=eleifend&ultrices=quam&posuere=a&cubilia=odio&curae=in&nulla=hac&dapibus=habitasse&dolor=platea&vel=dictumst&est=maecenas&donec=ut&odio=massa&justo=quis&sollicitudin=augue&ut=luctus&suscipit=tincidunt&a=nulla&feugiat=mollis&et=molestie&eros=lorem&vestibulum=quisque&ac=ut&est=erat&lacinia=curabitur&nisi=gravida&venenatis=nisi&tristique=at&fusce=nibh&congue=in&diam=hac&id=habitasse&ornare=platea&imperdiet=dictumst&sapien=aliquam&urna=augue&pretium=quam&nisl=sollicitudin&ut=vitae&volutpat=consectetuer&sapien=eget",
        telegram:
          "http://delicious.com/rutrum/at/lorem/integer.xml?eget=nisl&semper=aenean&rutrum=lectus&nulla=pellentesque&nunc=eget&purus=nunc&phasellus=donec&in=quis&felis=orci&donec=eget&semper=orci&sapien=vehicula&a=condimentum&libero=curabitur&nam=in&dui=libero&proin=ut&leo=massa&odio=volutpat&porttitor=convallis&id=morbi&consequat=odio&in=odio&consequat=elementum&ut=eu&nulla=interdum&sed=eu&accumsan=tincidunt&felis=in&ut=leo&at=maecenas&dolor=pulvinar&quis=lobortis&odio=est&consequat=phasellus&varius=sit&integer=amet&ac=erat&leo=nulla&pellentesque=tempus&ultrices=vivamus&mattis=in&odio=felis&donec=eu&vitae=sapien&nisi=cursus&nam=vestibulum&ultrices=proin&libero=eu&non=mi&mattis=nulla&pulvinar=ac&nulla=enim&pede=in&ullamcorper=tempor&augue=turpis&a=nec&suscipit=euismod&nulla=scelerisque&elit=quam&ac=turpis&nulla=adipiscing&sed=lorem&vel=vitae&enim=mattis&sit=nibh&amet=ligula&nunc=nec&viverra=sem&dapibus=duis&nulla=aliquam&suscipit=convallis&ligula=nunc&in=proin&lacus=at&curabitur=turpis&at=a&ipsum=pede&ac=posuere&tellus=nonummy&semper=integer&interdum=non&mauris=velit&ullamcorper=donec",
        instagram:
          "http://irs.gov/suspendisse/potenti/cras/in/purus.js?in=mi&blandit=in&ultrices=porttitor&enim=pede&lorem=justo&ipsum=eu&dolor=massa&sit=donec&amet=dapibus&consectetuer=duis&adipiscing=at&elit=velit&proin=eu&interdum=est&mauris=congue&non=elementum&ligula=in&pellentesque=hac&ultrices=habitasse&phasellus=platea&id=dictumst&sapien=morbi&in=vestibulum&sapien=velit&iaculis=id&congue=pretium&vivamus=iaculis&metus=diam&arcu=erat&adipiscing=fermentum&molestie=justo&hendrerit=nec&at=condimentum&vulputate=neque&vitae=sapien&nisl=placerat&aenean=ante&lectus=nulla&pellentesque=justo&eget=aliquam&nunc=quis&donec=turpis&quis=eget&orci=elit&eget=sodales&orci=scelerisque&vehicula=mauris&condimentum=sit&curabitur=amet&in=eros&libero=suspendisse&ut=accumsan&massa=tortor&volutpat=quis&convallis=turpis&morbi=sed&odio=ante&odio=vivamus&elementum=tortor&eu=duis&interdum=mattis&eu=egestas&tincidunt=metus&in=aenean&leo=fermentum&maecenas=donec&pulvinar=ut&lobortis=mauris&est=eget&phasellus=massa&sit=tempor&amet=convallis&erat=nulla&nulla=neque",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Female" },
      stats: null,
      details: {
        dropDate: "10/25/2021",
        listPrice: 27,
        editionSupply: 7,
        edition: 3,
        editionType: "Common",
        season: 3,
        rarity: "Common",
        license: "Marvel",
        brand: "Robin",
        collection: "Zombie",
        series: "Robin - Zombie",
        annotations: ["Zombie", "Generation"],
        description:
          "sollicitudin vitae consectetuer eget rutrum at lorem integer tincidunt ante vel ipsum praesent blandit lacinia erat vestibulum",
      },
    },
    auction: "20-Aug-2021 00:00:00",
    price: {
      amount: 861.54,
      currency: "MATIC",
      history: [
        { amount: 439.61, currency: "MATIC", date: "10/14/2021 23:23:23" },
        { amount: 260.81, currency: "ETH", date: "07/24/2021 00:00:00" },
        { amount: 561.41, currency: "SOL", date: "04/29/2021 20:20:20" },
        { amount: 29.86, currency: "SOL", date: "08/17/2021 17:12:12" },
        { amount: 798.1, currency: "ETH", date: "05/03/2021 10:55:55" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "07/12/2021 00:00:00",
          amount: 670.9,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "01/14/2022 20:20:20",
          amount: 312.7,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "04/28/2021 20:20:20",
          amount: 233.84,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "06/04/2021 10:55:55",
          amount: 6.44,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 209.25,
          currency: "BUSD",
          expiration: "05/03/2021 23:23:23",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 891.36,
          currency: "BUSD",
          expiration: "01/04/2022 23:23:23",
          from: "Raymund",
        },
        {
          active: false,
          amount: 144.0,
          currency: "BUSD",
          expiration: "12/23/2021 17:12:12",
          from: "Nickolas",
        },
        {
          active: false,
          amount: 688.93,
          currency: "BUSD",
          expiration: "05/12/2021 23:23:23",
          from: "Winni",
        },
      ],
    },
    listings: [
      {
        amount: 2.47,
        currency: "SOL",
        expiration: "11/30/2021 20:20:20",
        addDate: "08/13/2021 00:00:00",
        from: "Winni",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "ETH", usdEquivalent: 2.75 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "11/14/2021 10:55:55",
        transaction: "0xa3ba6ec99d7b8236cfff497418aaf120c91cf5f8",
      },
      {
        type: "Sale",
        cost: { amount: 2.74, currency: "ETH", usdEquivalent: 2.56 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "09/07/2021 00:00:00",
        transaction: "0x23704b109a88d43c5e7aaa3f4e7aeaa2722ce646",
      },
      {
        type: "Transfer",
        cost: { amount: 6.09, currency: "SOL", usdEquivalent: 6.26 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "02/11/2022 05:33:33",
        transaction: "0xd9abe9734764c8a372adff733ce85c28074bb749",
      },
      {
        type: "Bid",
        cost: { amount: 4.36, currency: "MATIC", usdEquivalent: 4.22 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "04/27/2021 20:20:20",
        transaction: "0xbdfb970e1b7155a9bd0c574ff45bebd3accbfceb",
      },
      {
        type: "Bid",
        cost: { amount: 3.92, currency: "MATIC", usdEquivalent: 2.83 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "03/25/2022 10:55:55",
        transaction: "0xa2bf94f41110c8dd10888407612f651e0b465dad",
      },
    ],
    more: [{ id: 1 }, { id: 0 }],
  },
  {
    id: 18,
    general: {
      name: "Larissa",
      src: "https://lh3.googleusercontent.com/5-Nx0qj4MYyHG2-l9p_4U27ly5qddKsaV69Qs295VsXUvgKj0FYmtKq_TFv-ASFa-R9K-q8YnIs6ZSNE04EQvyDe5oIPwz8OUEDzhQ=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: false,
      link: "https://scribd.com/vivamus/metus/arcu/adipiscing.json?sit=vel&amet=augue&eleifend=vestibulum&pede=ante&libero=ipsum&quis=primis&orci=in&nullam=faucibus&molestie=orci&nibh=luctus&in=et&lectus=ultrices&pellentesque=posuere&at=cubilia&nulla=curae&suspendisse=donec&potenti=pharetra&cras=magna&in=vestibulum&purus=aliquet&eu=ultrices&magna=erat&vulputate=tortor&luctus=sollicitudin&cum=mi&sociis=sit&natoque=amet&penatibus=lobortis&et=sapien&magnis=sapien&dis=non&parturient=mi&montes=integer&nascetur=ac&ridiculus=neque&mus=duis&vivamus=bibendum&vestibulum=morbi&sagittis=non&sapien=quam&cum=nec&sociis=dui&natoque=luctus&penatibus=rutrum&et=nulla&magnis=tellus&dis=in&parturient=sagittis&montes=dui&nascetur=vel&ridiculus=nisl&mus=duis&etiam=ac&vel=nibh",
    },
    contract: {
      contractAddress: "0xbd636bac0dc4b4267dfc19afc810258c320a2232",
      tokenID: 2251,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Kristofer",
        link: "https://canalblog.com/id.js?metus=dapibus&vitae=dolor&ipsum=vel&aliquam=est&non=donec&mauris=odio&morbi=justo&non=sollicitudin&lectus=ut&aliquam=suscipit&sit=a&amet=feugiat&diam=et&in=eros&magna=vestibulum&bibendum=ac&imperdiet=est&nullam=lacinia&orci=nisi&pede=venenatis&venenatis=tristique&non=fusce&sodales=congue&sed=diam&tincidunt=id&eu=ornare&felis=imperdiet&fusce=sapien",
        avatar:
          "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "http://plala.or.jp/risus/dapibus/augue/vel.png?lectus=nisi&in=at&quam=nibh&fringilla=in&rhoncus=hac&mauris=habitasse&enim=platea&leo=dictumst&rhoncus=aliquam&sed=augue&vestibulum=quam&sit=sollicitudin&amet=vitae&cursus=consectetuer&id=eget&turpis=rutrum&integer=at&aliquet=lorem&massa=integer&id=tincidunt&lobortis=ante",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 32,
      },
    },
    socialMedia: {
      stats: { favorites: 111232, views: 377139 },
      links: {
        website:
          "https://examiner.com/curae.jsp?sit=mi&amet=pede&eleifend=malesuada&pede=in&libero=imperdiet&quis=et&orci=commodo&nullam=vulputate&molestie=justo&nibh=in&in=blandit&lectus=ultrices&pellentesque=enim&at=lorem&nulla=ipsum&suspendisse=dolor&potenti=sit&cras=amet&in=consectetuer&purus=adipiscing&eu=elit&magna=proin&vulputate=interdum&luctus=mauris&cum=non&sociis=ligula&natoque=pellentesque&penatibus=ultrices&et=phasellus&magnis=id&dis=sapien&parturient=in&montes=sapien&nascetur=iaculis&ridiculus=congue&mus=vivamus&vivamus=metus&vestibulum=arcu&sagittis=adipiscing&sapien=molestie&cum=hendrerit&sociis=at&natoque=vulputate&penatibus=vitae&et=nisl&magnis=aenean&dis=lectus&parturient=pellentesque&montes=eget&nascetur=nunc&ridiculus=donec&mus=quis&etiam=orci&vel=eget&augue=orci&vestibulum=vehicula&rutrum=condimentum&rutrum=curabitur&neque=in&aenean=libero&auctor=ut&gravida=massa&sem=volutpat&praesent=convallis&id=morbi&massa=odio&id=odio&nisl=elementum&venenatis=eu&lacinia=interdum&aenean=eu&sit=tincidunt&amet=in&justo=leo&morbi=maecenas&ut=pulvinar&odio=lobortis&cras=est&mi=phasellus&pede=sit&malesuada=amet&in=erat&imperdiet=nulla&et=tempus&commodo=vivamus&vulputate=in&justo=felis&in=eu",
        discord:
          "https://blog.com/porttitor/lacus/at/turpis.js?praesent=volutpat&blandit=in&nam=congue&nulla=etiam&integer=justo&pede=etiam&justo=pretium&lacinia=iaculis&eget=justo&tincidunt=in&eget=hac&tempus=habitasse&vel=platea&pede=dictumst&morbi=etiam",
        medium:
          "http://miitbeian.gov.cn/ligula.png?odio=volutpat&in=dui&hac=maecenas&habitasse=tristique&platea=est&dictumst=et&maecenas=tempus&ut=semper&massa=est&quis=quam&augue=pharetra&luctus=magna&tincidunt=ac&nulla=consequat&mollis=metus&molestie=sapien&lorem=ut&quisque=nunc&ut=vestibulum&erat=ante&curabitur=ipsum&gravida=primis&nisi=in&at=faucibus&nibh=orci&in=luctus&hac=et&habitasse=ultrices&platea=posuere&dictumst=cubilia&aliquam=curae&augue=mauris&quam=viverra&sollicitudin=diam&vitae=vitae&consectetuer=quam&eget=suspendisse&rutrum=potenti&at=nullam&lorem=porttitor&integer=lacus&tincidunt=at&ante=turpis&vel=donec&ipsum=posuere&praesent=metus&blandit=vitae&lacinia=ipsum&erat=aliquam&vestibulum=non&sed=mauris&magna=morbi&at=non&nunc=lectus&commodo=aliquam&placerat=sit&praesent=amet&blandit=diam&nam=in&nulla=magna&integer=bibendum&pede=imperdiet&justo=nullam&lacinia=orci&eget=pede&tincidunt=venenatis&eget=non&tempus=sodales&vel=sed&pede=tincidunt&morbi=eu&porttitor=felis&lorem=fusce&id=posuere&ligula=felis&suspendisse=sed&ornare=lacus&consequat=morbi&lectus=sem&in=mauris&est=laoreet&risus=ut&auctor=rhoncus&sed=aliquet&tristique=pulvinar&in=sed&tempus=nisl&sit=nunc&amet=rhoncus&sem=dui&fusce=vel&consequat=sem",
        telegram:
          "http://homestead.com/massa/id/lobortis/convallis/tortor/risus/dapibus.html?ligula=integer&suspendisse=a&ornare=nibh&consequat=in&lectus=quis&in=justo&est=maecenas&risus=rhoncus&auctor=aliquam&sed=lacus&tristique=morbi&in=quis&tempus=tortor",
        instagram:
          "http://fda.gov/rutrum.html?tristique=primis&in=in&tempus=faucibus&sit=orci&amet=luctus&sem=et&fusce=ultrices&consequat=posuere&nulla=cubilia&nisl=curae&nunc=nulla&nisl=dapibus&duis=dolor&bibendum=vel&felis=est&sed=donec&interdum=odio&venenatis=justo&turpis=sollicitudin&enim=ut&blandit=suscipit&mi=a&in=feugiat&porttitor=et&pede=eros&justo=vestibulum&eu=ac&massa=est&donec=lacinia&dapibus=nisi&duis=venenatis&at=tristique&velit=fusce&eu=congue&est=diam&congue=id&elementum=ornare&in=imperdiet&hac=sapien&habitasse=urna&platea=pretium&dictumst=nisl&morbi=ut&vestibulum=volutpat&velit=sapien&id=arcu&pretium=sed&iaculis=augue&diam=aliquam&erat=erat&fermentum=volutpat&justo=in&nec=congue&condimentum=etiam&neque=justo&sapien=etiam&placerat=pretium&ante=iaculis&nulla=justo&justo=in&aliquam=hac&quis=habitasse&turpis=platea&eget=dictumst&elit=etiam&sodales=faucibus&scelerisque=cursus&mauris=urna&sit=ut&amet=tellus&eros=nulla&suspendisse=ut&accumsan=erat&tortor=id&quis=mauris&turpis=vulputate&sed=elementum",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: true,
      category: ["art"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "5/6/2021",
        listPrice: 14,
        editionSupply: 2,
        edition: 5,
        editionType: "Common",
        season: 1,
        rarity: "One of a kind",
        license: "Marvel",
        brand: "Robin",
        collection: "Purple",
        series: "Robin - Purple",
        annotations: ["Generation", "Purple"],
        description:
          "purus phasellus in felis donec semper sapien a libero nam dui proin leo odio porttitor id",
      },
    },
    auction: "01-Dec-2021 10:55:55",
    price: {
      amount: 526.64,
      currency: "ETH",
      history: [
        { amount: 769.41, currency: "MATIC", date: "11/13/2021 05:33:33" },
        { amount: 768.35, currency: "MATIC", date: "08/10/2021 05:33:33" },
        { amount: 819.76, currency: "SOL", date: "03/05/2022 17:12:12" },
        { amount: 95.19, currency: "ETH", date: "12/27/2021 05:33:33" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "08/05/2021 20:20:20",
          amount: 330.27,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "01/28/2022 23:23:23",
          amount: 372.34,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "07/16/2021 20:20:20",
          amount: 879.11,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "08/11/2021 23:23:23",
          amount: 779.45,
          currency: "BUSD",
        },
      ],
      history: [],
    },
    listings: [
      {
        amount: 2.93,
        currency: "MATIC",
        expiration: "09/03/2021 23:23:23",
        addDate: "11/29/2021 20:20:20",
        from: "Eda",
      },
      {
        amount: 2.72,
        currency: "ETH",
        expiration: "12/12/2021 17:12:12",
        addDate: "05/20/2021 17:12:12",
        from: "Kristofer",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "ETH", usdEquivalent: 7.72 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "04/02/2022 10:55:55",
        transaction: "0x76e166f293fc2fa7c010941f0a943b12dc59c308",
      },
      {
        type: "Sale",
        cost: { amount: 2.44, currency: "SOL", usdEquivalent: 3.03 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "05/05/2021 05:33:33",
        transaction: "0x29f5c2d37a37e9f04d21ef9a8a0a72876601e730",
      },
      {
        type: "Transfer",
        cost: { amount: 7.45, currency: "ETH", usdEquivalent: 2.87 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "11/12/2021 23:23:23",
        transaction: "0x67d21a7f90096eeb7900f588044557c8637a5269",
      },
      {
        type: "Bid",
        cost: { amount: 7.19, currency: "MATIC", usdEquivalent: 1.84 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "11/29/2021 00:00:00",
        transaction: "0x8a4899c7a8a0d941e8bedc935ceab9aa774e232c",
      },
    ],
    more: [{ id: 2 }],
  },
  {
    id: 19,
    general: {
      name: "Nettie",
      src: "https://lh3.googleusercontent.com/tlMxSh5Rf5FJW_mTTyw8jS_OwdD3BKf2F71Tk3noa1NSJlPTht8dBcm-RjoBiFEFQAkpbpcgXpbkHhdqOArOhxG_4t_mUiNG498WGw=w206",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: false,
      link: "http://twitter.com/pretium/iaculis/diam.jpg?sed=dis&tristique=parturient&in=montes&tempus=nascetur&sit=ridiculus",
    },
    contract: {
      contractAddress: "0xc7fc6f15887fade226d606040fadbe975587ff95",
      tokenID: 7198,
      tokenStandard: "ERC0721",
      blockchain: "Polygon",
      owner: {
        name: "Raymund",
        link: "http://cafepress.com/odio/justo/sollicitudin/ut.html?quisque=morbi&erat=a&eros=ipsum&viverra=integer&eget=a&congue=nibh&eget=in&semper=quis&rutrum=justo&nulla=maecenas&nunc=rhoncus&purus=aliquam&phasellus=lacus&in=morbi&felis=quis&donec=tortor&semper=id&sapien=nulla&a=ultrices&libero=aliquet&nam=maecenas&dui=leo&proin=odio&leo=condimentum&odio=id&porttitor=luctus&id=nec&consequat=molestie&in=sed&consequat=justo&ut=pellentesque&nulla=viverra&sed=pede&accumsan=ac&felis=diam&ut=cras&at=pellentesque&dolor=volutpat&quis=dui&odio=maecenas&consequat=tristique&varius=est&integer=et&ac=tempus&leo=semper&pellentesque=est&ultrices=quam&mattis=pharetra&odio=magna&donec=ac&vitae=consequat&nisi=metus&nam=sapien&ultrices=ut&libero=nunc&non=vestibulum&mattis=ante&pulvinar=ipsum&nulla=primis&pede=in&ullamcorper=faucibus&augue=orci&a=luctus&suscipit=et&nulla=ultrices&elit=posuere&ac=cubilia&nulla=curae&sed=mauris&vel=viverra&enim=diam&sit=vitae&amet=quam&nunc=suspendisse",
        avatar:
          "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "https://cisco.com/at.js?phasellus=vitae&id=nisl&sapien=aenean&in=lectus&sapien=pellentesque",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 13,
      },
    },
    socialMedia: {
      stats: { favorites: 643390, views: 58701 },
      links: {
        website:
          "https://utexas.edu/ante/vivamus/tortor.js?in=turpis&felis=eget&donec=elit&semper=sodales&sapien=scelerisque&a=mauris&libero=sit&nam=amet&dui=eros&proin=suspendisse&leo=accumsan&odio=tortor&porttitor=quis&id=turpis&consequat=sed&in=ante&consequat=vivamus&ut=tortor&nulla=duis&sed=mattis&accumsan=egestas&felis=metus",
        discord:
          "http://elpais.com/est/phasellus/sit.png?potenti=libero&cras=non&in=mattis&purus=pulvinar&eu=nulla&magna=pede&vulputate=ullamcorper&luctus=augue&cum=a&sociis=suscipit&natoque=nulla&penatibus=elit&et=ac&magnis=nulla&dis=sed&parturient=vel&montes=enim&nascetur=sit",
        medium:
          "https://uol.com.br/nulla/suscipit/ligula/in.aspx?tellus=iaculis&in=congue&sagittis=vivamus&dui=metus&vel=arcu&nisl=adipiscing&duis=molestie&ac=hendrerit&nibh=at&fusce=vulputate&lacus=vitae&purus=nisl&aliquet=aenean&at=lectus&feugiat=pellentesque&non=eget&pretium=nunc&quis=donec&lectus=quis&suspendisse=orci&potenti=eget&in=orci&eleifend=vehicula&quam=condimentum&a=curabitur&odio=in&in=libero&hac=ut&habitasse=massa&platea=volutpat&dictumst=convallis&maecenas=morbi&ut=odio&massa=odio&quis=elementum&augue=eu&luctus=interdum&tincidunt=eu&nulla=tincidunt&mollis=in&molestie=leo&lorem=maecenas&quisque=pulvinar&ut=lobortis&erat=est&curabitur=phasellus&gravida=sit&nisi=amet&at=erat&nibh=nulla&in=tempus&hac=vivamus&habitasse=in&platea=felis&dictumst=eu&aliquam=sapien&augue=cursus&quam=vestibulum&sollicitudin=proin&vitae=eu&consectetuer=mi&eget=nulla&rutrum=ac&at=enim&lorem=in&integer=tempor&tincidunt=turpis&ante=nec&vel=euismod&ipsum=scelerisque&praesent=quam&blandit=turpis&lacinia=adipiscing&erat=lorem&vestibulum=vitae&sed=mattis&magna=nibh&at=ligula&nunc=nec",
        telegram:
          "https://google.it/sed/justo.html?nunc=lectus&purus=pellentesque&phasellus=eget&in=nunc&felis=donec&donec=quis&semper=orci&sapien=eget&a=orci&libero=vehicula&nam=condimentum&dui=curabitur&proin=in&leo=libero&odio=ut&porttitor=massa&id=volutpat&consequat=convallis&in=morbi&consequat=odio&ut=odio&nulla=elementum&sed=eu&accumsan=interdum&felis=eu&ut=tincidunt&at=in&dolor=leo&quis=maecenas&odio=pulvinar&consequat=lobortis&varius=est&integer=phasellus&ac=sit&leo=amet&pellentesque=erat&ultrices=nulla&mattis=tempus&odio=vivamus&donec=in&vitae=felis&nisi=eu&nam=sapien&ultrices=cursus&libero=vestibulum&non=proin&mattis=eu&pulvinar=mi&nulla=nulla&pede=ac&ullamcorper=enim&augue=in&a=tempor&suscipit=turpis&nulla=nec",
        instagram:
          "https://bloglovin.com/eget/eros/elementum.aspx?pellentesque=volutpat&ultrices=dui&phasellus=maecenas&id=tristique&sapien=est&in=et&sapien=tempus&iaculis=semper&congue=est&vivamus=quam&metus=pharetra&arcu=magna&adipiscing=ac&molestie=consequat&hendrerit=metus&at=sapien&vulputate=ut&vitae=nunc&nisl=vestibulum&aenean=ante&lectus=ipsum&pellentesque=primis&eget=in&nunc=faucibus&donec=orci&quis=luctus&orci=et&eget=ultrices&orci=posuere&vehicula=cubilia&condimentum=curae&curabitur=mauris&in=viverra&libero=diam&ut=vitae&massa=quam&volutpat=suspendisse&convallis=potenti&morbi=nullam&odio=porttitor&odio=lacus&elementum=at",
      },
    },
    summary: {
      isNSFW: false,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "8/30/2021",
        listPrice: 23,
        editionSupply: 1,
        edition: 2,
        editionType: "Unique",
        season: 2,
        rarity: "Common",
        license: "Disney",
        brand: "Captain America",
        collection: "Old School",
        series: "Captain America - Old School",
        annotations: ["Purple", "Zombie", "Generation"],
        description:
          "enim leo rhoncus sed vestibulum sit amet cursus id turpis integer aliquet",
      },
    },
    auction: null,
    price: { amount: 38.49, currency: "SOL", history: [] },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "03/18/2022 23:23:23",
          amount: 576.49,
          currency: "BUSD",
        },
      ],
      history: [],
    },
    listings: [
      {
        amount: 4.9,
        currency: "SOL",
        expiration: "07/11/2021 20:20:20",
        addDate: "11/13/2021 10:55:55",
        from: "Raymund",
      },
      {
        amount: 5.56,
        currency: "ETH",
        expiration: "12/27/2021 00:00:00",
        addDate: "12/06/2021 17:12:12",
        from: "Nickolas",
      },
      {
        amount: 1.31,
        currency: "MATIC",
        expiration: "10/27/2021 17:12:12",
        addDate: "11/18/2021 23:23:23",
        from: "Winni",
      },
    ],
    itemHistory: [],
    more: [{ id: 1 }, { id: 2 }, { id: 2 }, { id: 0 }, { id: 2 }],
  },
  {
    id: 20,
    general: {
      name: "Marietta",
      src: "https://lh3.googleusercontent.com/M9Tyqa3vOo5ApTCmIq0ot64XcjPb1NlImqhJnQmAmhWghbhF-oJrG-HVM7p4J9lQaHkIA_CAximNRn3H81dOP43S=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: true,
      link: "https://dion.ne.jp/ultrices/phasellus/id.png?nulla=sollicitudin&nisl=ut&nunc=suscipit&nisl=a&duis=feugiat&bibendum=et&felis=eros&sed=vestibulum&interdum=ac&venenatis=est&turpis=lacinia&enim=nisi&blandit=venenatis&mi=tristique&in=fusce&porttitor=congue&pede=diam&justo=id&eu=ornare&massa=imperdiet&donec=sapien&dapibus=urna&duis=pretium&at=nisl&velit=ut&eu=volutpat&est=sapien&congue=arcu&elementum=sed&in=augue&hac=aliquam&habitasse=erat&platea=volutpat&dictumst=in&morbi=congue&vestibulum=etiam&velit=justo&id=etiam&pretium=pretium&iaculis=iaculis&diam=justo&erat=in&fermentum=hac&justo=habitasse&nec=platea&condimentum=dictumst&neque=etiam&sapien=faucibus&placerat=cursus&ante=urna&nulla=ut&justo=tellus&aliquam=nulla",
    },
    contract: {
      contractAddress: "0x74c4a6b7db8e0c161ba17d2d0a0de23973feab7b",
      tokenID: 1133,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Nickolas",
        link: "http://hc360.com/rutrum/nulla/tellus.json?nisl=non&venenatis=mattis&lacinia=pulvinar&aenean=nulla&sit=pede&amet=ullamcorper&justo=augue&morbi=a&ut=suscipit&odio=nulla&cras=elit&mi=ac&pede=nulla&malesuada=sed&in=vel&imperdiet=enim&et=sit&commodo=amet&vulputate=nunc&justo=viverra&in=dapibus",
        avatar:
          "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
      },
      creator: {
        name: "Azuki",
        link: "https://amazon.co.jp/consequat.jsp?nisl=consectetuer&aenean=eget&lectus=rutrum&pellentesque=at&eget=lorem&nunc=integer&donec=tincidunt&quis=ante&orci=vel&eget=ipsum&orci=praesent&vehicula=blandit&condimentum=lacinia&curabitur=erat&in=vestibulum&libero=sed&ut=magna&massa=at&volutpat=nunc&convallis=commodo&morbi=placerat&odio=praesent&odio=blandit&elementum=nam&eu=nulla&interdum=integer&eu=pede&tincidunt=justo&in=lacinia&leo=eget&maecenas=tincidunt&pulvinar=eget&lobortis=tempus&est=vel&phasellus=pede&sit=morbi&amet=porttitor&erat=lorem&nulla=id&tempus=ligula&vivamus=suspendisse&in=ornare&felis=consequat&eu=lectus&sapien=in&cursus=est&vestibulum=risus&proin=auctor&eu=sed&mi=tristique&nulla=in",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 43,
      },
    },
    socialMedia: {
      stats: { favorites: 217602, views: 176033 },
      links: {
        website:
          "https://squidoo.com/sagittis/sapien.js?convallis=cras&morbi=in&odio=purus&odio=eu&elementum=magna&eu=vulputate&interdum=luctus&eu=cum&tincidunt=sociis&in=natoque&leo=penatibus&maecenas=et&pulvinar=magnis&lobortis=dis&est=parturient&phasellus=montes&sit=nascetur&amet=ridiculus&erat=mus&nulla=vivamus&tempus=vestibulum&vivamus=sagittis&in=sapien&felis=cum&eu=sociis&sapien=natoque&cursus=penatibus&vestibulum=et&proin=magnis&eu=dis&mi=parturient&nulla=montes&ac=nascetur&enim=ridiculus&in=mus&tempor=etiam&turpis=vel&nec=augue&euismod=vestibulum&scelerisque=rutrum&quam=rutrum&turpis=neque&adipiscing=aenean&lorem=auctor&vitae=gravida&mattis=sem&nibh=praesent",
        discord:
          "https://printfriendly.com/eros/elementum.png?magna=eget&ac=rutrum&consequat=at&metus=lorem&sapien=integer&ut=tincidunt&nunc=ante&vestibulum=vel&ante=ipsum&ipsum=praesent&primis=blandit&in=lacinia&faucibus=erat&orci=vestibulum&luctus=sed&et=magna&ultrices=at&posuere=nunc&cubilia=commodo&curae=placerat&mauris=praesent&viverra=blandit&diam=nam&vitae=nulla&quam=integer&suspendisse=pede&potenti=justo&nullam=lacinia&porttitor=eget&lacus=tincidunt&at=eget&turpis=tempus&donec=vel&posuere=pede&metus=morbi&vitae=porttitor&ipsum=lorem&aliquam=id&non=ligula&mauris=suspendisse&morbi=ornare&non=consequat&lectus=lectus&aliquam=in&sit=est&amet=risus&diam=auctor&in=sed&magna=tristique&bibendum=in&imperdiet=tempus&nullam=sit",
        medium:
          "https://yahoo.co.jp/semper/sapien/a/libero/nam.jsp?porttitor=magna&lacus=vulputate&at=luctus&turpis=cum&donec=sociis&posuere=natoque&metus=penatibus&vitae=et&ipsum=magnis&aliquam=dis&non=parturient&mauris=montes&morbi=nascetur&non=ridiculus&lectus=mus&aliquam=vivamus&sit=vestibulum&amet=sagittis&diam=sapien&in=cum&magna=sociis&bibendum=natoque&imperdiet=penatibus&nullam=et&orci=magnis&pede=dis&venenatis=parturient&non=montes&sodales=nascetur&sed=ridiculus&tincidunt=mus&eu=etiam&felis=vel&fusce=augue&posuere=vestibulum&felis=rutrum&sed=rutrum&lacus=neque&morbi=aenean&sem=auctor&mauris=gravida&laoreet=sem&ut=praesent&rhoncus=id&aliquet=massa&pulvinar=id&sed=nisl&nisl=venenatis&nunc=lacinia&rhoncus=aenean&dui=sit&vel=amet&sem=justo&sed=morbi&sagittis=ut&nam=odio&congue=cras&risus=mi&semper=pede&porta=malesuada&volutpat=in&quam=imperdiet&pede=et",
        telegram: "http://about.me/aliquam.png?vitae=justo",
        instagram:
          "https://sitemeter.com/ornare/imperdiet/sapien/urna/pretium/nisl/ut.json?erat=ipsum&id=primis&mauris=in&vulputate=faucibus&elementum=orci&nullam=luctus&varius=et&nulla=ultrices&facilisi=posuere&cras=cubilia&non=curae&velit=nulla&nec=dapibus&nisi=dolor&vulputate=vel&nonummy=est&maecenas=donec",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["art"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Female" },
      stats: null,
      details: {
        dropDate: "12/7/2021",
        listPrice: 25,
        editionSupply: 9,
        edition: 4,
        editionType: "Con Exclusive",
        season: 2,
        rarity: "One of a kind",
        license: "Disney",
        brand: "The Flash",
        collection: "Old School",
        series: "The Flash - Old School",
        annotations: ["Purple", "Generation"],
        description:
          "sapien non mi integer ac neque duis bibendum morbi non quam nec dui",
      },
    },
    auction: "24-Feb-2022 17:12:12",
    price: {
      amount: 371.96,
      currency: "MATIC",
      history: [
        { amount: 517.6, currency: "MATIC", date: "05/11/2021 20:20:20" },
        { amount: 850.08, currency: "ETH", date: "12/02/2021 05:33:33" },
        { amount: 320.46, currency: "SOL", date: "09/04/2021 05:33:33" },
        { amount: 842.4, currency: "MATIC", date: "09/20/2021 20:20:20" },
        { amount: 858.06, currency: "SOL", date: "03/19/2022 17:12:12" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "08/20/2021 20:20:20",
          amount: 782.49,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "02/23/2022 20:20:20",
          amount: 972.41,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "05/12/2021 17:12:12",
          amount: 143.74,
          currency: "BUSD",
        },
      ],
      history: [],
    },
    listings: [
      {
        amount: 2.65,
        currency: "SOL",
        expiration: "12/01/2021 17:12:12",
        addDate: "10/10/2021 20:20:20",
        from: "Eda",
      },
      {
        amount: 1.95,
        currency: "SOL",
        expiration: "01/09/2022 20:20:20",
        addDate: "08/08/2021 10:55:55",
        from: "Kristofer",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "SOL", usdEquivalent: 2.53 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "09/12/2021 17:12:12",
        transaction: "0x2cdc4028ed61a2d0c11b7393aff4bcc149b55d72",
      },
      {
        type: "Sale",
        cost: { amount: 1.15, currency: "SOL", usdEquivalent: 7.54 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "12/04/2021 00:00:00",
        transaction: "0x3155bc310a06baaf269393c6107839134f86650a",
      },
      {
        type: "Transfer",
        cost: { amount: 5.55, currency: "MATIC", usdEquivalent: 2.54 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "12/28/2021 00:00:00",
        transaction: "0x6621f62b4c339814a99f0c5fd8ad9e0ca4106e3d",
      },
    ],
    more: [{ id: 2 }, { id: 1 }],
  },
  {
    id: 21,
    general: {
      name: "Dalli",
      src: "https://lh3.googleusercontent.com/kR7YztId1NIN9dmJO41Bb0ZlwvwBsBfl9-JhptqriL1laOqaZ6b_lCOi2WukIqxE0f7DMJ_sSvhYkaElNGvY2tA=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: false,
      link: "http://nps.gov/commodo/placerat/praesent/blandit/nam/nulla/integer.png?quis=morbi&orci=a&nullam=ipsum&molestie=integer&nibh=a&in=nibh&lectus=in&pellentesque=quis&at=justo&nulla=maecenas&suspendisse=rhoncus&potenti=aliquam&cras=lacus&in=morbi&purus=quis&eu=tortor&magna=id&vulputate=nulla&luctus=ultrices&cum=aliquet&sociis=maecenas&natoque=leo&penatibus=odio&et=condimentum&magnis=id&dis=luctus&parturient=nec&montes=molestie&nascetur=sed&ridiculus=justo&mus=pellentesque&vivamus=viverra&vestibulum=pede&sagittis=ac&sapien=diam&cum=cras&sociis=pellentesque&natoque=volutpat&penatibus=dui&et=maecenas&magnis=tristique&dis=est&parturient=et&montes=tempus&nascetur=semper&ridiculus=est&mus=quam&etiam=pharetra&vel=magna&augue=ac&vestibulum=consequat&rutrum=metus&rutrum=sapien&neque=ut&aenean=nunc&auctor=vestibulum&gravida=ante&sem=ipsum&praesent=primis&id=in&massa=faucibus&id=orci&nisl=luctus&venenatis=et&lacinia=ultrices&aenean=posuere&sit=cubilia&amet=curae&justo=mauris&morbi=viverra&ut=diam",
    },
    contract: {
      contractAddress: "0x7f053c7e8c1741daca48ecf1d1f2923a80542025",
      tokenID: 9213,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Winni",
        link: "http://wisc.edu/mi.html?mi=ut&integer=at&ac=dolor&neque=quis&duis=odio&bibendum=consequat&morbi=varius&non=integer&quam=ac&nec=leo&dui=pellentesque&luctus=ultrices&rutrum=mattis&nulla=odio&tellus=donec&in=vitae&sagittis=nisi&dui=nam&vel=ultrices&nisl=libero&duis=non&ac=mattis&nibh=pulvinar&fusce=nulla&lacus=pede",
        avatar:
          "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
      },
      creator: {
        name: "Moonbirds",
        link: "https://youtu.be/in/sagittis/dui/vel/nisl/duis/ac.aspx?aliquam=faucibus&sit=accumsan&amet=odio&diam=curabitur&in=convallis&magna=duis&bibendum=consequat&imperdiet=dui&nullam=nec&orci=nisi&pede=volutpat&venenatis=eleifend&non=donec&sodales=ut&sed=dolor&tincidunt=morbi&eu=vel&felis=lectus&fusce=in&posuere=quam&felis=fringilla&sed=rhoncus&lacus=mauris&morbi=enim&sem=leo&mauris=rhoncus&laoreet=sed&ut=vestibulum&rhoncus=sit&aliquet=amet&pulvinar=cursus",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 35,
      },
    },
    socialMedia: {
      stats: { favorites: 692053, views: 721282 },
      links: {
        website:
          "https://who.int/pretium/iaculis/diam/erat/fermentum.jsp?felis=faucibus&eu=orci&sapien=luctus&cursus=et&vestibulum=ultrices&proin=posuere&eu=cubilia&mi=curae&nulla=nulla&ac=dapibus&enim=dolor&in=vel&tempor=est&turpis=donec&nec=odio&euismod=justo&scelerisque=sollicitudin&quam=ut&turpis=suscipit&adipiscing=a&lorem=feugiat&vitae=et&mattis=eros&nibh=vestibulum&ligula=ac&nec=est&sem=lacinia&duis=nisi&aliquam=venenatis&convallis=tristique&nunc=fusce&proin=congue&at=diam&turpis=id&a=ornare&pede=imperdiet&posuere=sapien&nonummy=urna&integer=pretium&non=nisl&velit=ut&donec=volutpat&diam=sapien&neque=arcu&vestibulum=sed&eget=augue&vulputate=aliquam&ut=erat&ultrices=volutpat&vel=in&augue=congue&vestibulum=etiam&ante=justo&ipsum=etiam&primis=pretium&in=iaculis&faucibus=justo&orci=in&luctus=hac&et=habitasse&ultrices=platea&posuere=dictumst&cubilia=etiam&curae=faucibus&donec=cursus&pharetra=urna&magna=ut&vestibulum=tellus&aliquet=nulla&ultrices=ut&erat=erat&tortor=id&sollicitudin=mauris&mi=vulputate&sit=elementum&amet=nullam&lobortis=varius&sapien=nulla&sapien=facilisi&non=cras&mi=non&integer=velit&ac=nec&neque=nisi&duis=vulputate&bibendum=nonummy&morbi=maecenas&non=tincidunt&quam=lacus&nec=at&dui=velit&luctus=vivamus&rutrum=vel&nulla=nulla",
        discord:
          "https://liveinternet.ru/aenean/auctor/gravida/sem/praesent.js?congue=lectus&eget=in&semper=est&rutrum=risus&nulla=auctor&nunc=sed&purus=tristique&phasellus=in&in=tempus&felis=sit&donec=amet&semper=sem&sapien=fusce&a=consequat&libero=nulla&nam=nisl&dui=nunc&proin=nisl&leo=duis&odio=bibendum&porttitor=felis&id=sed&consequat=interdum&in=venenatis&consequat=turpis&ut=enim&nulla=blandit&sed=mi&accumsan=in&felis=porttitor&ut=pede&at=justo&dolor=eu&quis=massa&odio=donec&consequat=dapibus&varius=duis&integer=at&ac=velit&leo=eu&pellentesque=est&ultrices=congue&mattis=elementum&odio=in&donec=hac&vitae=habitasse&nisi=platea&nam=dictumst&ultrices=morbi&libero=vestibulum&non=velit&mattis=id&pulvinar=pretium&nulla=iaculis&pede=diam&ullamcorper=erat&augue=fermentum&a=justo&suscipit=nec&nulla=condimentum&elit=neque&ac=sapien&nulla=placerat&sed=ante&vel=nulla",
        medium:
          "http://arstechnica.com/cras/pellentesque.jpg?nisl=condimentum&ut=curabitur&volutpat=in&sapien=libero&arcu=ut&sed=massa&augue=volutpat&aliquam=convallis&erat=morbi&volutpat=odio&in=odio&congue=elementum&etiam=eu&justo=interdum&etiam=eu&pretium=tincidunt&iaculis=in&justo=leo&in=maecenas&hac=pulvinar&habitasse=lobortis&platea=est&dictumst=phasellus&etiam=sit&faucibus=amet&cursus=erat&urna=nulla&ut=tempus&tellus=vivamus&nulla=in&ut=felis&erat=eu&id=sapien&mauris=cursus&vulputate=vestibulum&elementum=proin&nullam=eu&varius=mi&nulla=nulla&facilisi=ac&cras=enim&non=in&velit=tempor&nec=turpis&nisi=nec&vulputate=euismod&nonummy=scelerisque&maecenas=quam&tincidunt=turpis",
        telegram:
          "https://networkadvertising.org/habitasse/platea/dictumst/etiam.jsp?sem=quam&mauris=pede&laoreet=lobortis&ut=ligula&rhoncus=sit&aliquet=amet&pulvinar=eleifend&sed=pede&nisl=libero&nunc=quis&rhoncus=orci&dui=nullam&vel=molestie&sem=nibh&sed=in&sagittis=lectus&nam=pellentesque&congue=at&risus=nulla&semper=suspendisse&porta=potenti&volutpat=cras&quam=in&pede=purus&lobortis=eu&ligula=magna&sit=vulputate&amet=luctus&eleifend=cum&pede=sociis&libero=natoque&quis=penatibus&orci=et&nullam=magnis&molestie=dis&nibh=parturient&in=montes&lectus=nascetur&pellentesque=ridiculus&at=mus&nulla=vivamus&suspendisse=vestibulum&potenti=sagittis&cras=sapien&in=cum&purus=sociis&eu=natoque&magna=penatibus&vulputate=et&luctus=magnis&cum=dis&sociis=parturient&natoque=montes&penatibus=nascetur&et=ridiculus&magnis=mus&dis=etiam&parturient=vel&montes=augue&nascetur=vestibulum&ridiculus=rutrum&mus=rutrum",
        instagram:
          "https://cbsnews.com/non/velit/nec/nisi/vulputate/nonummy.jpg?eros=ipsum&elementum=aliquam&pellentesque=non&quisque=mauris&porta=morbi&volutpat=non&erat=lectus&quisque=aliquam&erat=sit&eros=amet&viverra=diam&eget=in&congue=magna&eget=bibendum&semper=imperdiet&rutrum=nullam&nulla=orci&nunc=pede&purus=venenatis&phasellus=non&in=sodales&felis=sed&donec=tincidunt&semper=eu&sapien=felis&a=fusce&libero=posuere&nam=felis&dui=sed&proin=lacus&leo=morbi&odio=sem&porttitor=mauris&id=laoreet&consequat=ut",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["art"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "10/1/2021",
        listPrice: 73,
        editionSupply: 8,
        edition: 3,
        editionType: "Unique",
        season: 2,
        rarity: "One of a kind",
        license: "Disney",
        brand: "Robin",
        collection: "Old School",
        series: "Robin - Old School",
        annotations: [],
        description:
          "egestas metus aenean fermentum donec ut mauris eget massa tempor convallis nulla neque libero convallis eget eleifend luctus ultricies eu",
      },
    },
    auction: null,
    price: {
      amount: 134.19,
      currency: "ETH",
      history: [
        { amount: 884.59, currency: "ETH", date: "03/24/2022 00:00:00" },
        { amount: 807.35, currency: "ETH", date: "02/20/2022 23:23:23" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "07/02/2021 20:20:20",
          amount: 194.94,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "08/29/2021 00:00:00",
          amount: 403.63,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 87.03,
          currency: "BUSD",
          expiration: "08/29/2021 10:55:55",
          from: "Eda",
        },
      ],
    },
    listings: [],
    itemHistory: [],
    more: [{ id: 1 }, { id: 1 }],
  },
  {
    id: 22,
    general: {
      name: "Simone",
      src: "https://lh3.googleusercontent.com/tlMxSh5Rf5FJW_mTTyw8jS_OwdD3BKf2F71Tk3noa1NSJlPTht8dBcm-RjoBiFEFQAkpbpcgXpbkHhdqOArOhxG_4t_mUiNG498WGw=w206",
    },
    project: {
      name: "Moonbirds",
      isVerified: true,
      link: "https://skype.com/bibendum.json?placerat=auctor&praesent=sed&blandit=tristique&nam=in&nulla=tempus&integer=sit&pede=amet&justo=sem&lacinia=fusce&eget=consequat&tincidunt=nulla&eget=nisl&tempus=nunc&vel=nisl&pede=duis&morbi=bibendum&porttitor=felis&lorem=sed&id=interdum&ligula=venenatis&suspendisse=turpis&ornare=enim&consequat=blandit&lectus=mi&in=in&est=porttitor&risus=pede&auctor=justo&sed=eu&tristique=massa&in=donec&tempus=dapibus&sit=duis&amet=at&sem=velit&fusce=eu&consequat=est&nulla=congue&nisl=elementum&nunc=in&nisl=hac&duis=habitasse&bibendum=platea&felis=dictumst&sed=morbi&interdum=vestibulum&venenatis=velit&turpis=id&enim=pretium&blandit=iaculis&mi=diam&in=erat&porttitor=fermentum&pede=justo&justo=nec&eu=condimentum&massa=neque&donec=sapien&dapibus=placerat&duis=ante&at=nulla&velit=justo&eu=aliquam&est=quis&congue=turpis&elementum=eget&in=elit&hac=sodales&habitasse=scelerisque",
    },
    contract: {
      contractAddress: "0x53139835e6b59f8c6c0ad553880eb46b2f889b45",
      tokenID: 1011,
      tokenStandard: "ERC0721",
      blockchain: "Ethereum",
      owner: {
        name: "Eda",
        link: "https://toplist.cz/in.html?justo=venenatis&maecenas=lacinia&rhoncus=aenean&aliquam=sit&lacus=amet&morbi=justo&quis=morbi&tortor=ut&id=odio&nulla=cras&ultrices=mi&aliquet=pede&maecenas=malesuada&leo=in&odio=imperdiet&condimentum=et&id=commodo&luctus=vulputate&nec=justo&molestie=in&sed=blandit&justo=ultrices&pellentesque=enim&viverra=lorem&pede=ipsum&ac=dolor&diam=sit&cras=amet&pellentesque=consectetuer&volutpat=adipiscing&dui=elit&maecenas=proin&tristique=interdum&est=mauris&et=non&tempus=ligula&semper=pellentesque&est=ultrices&quam=phasellus&pharetra=id&magna=sapien&ac=in&consequat=sapien&metus=iaculis&sapien=congue&ut=vivamus&nunc=metus&vestibulum=arcu&ante=adipiscing&ipsum=molestie&primis=hendrerit&in=at&faucibus=vulputate&orci=vitae",
        avatar:
          "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
      },
      creator: {
        name: "BoredApeYachtClub",
        link: "https://dagondesign.com/aenean/sit/amet/justo/morbi/ut/odio.html?auctor=at&gravida=nulla&sem=suspendisse&praesent=potenti&id=cras&massa=in&id=purus&nisl=eu&venenatis=magna&lacinia=vulputate&aenean=luctus&sit=cum&amet=sociis&justo=natoque&morbi=penatibus&ut=et&odio=magnis&cras=dis&mi=parturient&pede=montes&malesuada=nascetur&in=ridiculus&imperdiet=mus&et=vivamus&commodo=vestibulum&vulputate=sagittis&justo=sapien&in=cum&blandit=sociis&ultrices=natoque&enim=penatibus&lorem=et&ipsum=magnis&dolor=dis&sit=parturient&amet=montes&consectetuer=nascetur&adipiscing=ridiculus&elit=mus&proin=etiam&interdum=vel&mauris=augue&non=vestibulum&ligula=rutrum&pellentesque=rutrum&ultrices=neque&phasellus=aenean&id=auctor&sapien=gravida&in=sem&sapien=praesent&iaculis=id&congue=massa&vivamus=id&metus=nisl&arcu=venenatis&adipiscing=lacinia&molestie=aenean",
        avatar:
          "https://lh3.googleusercontent.com/sn5iLHUcNuUO98w_9Z7cat32hiqvVkPYr6tzHUacESg4PePh9M3jySvpttyWWXHD2e8M4PNQqgorU9sUvpX-FHQHXFBiCpKjloC2nA=s64",
        royalties: 6,
      },
    },
    socialMedia: {
      stats: { favorites: 301666, views: 850866 },
      links: {
        website:
          "https://economist.com/aliquam.png?a=tincidunt&ipsum=eget&integer=tempus&a=vel&nibh=pede&in=morbi&quis=porttitor&justo=lorem&maecenas=id&rhoncus=ligula&aliquam=suspendisse",
        discord:
          "http://google.it/enim/sit/amet/nunc/viverra.html?id=potenti&ligula=cras&suspendisse=in&ornare=purus&consequat=eu&lectus=magna&in=vulputate&est=luctus&risus=cum&auctor=sociis&sed=natoque&tristique=penatibus&in=et&tempus=magnis&sit=dis&amet=parturient&sem=montes&fusce=nascetur&consequat=ridiculus&nulla=mus&nisl=vivamus&nunc=vestibulum&nisl=sagittis&duis=sapien&bibendum=cum&felis=sociis&sed=natoque&interdum=penatibus&venenatis=et&turpis=magnis&enim=dis&blandit=parturient&mi=montes&in=nascetur&porttitor=ridiculus&pede=mus&justo=etiam&eu=vel&massa=augue&donec=vestibulum&dapibus=rutrum&duis=rutrum&at=neque&velit=aenean&eu=auctor&est=gravida&congue=sem&elementum=praesent&in=id&hac=massa&habitasse=id&platea=nisl&dictumst=venenatis&morbi=lacinia&vestibulum=aenean&velit=sit&id=amet&pretium=justo",
        medium:
          "http://wufoo.com/viverra/eget/congue/eget/semper/rutrum.html?iaculis=in&diam=lectus&erat=pellentesque&fermentum=at&justo=nulla&nec=suspendisse&condimentum=potenti&neque=cras&sapien=in&placerat=purus&ante=eu&nulla=magna&justo=vulputate&aliquam=luctus&quis=cum&turpis=sociis&eget=natoque&elit=penatibus&sodales=et&scelerisque=magnis&mauris=dis&sit=parturient&amet=montes&eros=nascetur&suspendisse=ridiculus&accumsan=mus&tortor=vivamus&quis=vestibulum&turpis=sagittis&sed=sapien&ante=cum&vivamus=sociis&tortor=natoque&duis=penatibus&mattis=et&egestas=magnis&metus=dis&aenean=parturient&fermentum=montes&donec=nascetur&ut=ridiculus&mauris=mus&eget=etiam&massa=vel&tempor=augue&convallis=vestibulum&nulla=rutrum&neque=rutrum&libero=neque&convallis=aenean&eget=auctor&eleifend=gravida&luctus=sem&ultricies=praesent&eu=id&nibh=massa&quisque=id&id=nisl&justo=venenatis&sit=lacinia&amet=aenean&sapien=sit",
        telegram:
          "http://comsenz.com/luctus/et/ultrices/posuere/cubilia/curae/donec.aspx?et=mi&ultrices=in&posuere=porttitor&cubilia=pede&curae=justo&donec=eu&pharetra=massa&magna=donec&vestibulum=dapibus&aliquet=duis&ultrices=at&erat=velit&tortor=eu&sollicitudin=est&mi=congue&sit=elementum&amet=in&lobortis=hac&sapien=habitasse&sapien=platea&non=dictumst&mi=morbi&integer=vestibulum&ac=velit&neque=id&duis=pretium&bibendum=iaculis&morbi=diam&non=erat&quam=fermentum&nec=justo&dui=nec&luctus=condimentum&rutrum=neque&nulla=sapien&tellus=placerat&in=ante&sagittis=nulla&dui=justo&vel=aliquam&nisl=quis&duis=turpis&ac=eget&nibh=elit&fusce=sodales&lacus=scelerisque&purus=mauris&aliquet=sit&at=amet&feugiat=eros&non=suspendisse&pretium=accumsan&quis=tortor&lectus=quis&suspendisse=turpis&potenti=sed&in=ante&eleifend=vivamus&quam=tortor&a=duis&odio=mattis&in=egestas&hac=metus&habitasse=aenean&platea=fermentum&dictumst=donec&maecenas=ut&ut=mauris&massa=eget&quis=massa&augue=tempor&luctus=convallis&tincidunt=nulla&nulla=neque&mollis=libero&molestie=convallis&lorem=eget&quisque=eleifend&ut=luctus&erat=ultricies&curabitur=eu&gravida=nibh&nisi=quisque&at=id&nibh=justo&in=sit&hac=amet&habitasse=sapien&platea=dignissim&dictumst=vestibulum&aliquam=vestibulum&augue=ante&quam=ipsum&sollicitudin=primis",
        instagram:
          "http://geocities.jp/eros/elementum/pellentesque/quisque/porta/volutpat.html?mauris=dui&eget=maecenas&massa=tristique&tempor=est&convallis=et&nulla=tempus&neque=semper&libero=est&convallis=quam&eget=pharetra&eleifend=magna&luctus=ac&ultricies=consequat&eu=metus&nibh=sapien&quisque=ut&id=nunc&justo=vestibulum&sit=ante&amet=ipsum&sapien=primis&dignissim=in&vestibulum=faucibus&vestibulum=orci&ante=luctus&ipsum=et&primis=ultrices&in=posuere&faucibus=cubilia&orci=curae&luctus=mauris&et=viverra&ultrices=diam&posuere=vitae&cubilia=quam&curae=suspendisse&nulla=potenti&dapibus=nullam&dolor=porttitor&vel=lacus&est=at&donec=turpis&odio=donec&justo=posuere&sollicitudin=metus",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: false,
      category: ["science"],
      properties: { accessory: ["Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "5/21/2021",
        listPrice: 62,
        editionSupply: 7,
        edition: 4,
        editionType: "Common",
        season: 2,
        rarity: "One of a kind",
        license: "Disney",
        brand: "Captain America",
        collection: "Purple",
        series: "Captain America - Purple",
        annotations: [],
        description:
          "in tempor turpis nec euismod scelerisque quam turpis adipiscing lorem vitae mattis nibh ligula",
      },
    },
    auction: "06-Feb-2022 05:33:33",
    price: {
      amount: 64.74,
      currency: "ETH",
      history: [
        { amount: 560.05, currency: "MATIC", date: "10/17/2021 23:23:23" },
        { amount: 604.97, currency: "SOL", date: "04/02/2022 05:33:33" },
        { amount: 149.11, currency: "MATIC", date: "02/12/2022 00:00:00" },
        { amount: 370.89, currency: "SOL", date: "12/07/2021 10:55:55" },
        { amount: 167.85, currency: "ETH", date: "11/04/2021 20:20:20" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: true,
      active: [
        {
          id: 1,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "07/07/2021 17:12:12",
          amount: 306.59,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "05/05/2021 20:20:20",
          amount: 444.17,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "02/10/2022 23:23:23",
          amount: 407.61,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 230.09,
          currency: "BUSD",
          expiration: "04/03/2022 23:23:23",
          from: "Kristofer",
        },
        {
          active: false,
          amount: 501.53,
          currency: "BUSD",
          expiration: "09/18/2021 05:33:33",
          from: "Raymund",
        },
      ],
    },
    listings: [
      {
        amount: 8.74,
        currency: "ETH",
        expiration: "05/01/2021 17:12:12",
        addDate: "01/02/2022 23:23:23",
        from: "Raymund",
      },
      {
        amount: 3.21,
        currency: "MATIC",
        expiration: "11/12/2021 17:12:12",
        addDate: "10/09/2021 10:55:55",
        from: "Nickolas",
      },
      {
        amount: 7.3,
        currency: "MATIC",
        expiration: "07/05/2021 10:55:55",
        addDate: "11/07/2021 00:00:00",
        from: "Winni",
      },
      {
        amount: 4.2,
        currency: "SOL",
        expiration: "09/25/2021 20:20:20",
        addDate: "09/26/2021 17:12:12",
        from: "Eda",
      },
    ],
    itemHistory: [],
    more: [{ id: 1 }, { id: 2 }, { id: 1 }, { id: 2 }],
  },
  {
    id: 23,
    general: {
      name: "Trula",
      src: "https://lh3.googleusercontent.com/V7yIEHLmpvZUpKdzsdUkzWtRXOY67NcCiKEOekD5qtBtHRxUaSOpjnH0k23byzUW7OBhVvuYyrTV07wpFO6j70XRerHFJRI6WPa-=w206",
    },
    project: {
      name: "BoredApeYachtClub",
      isVerified: true,
      link: "http://businesswire.com/morbi/vestibulum/velit/id.png?elementum=integer&nullam=a&varius=nibh&nulla=in&facilisi=quis&cras=justo&non=maecenas&velit=rhoncus&nec=aliquam&nisi=lacus&vulputate=morbi&nonummy=quis&maecenas=tortor&tincidunt=id&lacus=nulla",
    },
    contract: {
      contractAddress: "0x72ea44fcb677a27870b2e76a4acad5e27a9452c7",
      tokenID: 5977,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Kristofer",
        link: "http://guardian.co.uk/est/risus/auctor/sed/tristique.jpg?eget=sed&vulputate=vestibulum&ut=sit&ultrices=amet&vel=cursus&augue=id&vestibulum=turpis&ante=integer&ipsum=aliquet&primis=massa&in=id&faucibus=lobortis&orci=convallis&luctus=tortor&et=risus&ultrices=dapibus&posuere=augue&cubilia=vel&curae=accumsan&donec=tellus&pharetra=nisi&magna=eu&vestibulum=orci&aliquet=mauris&ultrices=lacinia&erat=sapien&tortor=quis&sollicitudin=libero&mi=nullam&sit=sit&amet=amet&lobortis=turpis&sapien=elementum&sapien=ligula&non=vehicula&mi=consequat&integer=morbi&ac=a&neque=ipsum&duis=integer&bibendum=a&morbi=nibh&non=in&quam=quis&nec=justo&dui=maecenas&luctus=rhoncus&rutrum=aliquam&nulla=lacus&tellus=morbi&in=quis&sagittis=tortor&dui=id&vel=nulla&nisl=ultrices&duis=aliquet&ac=maecenas&nibh=leo&fusce=odio&lacus=condimentum&purus=id&aliquet=luctus&at=nec&feugiat=molestie&non=sed&pretium=justo&quis=pellentesque&lectus=viverra&suspendisse=pede&potenti=ac&in=diam&eleifend=cras&quam=pellentesque&a=volutpat&odio=dui&in=maecenas&hac=tristique&habitasse=est&platea=et&dictumst=tempus&maecenas=semper&ut=est",
        avatar:
          "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "https://nytimes.com/nisi/at/nibh.js?quam=cursus&pede=id&lobortis=turpis&ligula=integer&sit=aliquet&amet=massa&eleifend=id&pede=lobortis&libero=convallis&quis=tortor&orci=risus&nullam=dapibus&molestie=augue&nibh=vel&in=accumsan&lectus=tellus&pellentesque=nisi&at=eu&nulla=orci&suspendisse=mauris&potenti=lacinia&cras=sapien&in=quis&purus=libero&eu=nullam&magna=sit&vulputate=amet&luctus=turpis&cum=elementum&sociis=ligula&natoque=vehicula&penatibus=consequat&et=morbi&magnis=a&dis=ipsum&parturient=integer&montes=a&nascetur=nibh&ridiculus=in&mus=quis&vivamus=justo&vestibulum=maecenas&sagittis=rhoncus&sapien=aliquam&cum=lacus&sociis=morbi&natoque=quis&penatibus=tortor&et=id&magnis=nulla&dis=ultrices&parturient=aliquet&montes=maecenas&nascetur=leo&ridiculus=odio&mus=condimentum&etiam=id&vel=luctus&augue=nec&vestibulum=molestie&rutrum=sed&rutrum=justo&neque=pellentesque&aenean=viverra&auctor=pede&gravida=ac&sem=diam&praesent=cras&id=pellentesque&massa=volutpat&id=dui&nisl=maecenas&venenatis=tristique&lacinia=est&aenean=et&sit=tempus&amet=semper&justo=est",
        avatar:
          "https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s64",
        royalties: 89,
      },
    },
    socialMedia: {
      stats: { favorites: 374266, views: 928551 },
      links: {
        website:
          "http://barnesandnoble.com/eu/mi.json?lacus=orci&curabitur=eget&at=orci&ipsum=vehicula&ac=condimentum&tellus=curabitur&semper=in&interdum=libero&mauris=ut&ullamcorper=massa&purus=volutpat&sit=convallis&amet=morbi&nulla=odio&quisque=odio&arcu=elementum&libero=eu&rutrum=interdum&ac=eu&lobortis=tincidunt",
        discord:
          "https://engadget.com/proin/interdum/mauris/non.json?eros=sed&elementum=interdum&pellentesque=venenatis&quisque=turpis&porta=enim&volutpat=blandit&erat=mi&quisque=in&erat=porttitor&eros=pede&viverra=justo&eget=eu&congue=massa&eget=donec&semper=dapibus&rutrum=duis&nulla=at&nunc=velit&purus=eu&phasellus=est&in=congue&felis=elementum&donec=in&semper=hac&sapien=habitasse&a=platea&libero=dictumst&nam=morbi&dui=vestibulum&proin=velit&leo=id&odio=pretium&porttitor=iaculis&id=diam&consequat=erat&in=fermentum&consequat=justo&ut=nec&nulla=condimentum&sed=neque&accumsan=sapien&felis=placerat&ut=ante&at=nulla&dolor=justo&quis=aliquam&odio=quis&consequat=turpis&varius=eget&integer=elit&ac=sodales&leo=scelerisque&pellentesque=mauris&ultrices=sit&mattis=amet&odio=eros&donec=suspendisse&vitae=accumsan&nisi=tortor&nam=quis&ultrices=turpis&libero=sed&non=ante&mattis=vivamus&pulvinar=tortor&nulla=duis&pede=mattis&ullamcorper=egestas&augue=metus&a=aenean&suscipit=fermentum&nulla=donec&elit=ut&ac=mauris&nulla=eget&sed=massa&vel=tempor&enim=convallis",
        medium:
          "https://tinypic.com/molestie/nibh/in.json?ante=quis&ipsum=orci&primis=eget&in=orci&faucibus=vehicula&orci=condimentum&luctus=curabitur&et=in&ultrices=libero&posuere=ut&cubilia=massa&curae=volutpat&duis=convallis&faucibus=morbi&accumsan=odio&odio=odio&curabitur=elementum&convallis=eu&duis=interdum&consequat=eu&dui=tincidunt&nec=in&nisi=leo&volutpat=maecenas&eleifend=pulvinar&donec=lobortis&ut=est&dolor=phasellus&morbi=sit&vel=amet&lectus=erat&in=nulla&quam=tempus&fringilla=vivamus&rhoncus=in&mauris=felis&enim=eu&leo=sapien&rhoncus=cursus&sed=vestibulum&vestibulum=proin&sit=eu&amet=mi&cursus=nulla&id=ac&turpis=enim&integer=in&aliquet=tempor&massa=turpis&id=nec&lobortis=euismod&convallis=scelerisque&tortor=quam&risus=turpis&dapibus=adipiscing&augue=lorem&vel=vitae&accumsan=mattis&tellus=nibh&nisi=ligula&eu=nec&orci=sem&mauris=duis&lacinia=aliquam&sapien=convallis&quis=nunc&libero=proin&nullam=at&sit=turpis&amet=a&turpis=pede&elementum=posuere&ligula=nonummy&vehicula=integer&consequat=non&morbi=velit&a=donec&ipsum=diam&integer=neque&a=vestibulum&nibh=eget",
        telegram:
          "http://bing.com/mauris/vulputate/elementum/nullam/varius.html?non=tortor&mi=risus&integer=dapibus&ac=augue&neque=vel&duis=accumsan&bibendum=tellus&morbi=nisi&non=eu&quam=orci&nec=mauris&dui=lacinia&luctus=sapien&rutrum=quis&nulla=libero&tellus=nullam&in=sit&sagittis=amet&dui=turpis&vel=elementum&nisl=ligula&duis=vehicula&ac=consequat&nibh=morbi&fusce=a&lacus=ipsum&purus=integer&aliquet=a&at=nibh&feugiat=in&non=quis&pretium=justo&quis=maecenas&lectus=rhoncus&suspendisse=aliquam&potenti=lacus&in=morbi&eleifend=quis&quam=tortor&a=id&odio=nulla&in=ultrices&hac=aliquet&habitasse=maecenas&platea=leo&dictumst=odio&maecenas=condimentum&ut=id&massa=luctus&quis=nec&augue=molestie&luctus=sed&tincidunt=justo&nulla=pellentesque&mollis=viverra&molestie=pede&lorem=ac&quisque=diam&ut=cras&erat=pellentesque",
        instagram:
          "http://reddit.com/nam/dui/proin/leo/odio/porttitor.xml?mi=congue&pede=eget&malesuada=semper&in=rutrum&imperdiet=nulla&et=nunc&commodo=purus&vulputate=phasellus&justo=in&in=felis&blandit=donec&ultrices=semper&enim=sapien&lorem=a&ipsum=libero&dolor=nam&sit=dui&amet=proin&consectetuer=leo&adipiscing=odio&elit=porttitor&proin=id&interdum=consequat&mauris=in&non=consequat&ligula=ut&pellentesque=nulla&ultrices=sed&phasellus=accumsan&id=felis&sapien=ut&in=at&sapien=dolor&iaculis=quis&congue=odio&vivamus=consequat&metus=varius&arcu=integer&adipiscing=ac&molestie=leo&hendrerit=pellentesque&at=ultrices&vulputate=mattis&vitae=odio&nisl=donec&aenean=vitae&lectus=nisi&pellentesque=nam&eget=ultrices&nunc=libero&donec=non&quis=mattis&orci=pulvinar&eget=nulla&orci=pede&vehicula=ullamcorper&condimentum=augue&curabitur=a&in=suscipit&libero=nulla&ut=elit&massa=ac&volutpat=nulla&convallis=sed&morbi=vel&odio=enim&odio=sit&elementum=amet&eu=nunc&interdum=viverra&eu=dapibus&tincidunt=nulla",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Other" },
      stats: null,
      details: {
        dropDate: "8/26/2021",
        listPrice: 79,
        editionSupply: 7,
        edition: 4,
        editionType: "Con Exclusive",
        season: 1,
        rarity: "Secret",
        license: "Disney",
        brand: "The Flash",
        collection: "Next Generation",
        series: "The Flash - Next Generation",
        annotations: [],
        description:
          "massa volutpat convallis morbi odio odio elementum eu interdum eu tincidunt in leo maecenas pulvinar",
      },
    },
    auction: null,
    price: {
      amount: 162.61,
      currency: "SOL",
      history: [
        { amount: 604.17, currency: "SOL", date: "09/28/2021 00:00:00" },
        { amount: 586.48, currency: "ETH", date: "12/18/2021 10:55:55" },
        { amount: 231.07, currency: "MATIC", date: "12/28/2021 00:00:00" },
        { amount: 287.89, currency: "SOL", date: "12/27/2021 10:55:55" },
      ],
    },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "08/12/2021 00:00:00",
          amount: 114.27,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "05/30/2021 10:55:55",
          amount: 805.19,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "09/18/2021 17:12:12",
          amount: 721.88,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 95.19,
          currency: "BUSD",
          expiration: "09/12/2021 23:23:23",
          from: "Nickolas",
        },
      ],
    },
    listings: [
      {
        amount: 3.22,
        currency: "ETH",
        expiration: "01/15/2022 05:33:33",
        addDate: "04/15/2021 23:23:23",
        from: "Kristofer",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "ETH", usdEquivalent: 1.13 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "09/28/2021 20:20:20",
        transaction: "0x607dec819f2771675f15ab40c52a0819e07b6c55",
      },
      {
        type: "Sale",
        cost: { amount: 1.33, currency: "MATIC", usdEquivalent: 2.13 },
        from: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        to: {
          name: "Nickolas",
          src: "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          address: "0x8cad4153a09e32c6ee6055188a366191f5186021",
        },
        date: "01/22/2022 17:12:12",
        transaction: "0xf901b33a69df801969e5cd62aabf97c0810dfe3a",
      },
    ],
    more: [{ id: 1 }, { id: 1 }, { id: 1 }, { id: 0 }, { id: 0 }],
  },
  {
    id: 24,
    general: {
      name: "Adolphus",
      src: "https://lh3.googleusercontent.com/28jYQ9Toyfs8QPOUd_k86RhLSiventoMuhQjmqiE-TXVFlpoX_g_ncau0kO8GZb3-arCo712XcgsPZYyzYPop-V5=w206",
    },
    project: {
      name: "CryptoPunks",
      isVerified: true,
      link: "https://wikispaces.com/ultrices/erat/tortor/sollicitudin/mi.jsp?elementum=amet&nullam=consectetuer&varius=adipiscing&nulla=elit&facilisi=proin&cras=interdum&non=mauris&velit=non&nec=ligula&nisi=pellentesque&vulputate=ultrices&nonummy=phasellus&maecenas=id&tincidunt=sapien&lacus=in&at=sapien&velit=iaculis",
    },
    contract: {
      contractAddress: "0xd2e7cf0062189584b9f3b9e7155652bcd31d9e01",
      tokenID: 6939,
      tokenStandard: "ERC0721",
      blockchain: "Solana",
      owner: {
        name: "Raymund",
        link: "http://youtu.be/id/massa/id/nisl/venenatis.png?in=tincidunt&congue=lacus&etiam=at&justo=velit&etiam=vivamus&pretium=vel&iaculis=nulla&justo=eget&in=eros&hac=elementum&habitasse=pellentesque&platea=quisque&dictumst=porta&etiam=volutpat&faucibus=erat&cursus=quisque&urna=erat&ut=eros&tellus=viverra&nulla=eget&ut=congue&erat=eget&id=semper&mauris=rutrum&vulputate=nulla&elementum=nunc&nullam=purus&varius=phasellus&nulla=in&facilisi=felis&cras=donec&non=semper&velit=sapien&nec=a&nisi=libero&vulputate=nam&nonummy=dui&maecenas=proin&tincidunt=leo&lacus=odio&at=porttitor&velit=id&vivamus=consequat&vel=in&nulla=consequat&eget=ut&eros=nulla&elementum=sed&pellentesque=accumsan&quisque=felis&porta=ut&volutpat=at&erat=dolor&quisque=quis&erat=odio&eros=consequat&viverra=varius&eget=integer&congue=ac&eget=leo",
        avatar:
          "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
      },
      creator: {
        name: "CryptoPunks",
        link: "https://privacy.gov.au/turpis/a/pede/posuere/nonummy/integer.xml?sapien=tempus&cursus=vivamus&vestibulum=in&proin=felis&eu=eu&mi=sapien&nulla=cursus&ac=vestibulum&enim=proin&in=eu&tempor=mi&turpis=nulla&nec=ac&euismod=enim&scelerisque=in&quam=tempor&turpis=turpis&adipiscing=nec&lorem=euismod&vitae=scelerisque&mattis=quam&nibh=turpis&ligula=adipiscing&nec=lorem&sem=vitae&duis=mattis&aliquam=nibh&convallis=ligula&nunc=nec&proin=sem&at=duis&turpis=aliquam&a=convallis&pede=nunc&posuere=proin&nonummy=at&integer=turpis&non=a&velit=pede&donec=posuere&diam=nonummy&neque=integer&vestibulum=non&eget=velit&vulputate=donec&ut=diam&ultrices=neque&vel=vestibulum&augue=eget&vestibulum=vulputate&ante=ut&ipsum=ultrices&primis=vel&in=augue&faucibus=vestibulum&orci=ante&luctus=ipsum&et=primis&ultrices=in&posuere=faucibus&cubilia=orci&curae=luctus&donec=et&pharetra=ultrices&magna=posuere&vestibulum=cubilia&aliquet=curae&ultrices=donec&erat=pharetra&tortor=magna&sollicitudin=vestibulum&mi=aliquet&sit=ultrices&amet=erat&lobortis=tortor&sapien=sollicitudin&sapien=mi&non=sit&mi=amet&integer=lobortis&ac=sapien&neque=sapien&duis=non&bibendum=mi&morbi=integer&non=ac&quam=neque&nec=duis&dui=bibendum&luctus=morbi&rutrum=non&nulla=quam&tellus=nec&in=dui&sagittis=luctus&dui=rutrum&vel=nulla",
        avatar:
          "https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s64",
        royalties: 3,
      },
    },
    socialMedia: {
      stats: { favorites: 70400, views: 994821 },
      links: {
        website:
          "https://goodreads.com/nulla/ac/enim/in/tempor/turpis/nec.json?habitasse=blandit&platea=nam&dictumst=nulla&etiam=integer&faucibus=pede&cursus=justo&urna=lacinia&ut=eget&tellus=tincidunt&nulla=eget&ut=tempus&erat=vel&id=pede&mauris=morbi&vulputate=porttitor&elementum=lorem&nullam=id&varius=ligula&nulla=suspendisse&facilisi=ornare&cras=consequat&non=lectus&velit=in&nec=est&nisi=risus&vulputate=auctor&nonummy=sed&maecenas=tristique&tincidunt=in&lacus=tempus&at=sit&velit=amet&vivamus=sem&vel=fusce&nulla=consequat&eget=nulla&eros=nisl&elementum=nunc&pellentesque=nisl&quisque=duis&porta=bibendum&volutpat=felis&erat=sed&quisque=interdum&erat=venenatis&eros=turpis",
        discord:
          "http://ifeng.com/tempus/vivamus.json?non=sodales&quam=scelerisque&nec=mauris&dui=sit&luctus=amet&rutrum=eros&nulla=suspendisse&tellus=accumsan&in=tortor&sagittis=quis&dui=turpis&vel=sed&nisl=ante&duis=vivamus&ac=tortor&nibh=duis&fusce=mattis&lacus=egestas&purus=metus&aliquet=aenean&at=fermentum&feugiat=donec&non=ut&pretium=mauris&quis=eget&lectus=massa&suspendisse=tempor&potenti=convallis&in=nulla&eleifend=neque&quam=libero&a=convallis&odio=eget&in=eleifend&hac=luctus&habitasse=ultricies&platea=eu&dictumst=nibh&maecenas=quisque&ut=id&massa=justo&quis=sit&augue=amet&luctus=sapien&tincidunt=dignissim&nulla=vestibulum&mollis=vestibulum&molestie=ante&lorem=ipsum&quisque=primis&ut=in&erat=faucibus&curabitur=orci&gravida=luctus&nisi=et&at=ultrices&nibh=posuere&in=cubilia&hac=curae&habitasse=nulla&platea=dapibus&dictumst=dolor&aliquam=vel&augue=est&quam=donec&sollicitudin=odio&vitae=justo&consectetuer=sollicitudin&eget=ut&rutrum=suscipit&at=a&lorem=feugiat&integer=et&tincidunt=eros&ante=vestibulum&vel=ac&ipsum=est&praesent=lacinia&blandit=nisi&lacinia=venenatis&erat=tristique&vestibulum=fusce&sed=congue&magna=diam&at=id&nunc=ornare&commodo=imperdiet&placerat=sapien&praesent=urna&blandit=pretium&nam=nisl&nulla=ut",
        medium:
          "https://spiegel.de/in/lacus/curabitur/at.xml?elementum=metus&pellentesque=arcu&quisque=adipiscing&porta=molestie&volutpat=hendrerit&erat=at&quisque=vulputate&erat=vitae&eros=nisl&viverra=aenean&eget=lectus&congue=pellentesque&eget=eget&semper=nunc&rutrum=donec&nulla=quis&nunc=orci&purus=eget&phasellus=orci&in=vehicula&felis=condimentum&donec=curabitur&semper=in&sapien=libero&a=ut&libero=massa&nam=volutpat&dui=convallis&proin=morbi&leo=odio&odio=odio&porttitor=elementum&id=eu&consequat=interdum&in=eu&consequat=tincidunt&ut=in&nulla=leo&sed=maecenas&accumsan=pulvinar&felis=lobortis&ut=est&at=phasellus&dolor=sit&quis=amet&odio=erat&consequat=nulla&varius=tempus&integer=vivamus&ac=in&leo=felis&pellentesque=eu&ultrices=sapien&mattis=cursus&odio=vestibulum&donec=proin&vitae=eu&nisi=mi&nam=nulla&ultrices=ac&libero=enim&non=in&mattis=tempor&pulvinar=turpis&nulla=nec&pede=euismod&ullamcorper=scelerisque&augue=quam&a=turpis&suscipit=adipiscing&nulla=lorem&elit=vitae&ac=mattis&nulla=nibh&sed=ligula&vel=nec&enim=sem&sit=duis&amet=aliquam&nunc=convallis&viverra=nunc&dapibus=proin&nulla=at&suscipit=turpis&ligula=a&in=pede&lacus=posuere&curabitur=nonummy&at=integer",
        telegram:
          "http://tripod.com/at/ipsum/ac/tellus/semper.js?felis=non&eu=pretium&sapien=quis&cursus=lectus&vestibulum=suspendisse&proin=potenti&eu=in&mi=eleifend&nulla=quam&ac=a&enim=odio&in=in&tempor=hac&turpis=habitasse&nec=platea&euismod=dictumst&scelerisque=maecenas&quam=ut&turpis=massa&adipiscing=quis",
        instagram:
          "http://tripod.com/aliquet/ultrices/erat/tortor/sollicitudin/mi/sit.xml?porta=curabitur&volutpat=gravida&quam=nisi&pede=at&lobortis=nibh&ligula=in&sit=hac&amet=habitasse&eleifend=platea&pede=dictumst&libero=aliquam&quis=augue&orci=quam&nullam=sollicitudin&molestie=vitae&nibh=consectetuer&in=eget&lectus=rutrum&pellentesque=at&at=lorem&nulla=integer&suspendisse=tincidunt&potenti=ante&cras=vel&in=ipsum&purus=praesent&eu=blandit&magna=lacinia&vulputate=erat&luctus=vestibulum&cum=sed&sociis=magna&natoque=at&penatibus=nunc&et=commodo&magnis=placerat&dis=praesent",
      },
    },
    summary: {
      isNSFW: true,
      isLazyMinted: true,
      category: ["science"],
      properties: { accessory: ["Glasses", "Wild", "Hat"], type: "Male" },
      stats: null,
      details: {
        dropDate: "5/8/2021",
        listPrice: 19,
        editionSupply: 7,
        edition: 1,
        editionType: "Rare",
        season: 2,
        rarity: "One of a kind",
        license: "DC",
        brand: "Captain America",
        collection: "Purple",
        series: "Captain America - Purple",
        annotations: ["Generation", "Purple"],
        description:
          "consequat ut nulla sed accumsan felis ut at dolor quis odio consequat varius integer ac leo",
      },
    },
    auction: "05-Apr-2022 20:20:20",
    price: { amount: 394.81, currency: "MATIC", history: [] },
    boughtPrices: [],
    bids: {
      isAllowed: false,
      active: [
        {
          id: 1,
          user: {
            name: "Raymund",
            avatar:
              "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          },
          type: "bid",
          time: "03/06/2022 10:55:55",
          amount: 253.56,
          currency: "BUSD",
        },
        {
          id: 2,
          user: {
            name: "Nickolas",
            avatar:
              "https://lh3.googleusercontent.com/d7dS9_HCsKcOej8qlW6cmO8isfgRs3wpJGBznyka5UiEIqPhb5Ut9LbUcOTgIyhsqKvsJrNLF2t30lFUkTXDio-VFwqKbRpp_D11=s100",
          },
          type: "bid",
          time: "10/07/2021 05:33:33",
          amount: 470.09,
          currency: "BUSD",
        },
        {
          id: 3,
          user: {
            name: "Winni",
            avatar:
              "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          },
          type: "bid",
          time: "05/12/2021 20:20:20",
          amount: 886.08,
          currency: "BUSD",
        },
        {
          id: 4,
          user: {
            name: "Eda",
            avatar:
              "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          },
          type: "bid",
          time: "12/08/2021 05:33:33",
          amount: 814.12,
          currency: "BUSD",
        },
        {
          id: 5,
          user: {
            name: "Kristofer",
            avatar:
              "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          },
          type: "bid",
          time: "05/05/2021 05:33:33",
          amount: 546.59,
          currency: "BUSD",
        },
      ],
      history: [
        {
          active: false,
          amount: 879.85,
          currency: "BUSD",
          expiration: "06/29/2021 10:55:55",
          from: "Winni",
        },
      ],
    },
    listings: [
      {
        amount: 1.46,
        currency: "ETH",
        expiration: "12/10/2021 05:33:33",
        addDate: "08/05/2021 17:12:12",
        from: "Raymund",
      },
      {
        amount: 3.27,
        currency: "SOL",
        expiration: "11/04/2021 05:33:33",
        addDate: "12/09/2021 10:55:55",
        from: "Nickolas",
      },
      {
        amount: 9.82,
        currency: "MATIC",
        expiration: "03/29/2022 23:23:23",
        addDate: "06/11/2021 05:33:33",
        from: "Winni",
      },
    ],
    itemHistory: [
      {
        type: "Mint",
        cost: { amount: null, currency: "ETH", usdEquivalent: 5.28 },
        from: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        to: {
          name: "Winni",
          src: "https://lh3.googleusercontent.com/pU66bK-Npo4gnSqGWrLnet6u93bAzaUgpYs4T11Xv5bitmtNQitKldhBjk0FDHNYwt9nlOS3yefCB0pNOdgqBqeKyfuo1-g3jsg8WQ=s100",
          address: "0xe832bcb13ede4c91d7fd1361fa73f14a63179b17",
        },
        date: "10/30/2021 10:55:55",
        transaction: "0xb94ca0430974923399e656ea26db5bfc895df302",
      },
      {
        type: "Sale",
        cost: { amount: 8.6, currency: "SOL", usdEquivalent: 1.98 },
        from: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        to: {
          name: "Eda",
          src: "https://lh3.googleusercontent.com/morG2Iz69vppkkU4M-f3awkdrK8EqDvZbw9oBF2iJFGyBld5xtHOwpRSk1wcwfvUu4OwoxxX5crKdj7FRFUiL7fUQ9hqyfDjrjpl=s100",
          address: "0xf05715eba3596f1b23bd6900e3d92409477a86a9",
        },
        date: "07/06/2021 23:23:23",
        transaction: "0x08322b34de0d47ffd14482ff166b26b7000cfd35",
      },
      {
        type: "Transfer",
        cost: { amount: 2.11, currency: "ETH", usdEquivalent: 3.49 },
        from: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        to: {
          name: "Kristofer",
          src: "https://lh3.googleusercontent.com/10FvWeiHnUJi3OeAkHsyQIk_Eb__3MXRHrXlv9T5_pgnlxzA-wP10OrQNXsWTmbtIEL83yKJDf1g4u0VD1JR2H31RejbS-dzPRcYhWw=s100",
          address: "0x217d412648e5b576d8214bc3b481e4c3221b8a9f",
        },
        date: "08/19/2021 20:20:20",
        transaction: "0x76a338cbbeaa13ce9bbd9067627512adcfafd5b4",
      },
      {
        type: "Bid",
        cost: { amount: 3.39, currency: "SOL", usdEquivalent: 8.62 },
        from: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        to: {
          name: "Raymund",
          src: "https://lh3.googleusercontent.com/6CS0frnjPEpvJ8hE3OG6_TbJFEC5YYThnZMdLTTmW-Z91lyYAJkPA7-ou2uE-b_J-cBUBeqWkI4HYKHEiu2PAyCT6wkYKzoeCyuy=s100",
          address: "0x019900365479f80a2463f93b116f15526d00b785",
        },
        date: "09/24/2021 17:12:12",
        transaction: "0xdfd8f6a0499c80badf43b279ee8672ff3015d542",
      },
    ],
    more: [{ id: 0 }, { id: 2 }, { id: 2 }, { id: 2 }],
  },
];
